"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2265],{

/***/ 786350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ ZeroCart; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function ZeroCart(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || 226.768,
        height: props.height || 184.32,
        viewBox: "0 0 226.768 184.32"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                    children: ".prefix__b{fill:#bfbfbf}.prefix__c{fill:#b1b1b1}.prefix__d{fill:#28384f}.prefix__e{fill:#fff}"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                transform: "translate(8679.17 -11063)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M-8470.978 11105.794h-85.675a5.952 5.952 0 110-11.9h12.574a15.445 15.445 0 0015.445-15.445 15.453 15.453 0 00-15.445-15.449H-8649.3a15.453 15.453 0 00-15.445 15.445 15.445 15.445 0 0015.445 15.446h44.439a5.952 5.952 0 110 11.9h-12.087a18.576 18.576 0 00-18.576 18.576 18.576 18.576 0 0018.576 18.576h78.258a5.946 5.946 0 01.231 11.889h-123.9a16.816 16.816 0 00-16.811 16.82 16.816 16.816 0 0016.816 16.809h36.691a5.952 5.952 0 01.88 11.831h-5.93a16.814 16.814 0 100 33.629h117.85a16.814 16.814 0 100-33.629h-10.244a5.952 5.952 0 01.88-11.831h36.59a16.809 16.809 0 0016.809-16.809 16.816 16.816 0 00-16.809-16.816h-5.05a5.946 5.946 0 01.231-11.889h19.478a18.576 18.576 0 0018.578-18.577 18.576 18.576 0 00-18.578-18.576zm-93.5 88.618a5.944 5.944 0 01-5.05 5.88h-8.794a5.952 5.952 0 01.88-11.831h7.012a5.952 5.952 0 015.95 5.951z",
                        fill: "#f4f4f4"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        className: "prefix__b",
                        width: 123.361,
                        height: 10.821,
                        rx: 5.411,
                        transform: "translate(-8627.467 11236.499)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        className: "prefix__b",
                        width: 23.929,
                        height: 10.821,
                        rx: 5.411,
                        transform: "translate(-8659.626 11236.499)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        className: "prefix__c",
                        d: "M-8493.009 11247.32h.39a5.411 5.411 0 01-5.411-5.411 5.411 5.411 0 015.411-5.411h-.39a5.4 5.4 0 015.4 5.411 5.4 5.4 0 01-5.4 5.411z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        transform: "translate(-8657.581 11112.776)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                className: "prefix__c",
                                d: "M142.779 88.601h-93.68l-10.91-74.1h118.268zm-89.1-5.288h84.7l11.72-63.488H44.314z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                className: "prefix__c",
                                d: "M44.963 36.323h104.605v2.886H44.963zM49.298 64.062h95.933v2.886H49.298z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                className: "prefix__c",
                                d: "M95.821 17.147h2.886v68.808h-2.886zM62.018 17.293l2.87-.298L72.036 85.8l-2.87.298zM121.178 85.778l8.458-68.843 2.866.352-8.458 68.843zM39.407 21.571L26.766 9.011h-16.72v-9h20.42l15.283 15.184z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                className: "prefix__c",
                                d: "M136.697 113.521H51.044a17.025 17.025 0 110-34.051h.354v9h-.346a8.029 8.029 0 100 16.051h85.646z"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                className: "prefix__d",
                                cx: 16.01,
                                cy: 16.01,
                                r: 16.01,
                                transform: "rotate(-80.8 133.624 -5.902)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                className: "prefix__e",
                                cx: 8.029,
                                cy: 8.029,
                                r: 8.029,
                                transform: "rotate(-89 126.043 -4.47)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                className: "prefix__d",
                                cx: 15.965,
                                cy: 15.965,
                                r: 15.965,
                                transform: "rotate(-80.73 90.744 43.839)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                className: "prefix__e",
                                cx: 8.029,
                                cy: 8.029,
                                r: 8.029,
                                transform: "rotate(-80.75 91.438 35.213)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                className: "prefix__c",
                                d: "M20.73 9.01H4.505a4.505 4.505 0 110-9.01h16.232a4.5 4.5 0 010 9z"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
}


/***/ }),

/***/ 411110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);
/* harmony import */ var _components_PaymentPromoCouponDetailModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64109);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(168615);
/* harmony import */ var _components_CardPaymentBox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67865);
/* harmony import */ var _components_Common_Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(672651);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(913886);
/* harmony import */ var _components_Common_Toast__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40804);
/* harmony import */ var src_components_CouponsAndVouchers_Common_PromosContainer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(169708);
/* harmony import */ var src_components_CouponsAndVouchers_Common_CartPromosContainer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(462856);
/* harmony import */ var src_containers_Cart__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(374390);
/**
 * This component renders the list of payment promotions
 */ 













var BankOffers = function(props) {
    var onVerifyCard = function onVerifyCard(cardData) {
        var dataToSend = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
            card_number: cardData.cNum
        }, state.cardCouponData);
        dispatchVerifyCoupon(dataToSend);
    };
    var ref;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(src_containers_Cart__WEBPACK_IMPORTED_MODULE_10__.CartContext), _showAuthModal = ref1.showAuthModal, showAuthModal = _showAuthModal === void 0 ? null : _showAuthModal;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        showPromoDetailsModal: false,
        promoDataToBeViewed: {},
        cardCouponData: {}
    }), state = ref2[0], setState = ref2[1];
    var isUserLoggedIn = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.userReducer.isLogin;
    });
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showCardVerifyModal = ref3[0], setShowCardVerifyModal = ref3[1];
    var isCartPage = props === null || props === void 0 ? void 0 : props.isCartPage;
    var getAmtToAvailTheOffer = function(minOrderValue, cartPayAmount) {
        return minOrderValue - cartPayAmount;
    };
    var onApplyCoupon = function(promoId) {
        var ref, ref1;
        if (!isUserLoggedIn) {
            showAuthModal === null || showAuthModal === void 0 ? void 0 : showAuthModal();
            return;
        }
        var coupon = props === null || props === void 0 ? void 0 : (ref = props.paymentOffersList) === null || ref === void 0 ? void 0 : ref.find(function(offer) {
            return (offer === null || offer === void 0 ? void 0 : offer.promo_id) === promoId;
        });
        if (getAmtToAvailTheOffer(coupon.min_order_price, (ref1 = props.cartData) === null || ref1 === void 0 ? void 0 : ref1.pay_amount) <= 0) {
            if (coupon.payment_method === _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .PAYMENT_TYPE_CONSTANTS.DEBIT_CARD */ .Mf.DEBIT_CARD || coupon.payment_method === _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .PAYMENT_TYPE_CONSTANTS.CREDIT_CARD */ .Mf.CREDIT_CARD || coupon.payment_method === _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .PAYMENT_TYPE_CONSTANTS.CARD */ .Mf.CARD) {
                setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, state), {
                    cardCouponData: coupon
                }));
                setShowCardVerifyModal(true);
            } else {
                dispatchVerifyCoupon(coupon);
            }
        }
    };
    var dispatchVerifyCoupon = function(couponData) {
        var ref;
        var dataToPost = {
            promo_code: couponData.promo_code,
            pay_amount: (ref = props.cartData) === null || ref === void 0 ? void 0 : ref.pay_amount,
            promo_id: couponData.promo_id,
            payment_method: couponData.payment_method
        };
        if (couponData.card_number) {
            dataToPost["card_number"] = couponData.card_number;
        }
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_13__/* .verifyPaymentOffer */ .hI)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, props === null || props === void 0 ? void 0 : props.cartData), {
            payment_offer: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, dataToPost)
        }), function(resp) {
            if (resp.status) {
                props === null || props === void 0 ? void 0 : props.setSuccessPopupState({
                    show: true,
                    appliedPromoCode: couponData.promo_code
                });
            } else {
                (0,_components_Common_Toast__WEBPACK_IMPORTED_MODULE_7__/* .toastNotifyError */ .Lu)(resp.message);
            }
        }));
    };
    var togglePromoDetailsModal = function(promoId) {
        var ref;
        var promoData = props === null || props === void 0 ? void 0 : (ref = props.paymentOffersList) === null || ref === void 0 ? void 0 : ref.find(function(offer) {
            return (offer === null || offer === void 0 ? void 0 : offer.promo_id) === promoId;
        });
        setState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, state), {
                showPromoDetailsModal: !state.showPromoDetailsModal,
                promoDataToBeViewed: promoData
            });
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "paymentPromotionMainContainer",
        children: [
            isCartPage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_CouponsAndVouchers_Common_CartPromosContainer__WEBPACK_IMPORTED_MODULE_9__/* .CartPromosContainer */ .e, {
                promos: props.showAllPromos ? props.paymentOffersList : props.paymentOffersList.slice(0, 3),
                onDetailClick: togglePromoDetailsModal,
                onApplyClick: onApplyCoupon,
                isStorePromos: false,
                cartPayAmount: props === null || props === void 0 ? void 0 : (ref = props.cartData) === null || ref === void 0 ? void 0 : ref.pay_amount
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_CouponsAndVouchers_Common_PromosContainer__WEBPACK_IMPORTED_MODULE_8__/* .PromosContainer */ .$, {
                promos: props.paymentOffersList,
                onPromoClick: togglePromoDetailsModal,
                customClasses: "tw-flex tw-flex-col md:tw-px-[24px] md:tw-py-[21px]",
                primaryTextClasses: "tw-text-[13px]/[18px] tw-font-medium md:tw-text-[16px]/[20px] md:tw-font-semibold",
                secondaryTextClasses: "tw-text-[12px]/[20px] tw-font-normal md:tw-text-[15px]/[20px]",
                isStorePromos: false
            }),
            state.showPromoDetailsModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PaymentPromoCouponDetailModal__WEBPACK_IMPORTED_MODULE_3__/* .PaymentPromoCouponDetailsModal */ .f, {
                onClose: togglePromoDetailsModal,
                promoData: state.promoDataToBeViewed
            }),
            showCardVerifyModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Common_Modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                visible: true,
                height: 200,
                animation: "slideUp",
                onClose: function() {
                    return setShowCardVerifyModal(false);
                },
                className: "bottom-modal cardVerifyModal",
                customMaskStyles: {
                    background: "#000000e6"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "close-icon flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "https://cdn.dotpe.in/longtail/themes/8073865/FW1lciDX.webp",
                            className: "img h2 ",
                            onClick: function() {
                                return setShowCardVerifyModal(false);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "f4 b mb3",
                        children: "Verify Card"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CardPaymentBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        isVerifyCard: true,
                        onVerifyCard: onVerifyCard
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BankOffers);


/***/ }),

/***/ 953149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(313508);
/* harmony import */ var _Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(192134);



var CartPromoStrip = function(param) {
    var _promoId = param.promoId, promoId = _promoId === void 0 ? null : _promoId, _primaryText = param.primaryText, primaryText = _primaryText === void 0 ? "" : _primaryText, _secondaryText = param.secondaryText, secondaryText = _secondaryText === void 0 ? "" : _secondaryText, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "#ffffff" : _bgColor, _showHoverEffect = param.showHoverEffect, showHoverEffect = _showHoverEffect === void 0 ? true : _showHoverEffect, _errorText = param.errorText, errorText = _errorText === void 0 ? "" : _errorText, _savingAmount = param.savingAmount, savingAmount = _savingAmount === void 0 ? 0 : _savingAmount, _onDetailClick = param.onDetailClick, onDetailClick = _onDetailClick === void 0 ? null : _onDetailClick, _onApplyOrRemoveClick = param.onApplyOrRemoveClick, onApplyOrRemoveClick = _onApplyOrRemoveClick === void 0 ? null : _onApplyOrRemoveClick, _isApplyButtonDisabled = param.isApplyButtonDisabled, isApplyButtonDisabled = _isApplyButtonDisabled === void 0 ? false : _isApplyButtonDisabled, _isOfferApplied = param.isOfferApplied, isOfferApplied = _isOfferApplied === void 0 ? false : _isOfferApplied, _primaryButtonText = param.primaryButtonText, primaryButtonText = _primaryButtonText === void 0 ? "" : _primaryButtonText, _primaryButtonClasses = param.primaryButtonClasses, primaryButtonClasses = _primaryButtonClasses === void 0 ? "" : _primaryButtonClasses, _secondaryButtonText = param.secondaryButtonText, secondaryButtonText = _secondaryButtonText === void 0 ? "" : _secondaryButtonText, _secondaryButtonClasses = param.secondaryButtonClasses, secondaryButtonClasses = _secondaryButtonClasses === void 0 ? "" : _secondaryButtonClasses;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Common__WEBPACK_IMPORTED_MODULE_2__/* .StripContainer */ .P6, {
        showHoverEffect: showHoverEffect,
        bgColor: bgColor,
        customClasses: "!tw-flex-row tw-justify-between tw-items-start tw-border-none ".concat(src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_1__/* .IS_DESKTOP */ .yn ? "tw-px-0" : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Common__WEBPACK_IMPORTED_MODULE_2__/* .StripIconInfoWrapper */ .To, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common__WEBPACK_IMPORTED_MODULE_2__/* .StripOfferIcon */ .YT, {
                        iconSize: src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_1__/* .IS_DESKTOP */ .yn ? 14 : 12,
                        customClasses: "tw-pt-[2px]"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-gap-[2px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "tw-m-0 tw-flex tw-gap-[8px] tw-text-[14px]/[20px] tw-font-medium",
                                children: [
                                    primaryText,
                                    " ",
                                    !!savingAmount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "tw-text-[12px]/[20px] tw-font-semibold tw-text-[#0D9738] md:tw-text-[14px]/[20px]",
                                        children: [
                                            isOfferApplied ? "Saved" : "Save",
                                            " ₹",
                                            savingAmount
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "tw-flex tw-flex-col tw-gap-[4px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "tw-m-0 tw-text-[12px]/[20px] tw-font-normal tw-text-[#646464]",
                                        children: secondaryText
                                    }),
                                    errorText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "tw-m-0 tw-text-[13px]/[20px] tw-text-[#F63D60]",
                                        children: errorText
                                    }) : null,
                                    !!onDetailClick && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common__WEBPACK_IMPORTED_MODULE_2__/* .StripCTA */ .iQ, {
                                        ctaTextOrIcon: secondaryButtonText || "Details",
                                        onClick: function() {
                                            return onDetailClick(promoId);
                                        },
                                        customClasses: "!tw-text-[13px]/[20px] !tw-ml-0 $ ".concat(secondaryButtonClasses)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common__WEBPACK_IMPORTED_MODULE_2__/* .StripCTA */ .iQ, {
                ctaTextOrIcon: primaryButtonText || "Apply",
                onClick: function() {
                    return isOfferApplied ? onApplyOrRemoveClick() : onApplyOrRemoveClick(promoId);
                },
                customClasses: "tw-pr-[17px] ".concat(primaryButtonClasses),
                isDisabled: !!errorText || isApplyButtonDisabled
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CartPromoStrip);


/***/ }),

/***/ 462856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ CartPromosContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _CartPromoStrip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(953149);


var CartPromosContainer = function(param) {
    var promos = param.promos, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _onDetailClick = param.onDetailClick, onDetailClick = _onDetailClick === void 0 ? null : _onDetailClick, _onApplyClick = param.onApplyClick, onApplyClick = _onApplyClick === void 0 ? null : _onApplyClick, _isStorePromos = param.isStorePromos, isStorePromos = _isStorePromos === void 0 ? true : _isStorePromos, _cartPayAmount = param.cartPayAmount, cartPayAmount = _cartPayAmount === void 0 ? null : _cartPayAmount;
    return !!(promos === null || promos === void 0 ? void 0 : promos.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-flex tw-flex-col tw-gap-[20px] tw-transition-all md:tw-gap-[16px]" + customClasses,
        children: isStorePromos ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: promos.map(function(param, index) {
                var id = param.id, code = param.code, description = param.description, error_text = param.error_text, discount = param.discount;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CartPromoStrip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    primaryText: code,
                    secondaryText: description,
                    promoId: id,
                    onDetailClick: onDetailClick,
                    onApplyOrRemoveClick: onApplyClick,
                    errorText: error_text,
                    savingAmount: discount
                }, index);
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: promos.map(function(param, index) {
                var promo_id = param.promo_id, promo_code = param.promo_code, offer_callout = param.offer_callout, description = param.description, min_order_price = param.min_order_price;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CartPromoStrip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    primaryText: promo_code || offer_callout,
                    secondaryText: description,
                    promoId: promo_id,
                    onApplyOrRemoveClick: onApplyClick,
                    onDetailClick: onDetailClick,
                    isApplyButtonDisabled: min_order_price > cartPayAmount
                }, index);
            })
        })
    });
};


/***/ }),

/***/ 201325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(192134);



var TabsContainer = function(param) {
    var activeTabIndex = param.activeTabIndex, setActiveTabIndex = param.setActiveTabIndex, tabsData = param.tabsData, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _tabClasses = param.tabClasses, tabClasses = _tabClasses === void 0 ? "" : _tabClasses;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-flex tw-px-[18px] tw-transition-all ".concat(customClasses),
        children: tabsData.map(function(param, index) {
            var text = param.text;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common__WEBPACK_IMPORTED_MODULE_2__/* .Tab */ .OK, {
                text: text,
                isActive: index === activeTabIndex,
                onClick: function() {
                    return setActiveTabIndex(index);
                },
                customClasses: tabClasses
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TabsContainer);


/***/ }),

/***/ 995350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ItemSchedulingInfo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
;// CONCATENATED MODULE: ./src/assets/svgExports/DateIcon.js

var DateIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_4_1343)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.66667 10H6.5C5.85658 10 5.33333 10.5232 5.33333 11.1667V12.3333C5.33333 12.9767 5.85658 13.5 6.5 13.5H7.66667C8.31008 13.5 8.83333 12.9767 8.83333 12.3333V11.1667C8.83333 10.5232 8.31008 10 7.66667 10ZM6.5 12.3333V11.1667H7.66667V12.3333H6.5ZM14.0833 4.16667H13.5V3.58333C13.5 3.26133 13.2392 3 12.9167 3C12.5941 3 12.3333 3.26133 12.3333 3.58333V4.16667H7.66667V3.58333C7.66667 3.26133 7.40592 3 7.08333 3C6.76075 3 6.5 3.26133 6.5 3.58333V4.16667H5.91667C4.30842 4.16667 3 5.47508 3 7.08333V14.0833C3 15.6916 4.30842 17 5.91667 17H14.0833C15.6916 17 17 15.6916 17 14.0833V7.08333C17 5.47508 15.6916 4.16667 14.0833 4.16667ZM5.91667 5.33333H14.0833C15.0482 5.33333 15.8333 6.1185 15.8333 7.08333V7.66667H4.16667V7.08333C4.16667 6.1185 4.95183 5.33333 5.91667 5.33333ZM14.0833 15.8333H5.91667C4.95183 15.8333 4.16667 15.0482 4.16667 14.0833V8.83333H15.8333V14.0833C15.8333 15.0482 15.0482 15.8333 14.0833 15.8333Z",
                    fill: "#4E4E4E"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4_1343",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white",
                        transform: "translate(3 3)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var svgExports_DateIcon = (DateIcon);

;// CONCATENATED MODULE: ./src/assets/svgExports/TimeIcon.js

var TimeIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.5591 13.3357L13.3357 12.5591L10.5526 9.776V6.31579H9.44737V10.2238L12.5591 13.3357ZM10.0013 17C9.03308 17 8.12302 16.8163 7.2711 16.4488C6.41919 16.0814 5.67818 15.5827 5.04805 14.9529C4.41793 14.323 3.91903 13.5823 3.55134 12.7307C3.18378 11.8792 3 10.9694 3 10.0013C3 9.03308 3.18372 8.12302 3.55116 7.2711C3.9186 6.41919 4.41725 5.67818 5.04713 5.04805C5.67701 4.41793 6.41772 3.91903 7.26926 3.55134C8.12081 3.18378 9.03062 3 9.99871 3C10.9669 3 11.877 3.18372 12.7289 3.55116C13.5808 3.9186 14.3218 4.41725 14.9519 5.04713C15.5821 5.67701 16.081 6.41772 16.4487 7.26926C16.8162 8.12081 17 9.03062 17 9.99871C17 10.9669 16.8163 11.877 16.4488 12.7289C16.0814 13.5808 15.5827 14.3218 14.9529 14.9519C14.323 15.5821 13.5823 16.081 12.7307 16.4487C11.8792 16.8162 10.9694 17 10.0013 17ZM10 15.8947C11.6333 15.8947 13.0241 15.3206 14.1724 14.1724C15.3206 13.0241 15.8947 11.6333 15.8947 10C15.8947 8.36667 15.3206 6.97588 14.1724 5.82763C13.0241 4.67939 11.6333 4.10526 10 4.10526C8.36667 4.10526 6.97588 4.67939 5.82763 5.82763C4.67939 6.97588 4.10526 8.36667 4.10526 10C4.10526 11.6333 4.67939 13.0241 5.82763 14.1724C6.97588 15.3206 8.36667 15.8947 10 15.8947Z",
            fill: "#4E4E4E"
        })
    });
};
/* harmony default export */ var svgExports_TimeIcon = (TimeIcon);

// EXTERNAL MODULE: ./src/components/ProductScheduler/utils.ts
var utils = __webpack_require__(897713);
;// CONCATENATED MODULE: ./src/components/ItemSchedulingInfo/index.tsx




var ItemSchedulingInfo = function(param) {
    var schedulingInfo = param.schedulingInfo, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _headingClasses = param.headingClasses, headingClasses = _headingClasses === void 0 ? "" : _headingClasses, _paraClasses = param.paraClasses, paraClasses = _paraClasses === void 0 ? "" : _paraClasses;
    var ref = schedulingInfo || {}, date = ref.date, time = ref.time;
    var infoList = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_DateIcon, {}),
            infoName: "Date",
            infoData: date || ""
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_TimeIcon, {}),
            infoName: "Slot time",
            infoData: (time === null || time === void 0 ? void 0 : time.from) && (time === null || time === void 0 ? void 0 : time.to) ? "".concat((0,utils/* convertTo12HourFormat */.YZ)(time === null || time === void 0 ? void 0 : time.from), " - ").concat((0,utils/* convertTo12HourFormat */.YZ)(time === null || time === void 0 ? void 0 : time.to)) : ""
        }, 
    ];
    return !!date && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-gap-[12px] tw-pb-[8px] tw-pt-[24px] ".concat(customClasses),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tw-flex tw-text-[14px]/[15px]  tw-font-normal ".concat(headingClasses),
                children: "Booking details"
            }),
            infoList.map(function(info, index) {
                return !!info.infoData && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-items-center tw-gap-[8px] tw-text-[12px]/[15px] tw-font-normal  tw-text-[#4E4E4E] ".concat(paraClasses),
                    children: [
                        info.icon,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "tw-flex tw-items-center tw-gap-[4px]",
                            children: [
                                info.infoName,
                                ":",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "tw-flex tw-items-center tw-font-normal tw-text-[#6B6B6B]",
                                    children: info.infoData
                                })
                            ]
                        })
                    ]
                }, index);
            })
        ]
    });
};
/* harmony default export */ var components_ItemSchedulingInfo = (ItemSchedulingInfo);


/***/ }),

/***/ 64109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ PaymentPromoCouponDetailsModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _Common_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(672651);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(186812);
/**
 * This component renders the list of payment promotions
 */ 



var PaymentPromoCouponDetailsModal = function(props) {
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        visible: true,
        height: "auto",
        animation: "slideUp",
        onClose: props.onClose,
        className: "bottom-modal paymentPromoDetailsModal",
        customMaskStyles: {
            background: "#000000e6"
        },
        customStyles: {
            maxWidth: "450px"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "pb4 vh-75 overflow-scroll",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "close-icon flex justify-center items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/FW1lciDX.webp",
                        className: "img h2 ",
                        onClick: props.onClose
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "f4 b mv3",
                    children: "Offer Details"
                }),
                ((ref = props.promoData) === null || ref === void 0 ? void 0 : ref.image_url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center logo-coupon-desc",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: props.promoData.image_url,
                            alt: "",
                            width: "60px",
                            height: "60px",
                            className: "mv3 mr3"
                        }),
                        ((ref1 = props.promoData) === null || ref1 === void 0 ? void 0 : ref1.description) && _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__/* .deviceWidth */ .o > 990 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "f6 b",
                            children: props.promoData.description
                        }) : null
                    ]
                }) : null,
                ((ref2 = props.promoData) === null || ref2 === void 0 ? void 0 : ref2.description) && _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__/* .deviceWidth */ .o < 990 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "f6 b",
                    children: props.promoData.description
                }) : null,
                props.promoData.promo_code ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "promoCodeBox fw4",
                    children: props.promoData.promo_code
                }) : null,
                props.promoData.notes.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "notesList",
                    children: props.promoData.notes.map(function(data, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "f4",
                            children: data
                        }, index);
                    })
                }) : null
            ]
        })
    });
};


/***/ }),

/***/ 925269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_UserAddressCard; }
});

// UNUSED EXPORTS: renderAddressTypeIcon

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/InfoOutlined.js
var InfoOutlined = __webpack_require__(136804);
// EXTERNAL MODULE: ./node_modules/lodash/capitalize.js
var capitalize = __webpack_require__(548403);
var capitalize_default = /*#__PURE__*/__webpack_require__.n(capitalize);
;// CONCATENATED MODULE: ./src/assets/svgExports/HomeDarkIcon.js

function HomeDarkIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "10",
        height: "11",
        viewBox: "0 0 10 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.73138 4.84952C9.73115 4.84929 9.73092 4.84906 9.73069 4.84883L5.65107 0.769775C5.47718 0.595825 5.24598 0.5 5.00006 0.5C4.75414 0.5 4.52295 0.595749 4.34898 0.769699L0.271492 4.84669C0.270118 4.84807 0.268745 4.84952 0.267372 4.85089C-0.0897206 5.21001 -0.0891102 5.79266 0.269126 6.15086C0.432794 6.31459 0.648956 6.40942 0.880074 6.41934C0.889459 6.42026 0.898921 6.42072 0.908459 6.42072H1.07106V9.42265C1.07106 10.0167 1.55443 10.5 2.14867 10.5H3.74475C3.90651 10.5 4.03774 10.3689 4.03774 10.207V7.85352C4.03774 7.58244 4.25826 7.36195 4.52936 7.36195H5.47077C5.74187 7.36195 5.96238 7.58244 5.96238 7.85352V10.207C5.96238 10.3689 6.09354 10.5 6.25538 10.5H7.85146C8.44569 10.5 8.92907 10.0167 8.92907 9.42265V6.42072H9.07984C9.32568 6.42072 9.55688 6.32497 9.73092 6.15102C10.0895 5.79221 10.0897 5.20856 9.73138 4.84952Z",
            fill: "black"
        })
    });
}

;// CONCATENATED MODULE: ./src/assets/svgExports/OtherDarkIcon.js

function OtherDarkIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "11",
        height: "11",
        viewBox: "0 0 11 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_10_4884)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5.125 0C6.21857 0.00145065 7.26694 0.436513 8.04021 1.20979C8.81349 1.98306 9.24855 3.03143 9.25 4.125C9.25 7.0864 5.40688 10.7955 5.24359 10.9519C5.21183 10.9827 5.16929 11 5.125 11C5.08071 11 5.03817 10.9827 5.00641 10.9519C4.84313 10.7955 1 7.0864 1 4.125C1.00145 3.03143 1.43651 1.98306 2.20979 1.20979C2.98306 0.436513 4.03143 0.00145065 5.125 0ZM5.125 6.01562C5.49893 6.01562 5.86446 5.90474 6.17537 5.69699C6.48629 5.48925 6.72861 5.19398 6.87171 4.84851C7.01481 4.50304 7.05225 4.1229 6.9793 3.75616C6.90635 3.38941 6.72628 3.05253 6.46187 2.78813C6.19747 2.52372 5.86059 2.34365 5.49384 2.2707C5.1271 2.19775 4.74696 2.23519 4.40149 2.37829C4.05602 2.52139 3.76075 2.76371 3.553 3.07462C3.34526 3.38554 3.23438 3.75107 3.23438 4.125C3.23468 4.62633 3.43396 5.10704 3.78846 5.46154C4.14295 5.81604 4.62367 6.01532 5.125 6.01562Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_10_4884",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "11",
                        height: "11",
                        fill: "white",
                        transform: "matrix(-1 0 0 1 11 0)"
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/assets/svgExports/WorkDarkIcon.js

function WorkDarkIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0.714286 2.5H2.85714V0.375C2.85714 0.168 3.01714 0 3.21429 0H6.78571C6.98286 0 7.14286 0.168 7.14286 0.375V2.5H9.28571C9.68 2.5 10 2.836 10 3.25V9.25C10 9.664 9.68 10 9.28571 10H0.714286C0.32 10 0 9.664 0 9.25V3.25C0 2.836 0.32 2.5 0.714286 2.5ZM3.57143 2.5H6.42857V0.75H3.57143V2.5Z",
            fill: "black"
        })
    });
}

// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(270758);
;// CONCATENATED MODULE: ./src/components/UserAddressCard/index.tsx







var renderAddressTypeIcon = function(type) {
    switch(type){
        case "home":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeDarkIcon, {});
        case "work":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkDarkIcon, {});
        case "others":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherDarkIcon, {});
    }
};
var UserAddressCard = function(param) {
    var _onEditClick = param.onEditClick, onEditClick = _onEditClick === void 0 ? null : _onEditClick, _onDeliverClick = param.onDeliverClick, onDeliverClick = _onDeliverClick === void 0 ? null : _onDeliverClick, _estimatedDeliveryTime = param.estimatedDeliveryTime, estimatedDeliveryTime = _estimatedDeliveryTime === void 0 ? null : _estimatedDeliveryTime, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _isSelected = param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected, _userName = param.userName, userName = _userName === void 0 ? "" : _userName, _addressType = param.addressType, addressType = _addressType === void 0 ? "home" : _addressType, _addressName = param.addressName, addressName = _addressName === void 0 ? "" : _addressName, _alternatePhone = param.alternatePhone, alternatePhone = _alternatePhone === void 0 ? "" : _alternatePhone, _address1 = param.address1, address1 = _address1 === void 0 ? "" : _address1, _address2 = param.address2, address2 = _address2 === void 0 ? "" : _address2, _city = param.city, city = _city === void 0 ? "" : _city, _state = param.state, state = _state === void 0 ? "" : _state, _pincode = param.pincode, pincode = _pincode === void 0 ? "" : _pincode, _isIncomplete = param.isIncomplete, isIncomplete = _isIncomplete === void 0 ? false : _isIncomplete, _isUnserviceable = param.isUnserviceable, isUnserviceable = _isUnserviceable === void 0 ? false : _isUnserviceable;
    var getTrimmedString = function getTrimmedString(str) {
        return str.length > 6 ? str.slice(0, 6) + "..." : str;
    };
    var buttonsData = [
        {
            text: isIncomplete ? "Add missing details" : onDeliverClick ? "Edit" : "Edit Address",
            onClick: onEditClick,
            show: !!onEditClick
        },
        {
            text: "Deliver Here",
            onClick: onDeliverClick,
            show: !isSelected && !!onDeliverClick
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw- tw-flex tw-flex-col tw-gap-[12px] tw-rounded-lg tw-border tw-border-solid tw-border-[#E2E2E2] tw-pt-[12px] md:tw-border-none md:tw-p-0 " + customClasses,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-gap-[4px] tw-px-[16px] md:tw-p-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-m-0 tw-text-sm",
                                children: userName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "tw-flex tw-items-center tw-gap-[4px] tw-text-xs",
                                children: [
                                    renderAddressTypeIcon(addressType),
                                    getTrimmedString(capitalize_default()(addressName || addressType))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-text-sm tw-text-[#7D7D7D]",
                        children: alternatePhone
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-text-sm tw-text-[#7D7D7D]",
                        children: [
                            address1,
                            address2,
                            city,
                            state,
                            pincode
                        ].filter(function(data) {
                            return !!data;
                        }).join(", ")
                    }),
                    isIncomplete && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "tw-m-0 tw-flex tw-items-center tw-text-sm tw-text-[#E2574C] ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {
                                fontSize: "small"
                            }),
                            " Incomplete address"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col-reverse tw-justify-between tw-gap-[12px] md:tw-flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-flex tw-divide-x tw-border-t tw-border-solid tw-border-[#E2E2E2] md:tw-flex-row-reverse md:tw-gap-[16px] md:tw-border-none",
                        children: buttonsData.map(function(data, index) {
                            return data.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-flex tw-flex-1 tw-cursor-pointer tw-justify-center tw-border-r tw-border-solid tw-border-[#E2E2E2] tw-px-[16px] tw-py-[12px] tw-text-sm tw-font-semibold last:tw-border-none md:tw-flex-none md:tw-border-none md:tw-p-0",
                                style: {
                                    color: (0,getThemeColor/* getThemeColor */.p)()
                                },
                                onClick: data.onClick,
                                children: data.text
                            }, index);
                        })
                    }),
                    !!estimatedDeliveryTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-px-[16px] tw-text-xs tw-italic md:tw-p-0",
                        children: estimatedDeliveryTime
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_UserAddressCard = (UserAddressCard);


/***/ }),

/***/ 374390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Cart; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/index.js + 2 modules
var AtomicComponents = __webpack_require__(438855);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(452388);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/containers/Cart/cart.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: ",
        ";\n  box-sizing: border-box;\n  margin: 0 auto;\n  @media screen and (max-width: 766px) {\n    & > .cart-update-notifier {\n      top: 66px;\n      position: relative;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  position: fixed;\n  top: 0;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  left: 0;\n  height: 66px;\n  z-index: 10;\n  background: #ffffff;\n  transition-property: box-shadow;\n  transition-duration: 0.2s;\n  transition-timing-function: linear;\n  border-bottom: 1px solid #e9e9e9;\n  @media screen and (max-width: 766px) {\n    padding: 10px 20px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-grow: 1;\n  overflow: hidden;\n  height: auto;\n  flex-direction: row;\n  justify-content: space-between;\n  @media screen and (max-width: 766px) {\n    overflow: scroll;\n    padding-top: 66px;\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 0 0 auto;\n  display: flex;\n  height: 24px;\n  width: 24px;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  align-items: center;\n  height: 100%;\n  padding-left: 10px;\n  position: relative;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  justify-content: space-between;\n  align-items: center;\n  transition-property: top;\n  transition-duration: 0.2s;\n  transition-timing-function: linear;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  margin: 0;\n  padding-right: 10px;\n  color: #000000;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-items: space-between;\n  flex: 1;\n  box-sizing: border-box;\n  justify-content: space-between;\n  padding-top: 30px;\n  padding-bottom: 20px;\n  position: relative;\n  @media screen and (max-width: 766px) {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n  color: #000000;\n  font-size: 28px;\n  font-weight: 500;\n  margin-right: 10px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  border-top: 1px solid rgba(112, 112, 112, 0.5);\n  border-bottom: 1px solid rgba(112, 112, 112, 0.5);\n  color: ",
        ";\n  cursor: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 10px;\n\n  @media screen and (min-width: 767px) {\n    display: none;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #606060;\n  font-size: 12px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: center;\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  border-top: 1px solid rgba(112, 112, 112, 0.2);\n  padding: 20px 32px;\n  background: #fafafa;\n  margin-top: auto;\n  ",
        ";\n  ",
        ";\n\n  @media screen and (max-width: 766px) {\n    background: white;\n    position: static;\n    border: none;\n    padding-top: 0px;\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 0px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  position: relative;\n  margin-right: 15px;\n  cursor: pointer;\n  & > svg {\n    top: 3px;\n    position: relative;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 0px 24px;\n  border-top: 1px solid #eaeaec;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: space-between;\n  min-width: 26.875vw;\n  ",
        ";\n  @media screen and (max-width: 767px) {\n    min-width: 88.875vw;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  display: flex;\n  color: #000000;\n  font-weight: ",
        ";\n  margin-left: ",
        "px;\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: auto;\n  width: 100%;\n  padding: 2rem 20px;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  max-width: 1000px;\n  margin: 0 auto;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  width: 90%;\n\n  @media screen and (min-width: 767px) {\n    font-size: 20px;\n    padding: 40px 0;\n    margin: 0 auto;\n  }\n\n  @media screen and (max-width: 766px) {\n    padding: 30px 0;\n    margin: 0 auto;\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  cursor: pointer;\n  width: 100%;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  height: fit-content;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin: 0 0 10px 0;\n  justify-content: space-between;\n  font-weight: 600;\n  color: gray;\n\n  @media screen and (min-width: 767px) {\n    font-size: 15px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  width: 14px;\n  height: 14px;\n  margin-left: 20px;\n  font-size: 12px;\n  cursor: pointer;\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  width: auto;\n  height: auto;\n  font-weight: 600;\n  padding: 3px 5px;\n  background-color: transparent;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin: 0;\n  color: #000;\n  font-size: 15px;\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  position: relative;\n  height: 12px;\n  width: 12px;\n  margin-left: 7px;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background-color: #343638;\n  box-shadow: 3px 5px 12px 1px #0000002f;\n  z-index: 999;\n  width: fit-content;\n  padding: 8px;\n  border-radius: 8px;\n  font-size: 12px;\n  color: #ebebeb;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  overflow: scroll;\n  width: 35%;\n  background: #fafafa;\n  min-width: 560px;\n  @media screen and (max-width: 767px) {\n    overflow: visible;\n    min-width: 100%;\n  }\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  background: ",
        ";\n  display: flex;\n  justify-content: space-between;\n  border-bottom: ",
        ";\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 32px 30px 0px;\n  background: #fafafa;\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n\n  /* Hide scrollbar for IE, Edge and Firefox */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  @media screen and (max-width: 767px) {\n    overflow: visible;\n    height: auto;\n    padding: 0 16px;\n    background: ",
        "\n      ",
        ";\n  }\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-right: 16px;\n  ",
        "\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: ",
        ";\n  margin-top: 2px;\n  @media screen and (max-width: 767px) {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-left: 8px;\n  margin-top: 6px;\n  cursor: pointer;\n  ",
        ";\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-right: 10px;\n  margin-top: 4px;\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: 8px;\n  color: black;\n  opacity: 0.49;\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-left: 6px;\n  font-size: 14px;\n  color: #797a7c;\n  font-weight: 400;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n    align-items: center;\n  }\n"
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}




var OuterPadding = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "OuterPadding",
    componentId: "sc-e77092e2-0"
})(_templateObject());
var CartPage = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "CartPage",
    componentId: "sc-e77092e2-1"
})(_templateObject1(), function(props) {
    return props.height || "100vh";
});
var CartHeader = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "CartHeader",
    componentId: "sc-e77092e2-2"
})(_templateObject2());
var CartBody = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "CartBody",
    componentId: "sc-e77092e2-3"
})(_templateObject3());
var CartHeaderBack = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "CartHeaderBack",
    componentId: "sc-e77092e2-4"
})(_templateObject4());
var CartHeaderData = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "CartHeaderData",
    componentId: "sc-e77092e2-5"
})(_templateObject5());
var CardHeaderInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CardHeaderInner",
    componentId: "sc-e77092e2-6"
})(_templateObject6());
var CartHeaderText = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "CartHeaderText",
    componentId: "sc-e77092e2-7"
})(_templateObject7());
var CartInfo = (0,styled_components_browser_esm/* default */.ZP)(OuterPadding).withConfig({
    displayName: "CartInfo",
    componentId: "sc-e77092e2-8"
})(_templateObject8());
var CartOption = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "CartOption",
    componentId: "sc-e77092e2-9"
})(_templateObject9());
var Text = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "Text",
    componentId: "sc-e77092e2-10"
})(_templateObject10());
var MidContent = (0,styled_components_browser_esm/* default */.ZP)(OuterPadding).withConfig({
    displayName: "MidContent",
    componentId: "sc-e77092e2-11"
})(_templateObject11(), function(props) {
    return props.fontColor || "#6E03FF";
}, function(props) {
    return props.cursor ? props.cursor : "default";
});
var ItemContainer = (0,styled_components_browser_esm/* default */.ZP)(OuterPadding).withConfig({
    displayName: "ItemContainer",
    componentId: "sc-e77092e2-12"
})(_templateObject12());
var ItemPrecursor = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemPrecursor",
    componentId: "sc-e77092e2-13"
})(_templateObject13());
var ItemPrecursorText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "ItemPrecursorText",
    componentId: "sc-e77092e2-14"
})(_templateObject14());
var ItemList = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "ItemList",
    componentId: "sc-e77092e2-15"
})(_templateObject15());
var BottomContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "BottomContainer",
    componentId: "sc-e77092e2-16"
})(_templateObject16(), function(props) {
    return props.showScrollDownShadow && "box-shadow: rgb(0 0 0 / 20%) 0px -2px 10px -5px";
}, function(props) {
    return props.storeUnserviceable && "min-height: 15vh";
});
var CTAbutton = (0,styled_components_browser_esm/* default */.ZP)(AtomicComponents/* Button */.zx).withConfig({
    displayName: "CTAbutton",
    componentId: "sc-e77092e2-17"
})(_templateObject17());
var IconContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "IconContainer",
    componentId: "sc-e77092e2-18"
})(_templateObject18());
var AmountContainer = (0,styled_components_browser_esm/* default */.ZP)(OuterPadding).withConfig({
    displayName: "AmountContainer",
    componentId: "sc-e77092e2-19"
})(_templateObject19());
var AmountRow = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "AmountRow",
    componentId: "sc-e77092e2-20"
})(_templateObject20(), function(props) {
    return props.marginRight && "margin-right : ".concat(props.marginRight, "vw");
});
var TotalText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "TotalText",
    componentId: "sc-e77092e2-21"
})(_templateObject21(), function(props) {
    return props.fontWeight;
}, function(props) {
    return props.marginRight || 0;
});
var NoItemInCart = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "NoItemInCart",
    componentId: "sc-e77092e2-22"
})(_templateObject22());
var NoItemInCartSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NoItemInCartSection",
    componentId: "sc-e77092e2-23"
})(_templateObject23());
var NoItemInCartText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "NoItemInCartText",
    componentId: "sc-e77092e2-24"
})(_templateObject24());
var MidContentInner = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "MidContentInner",
    componentId: "sc-e77092e2-25"
})(_templateObject25());
var OrderInstructionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionContainer",
    componentId: "sc-e77092e2-26"
})(_templateObject26());
var OrderInstructionTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "OrderInstructionTitle",
    componentId: "sc-e77092e2-27"
})(_templateObject27());
var OrderInstructionEdit = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "OrderInstructionEdit",
    componentId: "sc-e77092e2-28"
})(_templateObject28(), function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return props.color;
}, function(props) {
    return props.color;
});
var OrderInstructionDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "OrderInstructionDescription",
    componentId: "sc-e77092e2-29"
})(_templateObject29());
var SVGBox = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "SVGBox",
    componentId: "sc-e77092e2-30"
})(_templateObject30());
var CartDeliveryTooltip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CartDeliveryTooltip",
    componentId: "sc-e77092e2-31"
})(_templateObject31());
var CartBodyRightSection = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "CartBodyRightSection",
    componentId: "sc-e77092e2-32"
})(_templateObject32());
var ItemHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemHeading",
    componentId: "sc-e77092e2-33"
})(_templateObject33(), function(props) {
    return props.showDropdown ? "28px 0px" : "24px 0px";
}, function(props) {
    return props.showDropdown ? "#fafafa" : "white";
}, function(props) {
    return !props.showSummery ? "1px solid #eaeaec" : "none";
});
var GrandTotal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GrandTotal",
    componentId: "sc-e77092e2-34"
})(_templateObject34());
var GrandTotalText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GrandTotalText",
    componentId: "sc-e77092e2-35"
})(_templateObject35());
var GrandTotalValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GrandTotalValue",
    componentId: "sc-e77092e2-36"
})(_templateObject36());
var ItemAmountContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemAmountContainer",
    componentId: "sc-e77092e2-37"
})(_templateObject37(), function(props) {
    return !props.showDropdown ? "white" : "#fafafa";
}, function(props) {
    return !props.showOrderSummary && "background : white ; visibility : hidden ; height : 50vh ; overflow: hidden;";
});
var OrderSummary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderSummary",
    componentId: "sc-e77092e2-38"
})(_templateObject38());
var DropDownArrowSummary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DropDownArrowSummary",
    componentId: "sc-e77092e2-39"
})(_templateObject39(), function(props) {
    return props.showOrderSummary ? "transform : rotateZ(180deg);" : "transform: rotateZ(360deg);";
});
var OrderSummaryText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderSummaryText",
    componentId: "sc-e77092e2-40"
})(_templateObject40(), deviceWidth/* deviceWidth */.o < 767 ? "16px" : "0px");
var DropDownArrowContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DropDownArrowContainer",
    componentId: "sc-e77092e2-41"
})(_templateObject41(), function(props) {
    return props.showDeliveryChargeList && "transform : rotate(180deg); margin-bottom : 4px";
});
var DeliveryChargeDropDownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DeliveryChargeDropDownContainer",
    componentId: "sc-e77092e2-42"
})(_templateObject42());
var MobileGrandTotal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobileGrandTotal",
    componentId: "sc-e77092e2-43"
})(_templateObject43());
var TotalDropDownArrowContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TotalDropDownArrowContainer",
    componentId: "sc-e77092e2-44"
})(_templateObject44());
var TotalItemsInCart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TotalItemsInCart",
    componentId: "sc-e77092e2-45"
})(_templateObject45());
var GstExcludesContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "GstExcludesContainer",
    componentId: "sc-e77092e2-46"
})(_templateObject46());
var GstIncludesContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "GstIncludesContainer",
    componentId: "sc-e77092e2-47"
})(_templateObject47());

// EXTERNAL MODULE: ./src/redux/actions/auth.js
var auth = __webpack_require__(368060);
// EXTERNAL MODULE: ./src/redux/actions/user.js
var user = __webpack_require__(656173);
// EXTERNAL MODULE: ./src/redux/actions/order.js
var order = __webpack_require__(804160);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var actions_cart = __webpack_require__(666162);
// EXTERNAL MODULE: ./src/redux/actions/error.js
var error = __webpack_require__(812256);
// EXTERNAL MODULE: ./src/utils/getAuthToken.js
var getAuthToken = __webpack_require__(861305);
// EXTERNAL MODULE: ./src/utils/addDeliveryInfoInCart.js
var addDeliveryInfoInCart = __webpack_require__(668068);
// EXTERNAL MODULE: ./src/utils/isDeliveryPincodeBased.js
var isDeliveryPincodeBased = __webpack_require__(984110);
// EXTERNAL MODULE: ./src/utils/getStringifyAddress.js
var getStringifyAddress = __webpack_require__(97978);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(672651);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(270758);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartValidationErrorMsgModal/index.js
/**
 * Cart Validation
 * Error message Component
 */ 






var CartValidationErrorMsgModal = function() {
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return {
            theme: (ref = state.storeReducer.store) === null || ref === void 0 ? void 0 : ref.theme,
            store_info: state.storeReducer.store.store_info,
            cartValidationErrorMsgModal: state.errorReducer.cart.cartValidationErrorMsgModal,
            cartValidationData: state.errorReducer.cart.cartValidationData
        };
    }), theme = ref1.theme, cartValidationErrorMsgModal = ref1.cartValidationErrorMsgModal, cartValidationData = ref1.cartValidationData;
    (0,react.useEffect)(function() {
        if (cartValidationErrorMsgModal) {
            document.getElementsByTagName("body")[0].style.overflowY = "hidden";
        } else {
            document.getElementsByTagName("body")[0].style.overflowY = "scroll";
        }
    }, [
        cartValidationErrorMsgModal
    ]);
    var onClose = function() {
        dispatch((0,error/* setCartValidationErrorMsgModalVisibility */.sn)(false));
        dispatch((0,error/* saveCartValidationData */.as)(null));
    };
    return cartValidationErrorMsgModal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        visible: cartValidationErrorMsgModal,
        className: "bottom-modal cartValidationErrorMsgModal",
        animation: "slideUp",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "closeicon",
                onClick: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    loading: "lazy",
                    src: "https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp",
                    alt: "cancel"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "f4 fw6 pv3",
                children: "Note"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "pt2 pb5 overflow-y-scroll h5",
                children: cartValidationData === null || cartValidationData === void 0 ? void 0 : (ref = cartValidationData.message_list) === null || ref === void 0 ? void 0 : ref.map(function(el, ind) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: "flex pb3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center items-start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/7UkwS1DR.webp",
                                    className: "info-icon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "f6 fw4 ph2 w-90",
                                children: el
                            })
                        ]
                    }, "list-error-cartvalidation-".concat(ind));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "f4 fw6 pa3 absolute bottom-0 left-0 w-100 bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "f5 fw6 pv3 w-100 br-pill bn white",
                    style: {
                        backgroundColor: themeColor || "#EA5151",
                        borderRadius: theme ? "".concat((0,util/* roundnessCalculator */.M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px"
                    },
                    onClick: onClose,
                    children: "View Cart"
                })
            })
        ]
    });
};
/* harmony default export */ var Components_CartValidationErrorMsgModal = (CartValidationErrorMsgModal);

// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(299375);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/NotAcceptingOrderPopUp/index.js
/**
 * Not accepting orders because
 * store is closed for now information component
 */ 








var NotAcceptingOrdersPopUp = function() {
    var router = (0,next_router.useRouter)();
    var primaryColor = (0,getThemeColor/* getThemeColor */.p)() || "#EA5151";
    var storePhone = (0,useStoreContactDetails/* default */.Z)().storePhone;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return {
            theme: state.storeReducer.store.theme,
            store_info: state.storeReducer.store.store_info,
            notAcceptingOrdersPopUp: state.errorReducer.common.notAcceptingOrdersPopUp
        };
    }), theme = ref.theme, store_info = ref.store_info, notAcceptingOrdersPopUp = ref.notAcceptingOrdersPopUp;
    (0,react.useEffect)(function() {
        if (notAcceptingOrdersPopUp) {
            document.getElementsByTagName("body")[0].style.overflowY = "hidden";
        } else {
            document.getElementsByTagName("body")[0].style.overflowY = "scroll";
        }
    }, [
        notAcceptingOrdersPopUp
    ]);
    var onClickExploreBtn = function(e) {
        onClose();
        router.push((0,routes.getRoute)(routes.PATH.PRODUCT, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
    };
    var onClickCallUsBtn = function(e) {
        onClose();
        window.open("tel:".concat(storePhone), "_self");
        router.push((0,routes.getRoute)(routes.PATH.PRODUCT, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
    };
    var onClose = function() {
        dispatch((0,error/* setNotAcceptingOrdersModalVisibility */.$G)(false));
    };
    return notAcceptingOrdersPopUp && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center items-center fixed left-0 bottom-0 top-0 right-0 w-100 bg-black-50 z-999",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "pa3 bg-white br3 z1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "ph2",
                    children: "Note"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "f7 ph2",
                    children: "We are not accepting online orders right now"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "f7 ph2",
                    children: "You can explore our store or call us for any queries."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex pt4 ph2",
                    children: [
                        !!storePhone && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            style: {
                                borderColor: primaryColor,
                                color: primaryColor,
                                borderRadius: theme ? "".concat((0,util/* roundnessCalculator */.M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px"
                            },
                            className: "ba pv3 bg-white flex-auto mr3",
                            onClick: onClickCallUsBtn,
                            children: "Call Us"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            style: {
                                backgroundColor: primaryColor,
                                borderRadius: theme ? "".concat((0,util/* roundnessCalculator */.M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px"
                            },
                            className: "white bn pv3 flex-auto",
                            onClick: onClickExploreBtn,
                            children: "Explore"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var NotAcceptingOrderPopUp = (NotAcceptingOrdersPopUp);

// EXTERNAL MODULE: ./src/components/PaymentModal/index.js + 1 modules
var PaymentModal = __webpack_require__(716307);
// EXTERNAL MODULE: ./src/components/DesktopPaymentModal/index.js + 3 modules
var DesktopPaymentModal = __webpack_require__(757909);
// EXTERNAL MODULE: ./src/components/DesignSystem/AuthPopUp/index.js + 4 modules
var AuthPopUp = __webpack_require__(493973);
// EXTERNAL MODULE: ./src/components/DesignSystem/OrderConfirmLoader/index.js
var OrderConfirmLoader = __webpack_require__(938173);
// EXTERNAL MODULE: ./src/utils/customHooks.js
var customHooks = __webpack_require__(930077);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/utils/localStorageFunctions.js
var localStorageFunctions = __webpack_require__(174943);
// EXTERNAL MODULE: ./src/assets/svgExports/InfoIcon.js
var InfoIcon = __webpack_require__(467313);
;// CONCATENATED MODULE: ./src/components/CartError/CartError.styles.js

function CartError_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  ",
        "px;\n  ",
        "px;\n  ",
        "px;\n  ",
        "px;\n  ",
        ";\n\n  @media screen and (max-width: 767px) {\n    ",
        ";\n    margin-top: 0px;\n    margin-bottom: 12px;\n  }\n"
    ]);
    CartError_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartError_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  ",
        "px;\n  ",
        "px;\n  ",
        "px;\n  ",
        "px;\n  @media screen and (max-width: 767px) {\n    ",
        ";\n  }\n"
    ]);
    CartError_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CartError_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  color: #fc3d3d;\n  font-size: ",
        "px;\n  @media screen and (max-width: 767px) {\n    ",
        ";\n  }\n"
    ]);
    CartError_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var CartErrorContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CartErrorContainer",
    componentId: "sc-c612a4e3-0"
})(CartError_styles_templateObject(), function(props) {
    return props.customStyles.mb && "margin-bottom: ".concat(props.customStyles.mb);
}, function(props) {
    return props.customStyles.mt && "margin-top: ".concat(props.customStyles.mt);
}, function(props) {
    return props.customStyles.mr && "margin-right: ".concat(props.customStyles.mr);
}, function(props) {
    return props.customStyles.ml && "margin-left: ".concat(props.customStyles.ml);
}, function(props) {
    return props.customStyles.width && "max-width: ".concat(props.customStyles.width);
}, function(props) {
    return props.customStyles.mobileMb && "margin-bottom : ".concat(props.customStyles.mobileMb);
});
var CartError_styles_IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "IconContainer",
    componentId: "sc-c612a4e3-1"
})(CartError_styles_templateObject1(), function(props) {
    return props.customStyles.mbi && "margin-bottom: ".concat(props.customStyles.mbi);
}, function(props) {
    return props.customStyles.mti && "margin-top: ".concat(props.customStyles.mti);
}, function(props) {
    return props.customStyles.mri && "margin-right: ".concat(props.customStyles.mri);
}, function(props) {
    return props.customStyles.mli && "margin-left: ".concat(props.customStyles.mli);
}, function(props) {
    return props.customStyles.transXi && "transform : translateX(".concat(props.customStyles.transXi, ")");
});
var ErrorText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ErrorText",
    componentId: "sc-c612a4e3-2"
})(CartError_styles_templateObject2(), function(props) {
    return props.fontSize || 14;
}, function(props) {
    return props.transX && "transform : translateX(".concat(props.transX, ")");
});

;// CONCATENATED MODULE: ./src/components/CartError/CartError.js



function CartError(props) {
    var cartErrorContainerStyles = {
        mb: props.mb ? props.mb : 0,
        mt: props.mt ? props.mt : 0,
        ml: props.ml ? props.ml : 0,
        mr: props.mr ? props.mr : 0,
        mobileMb: props.mobileMb ? props.mobileMb : "0px",
        width: props.width ? props.width : "auto"
    };
    var iconContainerStyles = {
        mbi: props.mbi ? props.mbi : 0,
        mti: props.mti ? props.mti : 0,
        mli: props.mli ? props.mli : 0,
        mri: props.mri ? props.mri : 0,
        transXi: props.transXi ? props.transXi : "0px"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartErrorContainer, {
        customStyles: cartErrorContainerStyles,
        className: (props === null || props === void 0 ? void 0 : props.customClasses) || "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartError_styles_IconContainer, {
                customStyles: iconContainerStyles,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon/* InfoIcon */.s, {
                    secondaryColor: "#FC3D3D",
                    height: props.iconHeight,
                    width: props.iconWidth
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
                fontSize: props.fontSize,
                transX: props.transX,
                children: props.text
            })
        ]
    });
}
/* harmony default export */ var CartError_CartError = (CartError);

// EXTERNAL MODULE: ./src/containers/AddDelivery/index.js + 13 modules
var AddDelivery = __webpack_require__(374640);
// EXTERNAL MODULE: ./src/containers/DeliveryList/index.js + 3 modules
var DeliveryList = __webpack_require__(630876);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
// EXTERNAL MODULE: ./src/redux/actions/delivery.js
var delivery = __webpack_require__(679977);
;// CONCATENATED MODULE: ./src/assets/svgExports/ShippingTruck.js

var ShippingTruck = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "18.938",
        height: props.height || "13.752",
        viewBox: "0 0 18.938 13.752",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "local_shipping_FILL0_wght400_GRAD0_opsz48",
            d: "M5.96,21.752A2.535,2.535,0,0,1,3.42,19.212H2V9.291a1.239,1.239,0,0,1,.387-.9A1.239,1.239,0,0,1,3.291,8h12.46v3.594h2.26l2.927,3.9v3.723H19.41a2.541,2.541,0,0,1-4.336,1.8,2.448,2.448,0,0,1-.742-1.8H8.5A2.535,2.535,0,0,1,5.96,21.752Zm0-1.291a1.248,1.248,0,1,0-.882-2.131A1.248,1.248,0,0,0,5.96,20.46ZM3.291,17.921h.473A2.851,2.851,0,0,1,4.69,17a2.422,2.422,0,0,1,2.507.011,3,3,0,0,1,.936.915H14.46V9.291H3.291ZM16.871,20.46a1.249,1.249,0,1,0-.882-.366A1.2,1.2,0,0,0,16.871,20.46Zm-1.119-4.39h4l-2.389-3.185H15.752ZM8.887,13.832Z",
            transform: "translate(-2 -8)"
        })
    });
};

// EXTERNAL MODULE: ./src/utils/triggerGetItemDeliveryChages.js + 1 modules
var triggerGetItemDeliveryChages = __webpack_require__(508527);
// EXTERNAL MODULE: ./src/utils/triggerGetServiceableAddressId.js + 2 modules
var triggerGetServiceableAddressId = __webpack_require__(467058);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/Components/CheckoutInfoTab.styles.js

function CheckoutInfoTab_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  min-height: ",
        "px;\n  border: ",
        ";\n  border-radius: ",
        ";\n  margin-top: ",
        ";\n  justify-content: space-between;\n  ",
        ";\n  @media screen and (max-width: 767px) {\n    width: 100vw;\n    border: 0px;\n    border-radius: 0px;\n    margin-top: 0px;\n    min-height: ",
        "px;\n    border-top: 1px solid #e8e8eb;\n  }\n"
    ]);
    CheckoutInfoTab_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CheckoutInfoTab_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    CheckoutInfoTab_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CheckoutInfoTab_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  margin-left: 8px;\n  font-size: ",
        "px;\n  flex-direction: column;\n  justify-content: center;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n    margin-left: 16px;\n    ",
        ";\n  }\n"
    ]);
    CheckoutInfoTab_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CheckoutInfoTab_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-right: 16px;\n  cursor: pointer;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n  }\n"
    ]);
    CheckoutInfoTab_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CheckoutInfoTab_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-left: 20px;\n  margin-bottom: ",
        "px;\n"
    ]);
    CheckoutInfoTab_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var CheckoutInfoTabContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckoutInfoTabContainer",
    componentId: "sc-cb63d9de-0"
})(CheckoutInfoTab_styles_templateObject(), function(props) {
    return props.isPromoApplied ? "88" : "64";
}, function(props) {
    return props.instructionPopup ? "none" : "1px solid #e8e8eb";
}, function(props) {
    return props.instructionPopup ? "0px" : "8px";
}, function(props) {
    return props.instructionPopup ? "0px" : "16px";
}, function(props) {
    return props.toggleAddDeliveryForm && "border-bottom-right-radius : 0px;\n  border-bottom-left-radius : 0px";
}, function(props) {
    return props.isPromoApplied ? "76" : "52";
});
var CheckoutInfoTabLeftContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckoutInfoTabLeftContainer",
    componentId: "sc-cb63d9de-1"
})(CheckoutInfoTab_styles_templateObject1());
var CheckoutInfoTabMiddleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckoutInfoTabMiddleContainer",
    componentId: "sc-cb63d9de-2"
})(CheckoutInfoTab_styles_templateObject2(), function(props) {
    return props.fontSize || "14";
}, function(props) {
    return props.cartError && "margin-top : 20px";
});
var CheckoutInfoTabRightContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckoutInfoTabRightContainer",
    componentId: "sc-cb63d9de-3"
})(CheckoutInfoTab_styles_templateObject3());
var CheckoutInfoTabLeftIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckoutInfoTabLeftIcon",
    componentId: "sc-cb63d9de-4"
})(CheckoutInfoTab_styles_templateObject4(), function(props) {
    return props.isPromoApplied ? "10" : "0";
});

// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/Components/TabAddress/TabAddress.styles.js

function TabAddress_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #e8e8eb;\n  border-radius: 8px;\n  @media screen and (max-width: 767px) {\n    border: none;\n    border-top: ",
        ";\n    border-radius: 0px;\n    margin-top: 0px;\n  }\n"
    ]);
    TabAddress_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TabAddress_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 600;\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    TabAddress_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TabAddress_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  border-radius: ",
        ";\n  margin-top: ",
        ";\n  justify-content: space-between;\n  min-height: 64px;\n  @media screen and (max-width: 767px) {\n    width: 100vw;\n    border-left: none;\n    border-right: none;\n    border-bottom: none;\n    border-radius: 0px;\n    margin-top: 0px;\n  }\n"
    ]);
    TabAddress_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TabAddress_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-left: 20px;\n"
    ]);
    TabAddress_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TabAddress_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  ",
        ";\n"
    ]);
    TabAddress_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function TabAddress_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  color: #7f7f7f;\n  font-size: 14px;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n  }\n"
    ]);
    TabAddress_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function TabAddress_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 700;\n  font-size: 14px;\n  margin-left: 6px;\n  flex-direction: column;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n    margin-top: 8px;\n    margin-left: 0px;\n  }\n"
    ]);
    TabAddress_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function TabAddress_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  @media screen and (max-width: 767px) {\n    flex-direction: column;\n  }\n"
    ]);
    TabAddress_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var AddressFormContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AddressFormContainer",
    componentId: "sc-5d327f6e-0"
})(TabAddress_styles_templateObject(), function(props) {
    return props.showBorderTop ? "1px solid #e8e8eb" : "none";
});
var AddressCtaText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AddressCtaText",
    componentId: "sc-5d327f6e-1"
})(TabAddress_styles_templateObject1(), function(props) {
    return props.color || "#000000";
});
var AddressTabContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AddressTabContainer",
    componentId: "sc-5d327f6e-2"
})(TabAddress_styles_templateObject2(), function(props) {
    return props.instructionPopup ? "0px" : "8px";
}, function(props) {
    return props.instructionPopup || checkClientDeviceType/* IS_DESKTOP */.yn ? "0px" : "16px";
});
var AddressTabLeftIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AddressTabLeftIcon",
    componentId: "sc-5d327f6e-3"
})(TabAddress_styles_templateObject3());
var AddressLineContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AddressLineContainer",
    componentId: "sc-5d327f6e-4"
})(TabAddress_styles_templateObject4(), function(props) {
    return !props.toggleAddDeliveryForm && "padding-top : 20px ; padding-bottom : 20px";
});
var AddressLineOneContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AddressLineOneContainer",
    componentId: "sc-5d327f6e-5"
})(TabAddress_styles_templateObject5());
var AddressLineTwoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AddressLineTwoContainer",
    componentId: "sc-5d327f6e-6"
})(TabAddress_styles_templateObject6());
var AddressMainLineContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "AddressMainLineContainer",
    componentId: "sc-5d327f6e-7"
})(TabAddress_styles_templateObject7());

// EXTERNAL MODULE: ./src/components/UserAddressCard/index.tsx + 3 modules
var UserAddressCard = __webpack_require__(925269);
// EXTERNAL MODULE: ./src/context/CartContext.ts
var CartContext = __webpack_require__(852271);
// EXTERNAL MODULE: ./src/components/CheckItemDelivery/constants.js
var CheckItemDelivery_constants = __webpack_require__(729465);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/Components/TabAddress/TabAddress.js



















function CheckoutInfoTabAddress(props) {
    var toggleShowDeliveryList = function toggleShowDeliveryList() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setShowDeliveryList(!showDeliveryList);
    };
    var handleEditId = function handleEditId(edit_id) {
        setEditId(edit_id);
    };
    var renderSelectedAddress = function renderSelectedAddress() {
        var addressDetails = (0,getStringifyAddress/* getStringifyAddress */.H)();
        return !newUser && !toggleAddDeliveryForm && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-px-[16px] tw-pb-[24px] md:tw-border-t md:tw-border-solid md:tw-border-[#EAEAEC] md:tw-pl-[46px] md:tw-pr-[32px] md:tw-pt-[24px] ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAddressCard/* default */.Z, {
                onEditClick: function() {
                    handleAddDeliveryForm(true);
                    setEditId((addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.address_id) || 0);
                },
                estimatedDeliveryTime: estimatedDeliveryTime.deliveryTime || "",
                userName: addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.user_name,
                addressType: (addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.address_type) || (addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.addressType),
                addressName: (addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.address_name) || (addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.addressName),
                alternatePhone: addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.alternate_phone,
                address1: addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.address1,
                address2: addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.address2,
                city: addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.city,
                state: addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.state,
                pincode: addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.pincode
            })
        });
    };
    var handleAddDeliveryForm = function handleAddDeliveryForm(flag) {
        dispatch((0,common/* setAddDeliveryForm */.r_)(flag));
    };
    var handleAddressCta = function handleAddressCta() {
        if (userData === null || userData === void 0 ? void 0 : userData.isLogin) {
            newUser ? dispatch((0,common/* setAddDeliveryForm */.r_)(true)) : toggleShowDeliveryList();
        } else {
            showAuthModal === null || showAuthModal === void 0 ? void 0 : showAuthModal();
        }
    };
    var renderAddressCta = function renderAddressCta() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressCtaText, {
            toggleAddDeliveryForm: toggleAddDeliveryForm,
            color: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color,
            children: [
                !newUser && (checkClientDeviceType/* IS_DESKTOP */.yn ? "Select from saved addresses" : "Saved addresses"),
                newUser && toggleAddDeliveryForm && "",
                newUser && !toggleAddDeliveryForm && "Add address"
            ]
        });
    };
    var renderLoggedOutAddressCta = function renderLoggedOutAddressCta() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressCtaText, {
            toggleAddDeliveryForm: toggleAddDeliveryForm,
            color: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color,
            children: "Add address"
        });
    };
    var getErrorText = function getErrorText() {
        if (cartData === null || cartData === void 0 ? void 0 : cartData.is_store_unserviceable) {
            return "Sorry, we are currently unserviceable at this pincode";
        }
        if (cartData === null || cartData === void 0 ? void 0 : cartData.is_cart_unserviceable) {
            return "Some items in your cart can't be delivered to this address";
        }
    };
    var renderCartNotServicable = function renderCartNotServicable() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: ((cartData === null || cartData === void 0 ? void 0 : cartData.is_cart_unserviceable) || (cartData === null || cartData === void 0 ? void 0 : cartData.is_store_unserviceable)) && !toggleAddDeliveryForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartError_CartError, {
                text: getErrorText(),
                iconWidth: 14,
                iconHeight: 14,
                mri: 8,
                width: deviceWidth/* deviceWidth */.o < 767 ? "100vw" : "34.48vw",
                fontSize: 12,
                mt: 12,
                mb: deviceWidth/* deviceWidth */.o > 767 ? 16 : 0,
                transXi: "-35px",
                transX: "-24px",
                mobileMb: "18px"
            })
        });
    };
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useContext)(CartContext/* CartContext */.A), _showAuthModal = ref1.showAuthModal, showAuthModal = _showAuthModal === void 0 ? null : _showAuthModal, showAddressError = ref1.showAddressError;
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        return {
            userData: state.userReducer,
            storeData: state.storeReducer.store,
            cartData: state.cartReducer,
            toggleAddDeliveryForm: state.commonReducer.toggleAddDeliveryForm
        };
    }), userData = ref2.userData, storeData = ref2.storeData, cartData = ref2.cartData, toggleAddDeliveryForm = ref2.toggleAddDeliveryForm;
    var ref3 = (0,react.useState)(false), newUser = ref3[0], setNewUser = ref3[1];
    var ref4 = (0,react.useState)(false), showDeliveryList = ref4[0], setShowDeliveryList = ref4[1];
    var ref5 = (0,react.useState)(0), editId = ref5[0], setEditId = ref5[1];
    var ref6 = (0,react.useState)({}), fetchedLatestSavedAddress = ref6[0], setFetchedLatestSavedAddress = ref6[1];
    var ref7 = (0,react.useState)({
        pincode: "",
        deliveryTime: ""
    }), estimatedDeliveryTime = ref7[0], setEstimatedDeliveryTime = ref7[1];
    var selectedAddressPincode = userData === null || userData === void 0 ? void 0 : (ref = userData.savedAddress) === null || ref === void 0 ? void 0 : ref.pincode;
    (0,react.useEffect)(function() {
        var ref;
        if (!!(fetchedLatestSavedAddress === null || fetchedLatestSavedAddress === void 0 ? void 0 : (ref = fetchedLatestSavedAddress.missing_fields) === null || ref === void 0 ? void 0 : ref.length)) {
            setEditId(fetchedLatestSavedAddress === null || fetchedLatestSavedAddress === void 0 ? void 0 : fetchedLatestSavedAddress.address_id);
            dispatch((0,common/* setAddDeliveryForm */.r_)(true));
        } else {
            dispatch((0,common/* setAddDeliveryForm */.r_)(false));
        }
    }, [
        fetchedLatestSavedAddress
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        // get Estimated delivery time
        if ((0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)() && selectedAddressPincode && selectedAddressPincode !== estimatedDeliveryTime.pincode && (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.services) === null || ref === void 0 ? void 0 : ref.delivery_estimate_flag) === CheckItemDelivery_constants/* ESTIMATE_DELIVERY_FLAG.ACTIVE */.F.ACTIVE) {
            var payload = {
                id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                text: selectedAddressPincode
            };
            dispatch((0,delivery/* getEstimatedDeliveryTime */.k4)(payload, function(data) {
                setEstimatedDeliveryTime({
                    pincode: selectedAddressPincode,
                    deliveryTime: data
                });
            }));
        }
        // if user has no saved address save the first address in Address List
        if (!((ref1 = (0,getStringifyAddress/* getStringifyAddress */.H)(userData === null || userData === void 0 ? void 0 : userData.savedAddress)) === null || ref1 === void 0 ? void 0 : ref1.address1)) {
            var ref7, ref8, ref9;
            dispatch((0,auth/* saveSelectedAddress */.z)(userData === null || userData === void 0 ? void 0 : (ref7 = userData.addressList) === null || ref7 === void 0 ? void 0 : ref7[0]));
            dispatch((0,common/* setAddDeliveryForm */.r_)(false));
            var ref10;
            setEditId((ref10 = userData === null || userData === void 0 ? void 0 : (ref8 = userData.addressList) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.address_id) !== null && ref10 !== void 0 ? ref10 : 0);
        } else {
            var ref11;
            // Else update the saved address to latest fetched address
            var savedAddress = userData === null || userData === void 0 ? void 0 : userData.savedAddress;
            var selectedSavedAddress = userData === null || userData === void 0 ? void 0 : (ref11 = userData.addressList) === null || ref11 === void 0 ? void 0 : ref11.find(function(add) {
                return (add === null || add === void 0 ? void 0 : add.address_id) === (savedAddress === null || savedAddress === void 0 ? void 0 : savedAddress.address_id);
            });
            if (selectedSavedAddress) {
                setFetchedLatestSavedAddress(selectedSavedAddress);
                var ref12;
                setEditId((ref12 = selectedSavedAddress === null || selectedSavedAddress === void 0 ? void 0 : selectedSavedAddress.address_id) !== null && ref12 !== void 0 ? ref12 : 0);
            }
        }
        // if address List is empty consider it New user and open add delivery Form
        if ((userData === null || userData === void 0 ? void 0 : (ref2 = userData.addressList) === null || ref2 === void 0 ? void 0 : ref2.length) === 0) {
            setNewUser(true);
        }
        // As soon as First address is added the user is no longer a new user. Close add delivery form.
        if ((userData === null || userData === void 0 ? void 0 : (ref3 = userData.addressList) === null || ref3 === void 0 ? void 0 : ref3.length) === 1) {
            dispatch((0,common/* setAddDeliveryForm */.r_)(false));
            setNewUser(false);
        }
        // addressList becomes >1 for any user its old user.
        if ((userData === null || userData === void 0 ? void 0 : (ref4 = userData.addressList) === null || ref4 === void 0 ? void 0 : ref4.length) > 1) setNewUser(false);
        // if savedAddress has missing any mandatory field open Add Delivery form to enter details.
        if ((userData === null || userData === void 0 ? void 0 : userData.isLogin) && (fetchedLatestSavedAddress === null || fetchedLatestSavedAddress === void 0 ? void 0 : (ref5 = fetchedLatestSavedAddress.missing_fields) === null || ref5 === void 0 ? void 0 : ref5.length)) dispatch((0,common/* setAddDeliveryForm */.r_)(true));
        // if user is Logged in And has some addresses get Item Charges in cart and servicable and unservicable addresses.
        if ((userData === null || userData === void 0 ? void 0 : userData.isLogin) && (userData === null || userData === void 0 ? void 0 : (ref6 = userData.addressList) === null || ref6 === void 0 ? void 0 : ref6.length) && (0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)()) {
            // if pincode is thier then only call getITemsDelivery corresponding to pincodes
            if (selectedAddressPincode) (0,triggerGetItemDeliveryChages/* triggerGetItemDeliveryCharges */.l)();
            (0,triggerGetServiceableAddressId/* triggerGetServiceableAddressId */.o)();
        }
    }, [
        userData === null || userData === void 0 ? void 0 : userData.savedAddress,
        userData === null || userData === void 0 ? void 0 : userData.addressList,
        userData === null || userData === void 0 ? void 0 : userData.isLogin
    ]);
    (0,react.useEffect)(function() {
        if (showAddressError) {
            document.getElementById("cart-address-section").scrollTo({
                top: 80
            });
        }
    }, [
        showAddressError
    ]);
    var showError = checkClientDeviceType/* IS_DESKTOP */.yn && showAddressError;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw- tw-flex tw-flex-col tw-gap-[12px]",
                id: "cart-address-section",
                children: [
                    showError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-mt-[16px] tw-text-sm tw-text-[#F63D60]",
                        children: "Please add a delivery address before placing the order"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressFormContainer, {
                        className: "".concat(showError ? "!tw-border-[#F63D60]" : "md:!tw-mt-[16px]", " "),
                        showBorderTop: props.showTopBorderMobile,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressTabContainer, {
                                isErrorThrown: (cartData === null || cartData === void 0 ? void 0 : cartData.is_cart_unservicable) || (cartData === null || cartData === void 0 ? void 0 : cartData.is_store_unserviceable),
                                toggleAddDeliveryForm: toggleAddDeliveryForm,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutInfoTabLeftContainer, {
                                        children: [
                                            checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressTabLeftIcon, {
                                                toggleAddDeliveryForm: toggleAddDeliveryForm,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingTruck, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutInfoTabMiddleContainer, {
                                                cartError: cartData === null || cartData === void 0 ? void 0 : cartData.is_store_unserviceable,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex tw-text-[16px] tw-font-semibold md:tw-text-[14px] md:tw-font-medium",
                                                        children: "Delivery Address"
                                                    }),
                                                    !checkClientDeviceType/* IS_DESKTOP */.yn && renderCartNotServicable()
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutInfoTabRightContainer, {
                                        onClick: handleAddressCta,
                                        children: !!(userData === null || userData === void 0 ? void 0 : userData.isLogin) ? renderAddressCta() : renderLoggedOutAddressCta()
                                    })
                                ]
                            }),
                            !!(userData === null || userData === void 0 ? void 0 : userData.isLogin) && renderSelectedAddress(),
                            checkClientDeviceType/* IS_DESKTOP */.yn && renderCartNotServicable(),
                            toggleAddDeliveryForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddDelivery/* default */.Z, {
                                toggleAddDeliveryForm: handleAddDeliveryForm,
                                edit_id: editId,
                                setEditId: handleEditId
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryList/* default */.Z, {
                isVisible: showDeliveryList,
                toggleModal: toggleShowDeliveryList,
                toggleAddDeliveryForm: handleAddDeliveryForm,
                edit_id: editId,
                setEditId: handleEditId
            })
        ]
    });
}
/* harmony default export */ var TabAddress = (CheckoutInfoTabAddress);

// EXTERNAL MODULE: ./src/utils/getCustomCtaText.js
var getCustomCtaText = __webpack_require__(336623);
;// CONCATENATED MODULE: ./src/assets/svgExports/PageIcon.js

var PageIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14.206",
        height: "17.758",
        viewBox: "0 0 14.206 17.758",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "description_FILL0_wght400_GRAD0_opsz48",
            d: "M11.529,17.984h7.147V16.652H11.529Zm0-3.773h7.147V12.879H11.529Zm-2.2,7.547A1.366,1.366,0,0,1,8,20.426V5.332A1.366,1.366,0,0,1,9.332,4h8.013l4.861,4.861V20.426a1.366,1.366,0,0,1-1.332,1.332Zm7.347-12.3V5.332H9.332V20.426H20.874V9.46ZM9.332,5.332v0Z",
            transform: "translate(-8 -4)"
        })
    });
};

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/Components/TabOrderInstruction/TabOrderInstruction.styles.js

function TabOrderInstruction_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 90%;\n  resize: none;\n  font-size: 14px;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n  }\n"
    ]);
    TabOrderInstruction_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border-radius: 8px;\n  margin-top: 16px;\n  border: 1px solid #e8e8e8;\n  min-height: ",
        "px;\n  padding-bottom: ",
        "px;\n  ",
        "px;\n  @media screen and (max-width: 767px) {\n    width: 100vw;\n    border-left: none;\n    border-right: none;\n    border-top: none;\n    border-bottom: 1px solid #e8e8e8;\n    border-radius: 0px;\n    margin-top: 0px;\n  }\n"
    ]);
    TabOrderInstruction_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  background-color: ",
        ";\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 14px;\n"
    ]);
    TabOrderInstruction_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  font-weight: 600;\n  margin-right: 16px;\n  justify-content: flex-end;\n  margin-bottom: 22px;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n  }\n"
    ]);
    TabOrderInstruction_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 500;\n  cursor: pointer;\n  margin-right: 20px;\n  color: #7f7f7f;\n  font-size: 14px;\n"
    ]);
    TabOrderInstruction_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  cursor: pointer;\n  color: ",
        ";\n  font-weight: 500;\n  font-size: 14px;\n"
    ]);
    TabOrderInstruction_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"
    ]);
    TabOrderInstruction_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  color: ",
        ";\n  font-weight: 500;\n  font-size: 14px;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n  }\n"
    ]);
    TabOrderInstruction_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 500;\n  margin-right: 20px;\n  color: #7f7f7f;\n  font-size: 14px;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n  }\n"
    ]);
    TabOrderInstruction_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function TabOrderInstruction_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 20vw;\n  margin-left: 20px;\n  font-size: 14px;\n  color: #7f7f7f;\n"
    ]);
    TabOrderInstruction_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var OrderInstructionTextArea = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
    displayName: "OrderInstructionTextArea",
    componentId: "sc-11fc75c2-0"
})(TabOrderInstruction_styles_templateObject());
var OrderInstructionInfoTabContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabContainer",
    componentId: "sc-11fc75c2-1"
})(TabOrderInstruction_styles_templateObject1(), function(props) {
    return props.cartSavedOrderText ? "93" : "0";
}, function(props) {
    return props.cartSavedOrderText ? "24" : "0";
}, function(props) {
    return props.isEdit && "padding-bottom : 0";
});
var OrderInstructionInfoTabAddCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabAddCta",
    componentId: "sc-11fc75c2-2"
})(TabOrderInstruction_styles_templateObject2(), function(props) {
    return props.color || "#000000";
}, function(props) {
    return props.background || "transparent";
});
var OrderInstructionInfoTabTypingCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabTypingCta",
    componentId: "sc-11fc75c2-3"
})(TabOrderInstruction_styles_templateObject3());
var OrderInstructionInfoTabTypingCancelCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabTypingCancelCta",
    componentId: "sc-11fc75c2-4"
})(TabOrderInstruction_styles_templateObject4());
var OrderInstructionInfoTabTypingAddCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabTypingAddCta",
    componentId: "sc-11fc75c2-5"
})(TabOrderInstruction_styles_templateObject5(), function(props) {
    return props.color || "#000000";
});
var OrderInstructionInfoTabSavedTextCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabSavedTextCta",
    componentId: "sc-11fc75c2-6"
})(TabOrderInstruction_styles_templateObject6());
var OrderInstructionInfoTabEditCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabEditCta",
    componentId: "sc-11fc75c2-7"
})(TabOrderInstruction_styles_templateObject7(), function(props) {
    return props.color || "#000000";
});
var OrderInstructionInfoTabRemoveCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabRemoveCta",
    componentId: "sc-11fc75c2-8"
})(TabOrderInstruction_styles_templateObject8());
var OrderInstructionInfoTabSavedText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OrderInstructionInfoTabSavedText",
    componentId: "sc-11fc75c2-9"
})(TabOrderInstruction_styles_templateObject9());

// EXTERNAL MODULE: ./src/components/BasicModal/index.tsx
var BasicModal = __webpack_require__(475868);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/Components/TabOrderInstruction/TabOrderInstruction.js

















function CheckoutInfoTabOrderInstruction(props) {
    var onOrderInstructionSaveBtnClick = function onOrderInstructionSaveBtnClick() {
        var ref, ref1;
        setOrderText(orderText);
        dispatch((0,actions_cart/* saveorderInstruction */.UE)(orderText));
        triggerSetCart((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartData), {
            user_phone: userData === null || userData === void 0 ? void 0 : (ref = userData.data) === null || ref === void 0 ? void 0 : ref.phone,
            phone: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone,
            instructions: orderText
        }));
        setCartSavedOrderText(orderText);
    };
    var handleOrderInstructionInfoTabTypingAddCta = function handleOrderInstructionInfoTabTypingAddCta() {
        onOrderInstructionSaveBtnClick();
        setIsEdit(false);
        handleToggleTextArea();
    };
    var handleOrderText = function handleOrderText(e) {
        if (e.target.value.length < 101) {
            setOrderText(e.target.value);
        }
    };
    var handleToggleTextArea = function handleToggleTextArea() {
        setToggleTextArea(!toggleTextArea);
    };
    var handleOrderInstructionInfoTabEditCta = function handleOrderInstructionInfoTabEditCta(e) {
        e.stopPropagation();
        handleToggleTextArea();
        setIsEdit(true);
        setOrderText(cartSavedOrderText);
    };
    var handleOrderInstructionInfoTabAddCta = function handleOrderInstructionInfoTabAddCta() {
        setOrderText("");
        handleToggleTextArea();
    };
    var handleOrderInstructionTypingCancelCta = function handleOrderInstructionTypingCancelCta() {
        setIsEdit(false);
        handleToggleTextArea();
    };
    var renderTabCTA = function renderTabCTA() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutInfoTabRightContainer, {
            className: "!tw-m-0",
            children: [
                !toggleTextArea && !cartSavedOrderText && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderInstructionInfoTabAddCta, {
                    color: themeColor,
                    onClick: (userData === null || userData === void 0 ? void 0 : userData.isLogin) ? handleOrderInstructionInfoTabAddCta : showAuthModal,
                    children: "Add"
                }),
                cartSavedOrderText && !toggleTextArea && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderInstructionInfoTabAddCta, {
                    color: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color,
                    onClick: function(e) {
                        return handleOrderInstructionInfoTabEditCta(e);
                    },
                    children: "Edit"
                }),
                checkClientDeviceType/* IS_DESKTOP */.yn && renderButtonWihtTextArea()
            ]
        });
    };
    var ref = (0,react.useContext)(CartContext/* CartContext */.A), _showAuthModal = ref.showAuthModal, showAuthModal = _showAuthModal === void 0 ? null : _showAuthModal;
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)(false), toggleTextArea = ref1[0], setToggleTextArea = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store,
            userData: state.userReducer,
            cartData: state.cartReducer
        };
    }), storeData = ref2.storeData, userData = ref2.userData, cartData = ref2.cartData;
    var ref3 = (0,react.useState)(""), orderText = ref3[0], setOrderText = ref3[1];
    var ref4 = (0,react.useState)(false), isEdit = ref4[0], setIsEdit = ref4[1];
    var ref5 = (0,react.useState)(cartData === null || cartData === void 0 ? void 0 : cartData.instructions), cartSavedOrderText = ref5[0], setCartSavedOrderText = ref5[1];
    var triggerSetCart = (0,customHooks/* default */.Z)().triggerSetCart;
    var renderButtonWihtTextArea = function() {
        return toggleTextArea && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderInstructionInfoTabAddCta, {
            className: "tw-rounded-lg tw-py-[12px] tw-text-center !tw-text-sm md:tw-p-0 ",
            color: checkClientDeviceType/* IS_DESKTOP */.yn ? themeColor : "white",
            background: checkClientDeviceType/* IS_DESKTOP */.yn ? "transparent" : themeColor,
            onClick: handleOrderInstructionInfoTabTypingAddCta,
            children: "Save Instructions"
        });
    };
    var renderTextAreaInnerContent = function() {
        return toggleTextArea && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-gap-[24px] tw-px-[16px] tw-py-[24px] md:tw-p-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderInstructionTextArea, {
                    className: "tw-h-[125px] !tw-w-full tw-rounded-lg tw-border !tw-border-solid !tw-border-[#E2E2E2] tw-p-[12px] tw-text-sm tw-font-medium tw-text-[#7D7D7D] md:tw-h-fit md:tw-rounded-none md:!tw-border-none md:tw-p-0 md:tw-font-normal",
                    placeholder: "Type order instrictions here",
                    value: orderText,
                    onChange: function(e) {
                        return handleOrderText(e);
                    }
                }),
                checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-justify-end tw-text-xs tw-opacity-60",
                    children: [
                        orderText.length,
                        "/ 100"
                    ]
                }),
                !checkClientDeviceType/* IS_DESKTOP */.yn && renderButtonWihtTextArea()
            ]
        });
    };
    var renderTextAreaMobile = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicModal/* default */.Z, {
            show: toggleTextArea,
            onClose: handleOrderInstructionTypingCancelCta,
            heading: (0,getCustomCtaText/* default */.Z)("order_instructions_label"),
            children: renderTextAreaInnerContent()
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-border-y tw-border-solid tw-border-[#EAEAEC] md:tw-mb-0 md:tw-mt-[16px] md:tw-rounded-lg md:tw-border",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-items-center tw-justify-between tw-px-[16px] tw-py-[24px] tw-text-sm md:tw-pl-[20px] md:tw-pr-[16px] ".concat(!checkClientDeviceType/* IS_DESKTOP */.yn && cartSavedOrderText && !isEdit ? "!tw-pb-[12px]" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "tw-flex tw-items-center tw-gap-[12px] tw-text-[16px] tw-font-semibold md:tw-text-[14px] md:tw-font-medium",
                        children: [
                            checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageIcon, {}),
                            " ",
                            (0,getCustomCtaText/* default */.Z)("order_instructions_label")
                        ]
                    }),
                    renderTabCTA()
                ]
            }),
            cartSavedOrderText && !isEdit && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-text-wrap tw-border-t tw-border-none tw-border-[#EAEAEC] tw-px-[16px] tw-pb-[24px] md:tw-border-solid md:tw-py-[16px] md:tw-pl-[46px] md:tw-pr-[32px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderInstructionInfoTabSavedText, {
                    className: "!tw-m-0 !tw-w-full !tw-flex-wrap tw-text-sm",
                    children: cartSavedOrderText
                })
            }),
            checkClientDeviceType/* IS_DESKTOP */.yn && toggleTextArea ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-border-t tw-border-solid tw-border-[#EAEAEC] tw-pb-[8px] tw-pl-[46px] tw-pr-[8px] tw-pt-[16px] ",
                children: renderTextAreaInnerContent()
            }) : renderTextAreaMobile()
        ]
    });
}
/* harmony default export */ var TabOrderInstruction = (CheckoutInfoTabOrderInstruction);

// EXTERNAL MODULE: ./src/redux/actions/promo.js
var promo = __webpack_require__(168615);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(414924);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/Common/index.tsx
var Common = __webpack_require__(192134);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/TabsContainer/index.tsx
var TabsContainer = __webpack_require__(201325);
// EXTERNAL MODULE: ./node_modules/@mui/material/Snackbar/Snackbar.js + 3 modules
var Snackbar = __webpack_require__(226379);
// EXTERNAL MODULE: ./node_modules/@mui/material/SnackbarContent/snackbarContentClasses.js
var snackbarContentClasses = __webpack_require__(40416);
// EXTERNAL MODULE: ./src/components/BasicModal/Transition.tsx
var Transition = __webpack_require__(375513);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js + 2 modules
var createSvgIcon = __webpack_require__(288169);
;// CONCATENATED MODULE: ./node_modules/@mui/icons-material/esm/KeyboardArrowUp.js
"use client";



/* harmony default export */ var KeyboardArrowUp = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"
}), 'KeyboardArrowUp'));
;// CONCATENATED MODULE: ./node_modules/@mui/icons-material/esm/KeyboardArrowDown.js
"use client";



/* harmony default export */ var KeyboardArrowDown = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), 'KeyboardArrowDown'));
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/AllCartPagePromos/Common/index.tsx














var SectionHeader = function(param) {
    var activeTabIndex = param.activeTabIndex, setActiveTabIndex = param.setActiveTabIndex, tabsData = param.tabsData, _hasPaymentOffers = param.hasPaymentOffers, hasPaymentOffers = _hasPaymentOffers === void 0 ? false : _hasPaymentOffers, _isCouponApplied = param.isCouponApplied, isCouponApplied = _isCouponApplied === void 0 ? false : _isCouponApplied, _UnopenedTabText = param.UnopenedTabText, UnopenedTabText = _UnopenedTabText === void 0 ? "" : _UnopenedTabText, _openDropDown = param.openDropDown, openDropDown = _openDropDown === void 0 ? false : _openDropDown, _handleDropDown = param.handleDropDown, handleDropDown = _handleDropDown === void 0 ? null : _handleDropDown;
    var showTabs = checkClientDeviceType/* IS_DESKTOP */.yn || openDropDown;
    return (checkClientDeviceType/* IS_DESKTOP */.yn || !isCouponApplied) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(showTabs ? "border-b-grey1" : "", " tw-flex tw-flex-col"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-items-center tw-justify-between tw-px-[16px] tw-py-[22px] md:tw-px-[18px]",
                onClick: function() {
                    return !checkClientDeviceType/* IS_DESKTOP */.yn && (handleDropDown === null || handleDropDown === void 0 ? void 0 : handleDropDown());
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-gap-[10px] tw-text-[16px]/[20px] tw-font-semibold md:tw-text-[14px]/[17px] md:tw-font-medium",
                        children: [
                            checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* StripOfferIcon */.YT, {
                                iconSize: 18,
                                customClasses: "tw-flex"
                            }),
                            "Available offers"
                        ]
                    }),
                    !checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-gap-[12px]",
                        children: [
                            UnopenedTabText && !openDropDown && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-rounded-[4px] tw-bg-[#D6F4DF] tw-px-[7px] tw-py-[4px] tw-text-[14px]/[17px] tw-text-[#017424]",
                                children: UnopenedTabText
                            }),
                            openDropDown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowUp, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDown, {})
                        ]
                    })
                ]
            }),
            showTabs && hasPaymentOffers && !isCouponApplied && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContainer/* default */.Z, {
                activeTabIndex: activeTabIndex,
                setActiveTabIndex: setActiveTabIndex,
                tabsData: tabsData
            })
        ]
    });
};
var CustomPromo = function(param) {
    var cartData = param.cartData, storeId = param.storeId, userId = param.userId, setSuccessPopupState = param.setSuccessPopupState, showAuthModal = param.showAuthModal;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(""), manualPromoCode = ref[0], setManualPromoCode = ref[1];
    var ref1 = (0,react.useState)(""), errorText = ref1[0], setErrorText = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        return {
            isUserLoggedIn: state.userReducer.isLogin,
            latestSyncedCart: state.commonReducer.latestSyncedCart
        };
    }), isUserLoggedIn = ref2.isUserLoggedIn, latestSyncedCart = ref2.latestSyncedCart;
    (0,react.useEffect)(function() {
        errorText && setErrorText("");
    }, [
        latestSyncedCart
    ]);
    var onApplyCustomPromo = function() {
        if (!isUserLoggedIn) {
            showAuthModal === null || showAuthModal === void 0 ? void 0 : showAuthModal();
            return;
        }
        var payload = {
            cart: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartData), {
                store_id: storeId,
                user_id: userId,
                store_offer: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartData.store_offer || {}), {
                    promo_code: manualPromoCode
                })
            })
        };
        dispatch((0,promo/* applyPromo */.RM)(payload, function(resp) {
            if (resp.data.status) {
                var ref;
                var errorText = (ref = resp.data.data) === null || ref === void 0 ? void 0 : ref.reason;
                if (!errorText) {
                    setSuccessPopupState({
                        show: true,
                        appliedPromoCode: manualPromoCode
                    });
                } else {
                    setErrorText(errorText);
                }
            } else {
                setErrorText("Invalid coupon");
            }
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-gap-[24px] tw-rounded-[8px] tw-border tw-border-solid tw-border-[#B4B4B4] tw-p-[16px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        value: manualPromoCode,
                        onChange: function(e) {
                            errorText && setErrorText("");
                            setManualPromoCode(e.target.value);
                        },
                        className: "tw-flex-1 tw-border-none tw-text-[14px]/[17px] placeholder:tw-text-[#00000099]",
                        placeholder: "Enter Coupon Code"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* StripCTA */.iQ, {
                        ctaTextOrIcon: "Apply",
                        onClick: onApplyCustomPromo,
                        isDisabled: !manualPromoCode || !!errorText
                    })
                ]
            }),
            !!errorText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "tw-m-0 tw-mt-[8px] tw-text-[14px]/[17px] tw-text-[#F63D60]",
                children: errorText
            })
        ]
    });
};
var ExpandOrShrinkButton = function(param) {
    var show = param.show, showAllPromos = param.showAllPromos, setShowAllPromos = param.setShowAllPromos;
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    return show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "tw-m-0 tw-cursor-pointer tw-text-center tw-text-[16px]/[20px] tw-font-semibold md:tw-text-left md:tw-text-[15px]/[20px]",
        style: {
            color: themeColor
        },
        onClick: function() {
            return setShowAllPromos(!showAllPromos);
        },
        children: [
            "View ",
            showAllPromos ? "less" : "all",
            " offers"
        ]
    });
};
var SuccessMessage = function(param) {
    var show = param.show, message = param.message, onClose = param.onClose;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
        open: show,
        onClose: onClose,
        autoHideDuration: 3000,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: checkClientDeviceType/* IS_DESKTOP */.yn ? "left" : "center"
        },
        message: message,
        sx: (_obj = {}, (0,_define_property/* default */.Z)(_obj, "& .".concat(snackbarContentClasses/* default.root */.Z.root), {
            minWidth: "auto",
            padding: "0px 0px",
            backgroundColor: "#24AC21"
        }), (0,_define_property/* default */.Z)(_obj, "& .".concat(snackbarContentClasses/* default.message */.Z.message), {
            width: "100%",
            padding: "16px 18px",
            borderRadius: "6px"
        }), _obj),
        TransitionComponent: Transition/* default */.Z,
        transitionDuration: 100
    });
};

// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/BankOffers/index.tsx
var BankOffers = __webpack_require__(411110);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/AllCartPagePromos/OfferNotAppliedView/OffersSections/BankOffersSection.tsx





var BankOffersSection = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BankOffers/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        isCartPage: true
    }));
};
/* harmony default export */ var OffersSections_BankOffersSection = (BankOffersSection);

// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/Common/CartPromosContainer.tsx
var CartPromosContainer = __webpack_require__(462856);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/AllCartPagePromos/OfferNotAppliedView/OffersSections/StoreOffersSection.tsx










var StoreOffersSection = function(param) {
    var _showAllPromos = param.showAllPromos, showAllPromos = _showAllPromos === void 0 ? false : _showAllPromos, _cartStorePromos = param.cartStorePromos, cartStorePromos = _cartStorePromos === void 0 ? [] : _cartStorePromos, _cartData = param.cartData, cartData = _cartData === void 0 ? {} : _cartData, setSuccessPopupState = param.setSuccessPopupState;
    var onStoreOfferDetailClick = function onStoreOfferDetailClick(promoId) {
        dispatch((0,promo/* togglePromoDetailModal */.wl)({
            show: true,
            promoId: promoId
        }));
    };
    var onStoreOfferApplyClick = function onStoreOfferApplyClick(promoId) {
        if (!isUserLoggedIn) {
            showAuthModal === null || showAuthModal === void 0 ? void 0 : showAuthModal();
            return;
        }
        var coupon = cartStorePromos === null || cartStorePromos === void 0 ? void 0 : cartStorePromos.find(function(promo) {
            return (promo === null || promo === void 0 ? void 0 : promo.id) === promoId;
        });
        var payload = {
            cart: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartData), {
                store_id: storeId,
                user_id: userId,
                store_offer: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartData.store_offer || {}), {
                    promo_id: coupon.id,
                    promo_code: coupon.code
                })
            })
        };
        dispatch((0,promo/* applyPromo */.RM)(payload, function(resp) {
            if (resp.data.status) {
                var ref;
                var errorText = (ref = resp.data.data) === null || ref === void 0 ? void 0 : ref.reason;
                if (!errorText) {
                    setSuccessPopupState({
                        show: true,
                        appliedPromoCode: coupon.code
                    });
                } else {
                    (0,Toast/* toastNotifyError */.Lu)(errorText);
                }
            } else {
                (0,Toast/* toastNotifyError */.Lu)(resp.message);
            }
        }));
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useContext)(CartContext/* CartContext */.A), _showAuthModal = ref.showAuthModal, showAuthModal = _showAuthModal === void 0 ? null : _showAuthModal;
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2;
        return {
            storeId: state.storeReducer.store.store_id,
            isUserLoggedIn: (ref = state.userReducer) === null || ref === void 0 ? void 0 : ref.isLogin,
            userId: (ref1 = state.userReducer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.user_id
        };
    }), storeId = ref1.storeId, isUserLoggedIn = ref1.isUserLoggedIn, userId = ref1.userId;
    var promosToShow = showAllPromos ? cartStorePromos : cartStorePromos.slice(0, 3);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-gap-[24px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomPromo, {
                cartData: cartData,
                storeId: storeId,
                userId: userId,
                setSuccessPopupState: setSuccessPopupState,
                showAuthModal: showAuthModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPromosContainer/* CartPromosContainer */.e, {
                promos: promosToShow,
                onDetailClick: onStoreOfferDetailClick,
                onApplyClick: onStoreOfferApplyClick,
                isStorePromos: true
            })
        ]
    });
};
/* harmony default export */ var OffersSections_StoreOffersSection = (StoreOffersSection);

// EXTERNAL MODULE: ./src/utils/debounce.js
var debounce = __webpack_require__(374118);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/AllCartPagePromos/OfferNotAppliedView/index.tsx








function getCartPromos(cartData, dispatch, callabck) {
    var payload = {
        cart: cartData
    };
    dispatch((0,promo/* getCartPagePromos */.go)(payload, callabck));
}
var debouncedGetCartPromos = (0,debounce/* debounce */.D)(getCartPromos, 300);
var OfferNotAppliedView = function(param) {
    var activeTabIndex = param.activeTabIndex, setSuccessPopupState = param.setSuccessPopupState, showView = param.showView, setUnOpenedTabText = param.setUnOpenedTabText;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(false), showAllPromos = ref[0], setShowAllPromos = ref[1];
    var ref1 = (0,react.useState)([]), cartStorePromos = ref1[0], setCartStorePromos = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        return {
            paymentOffersList: state.promoReducer.paymentOffersList || [],
            storeData: state.storeReducer.store,
            cartData: state.cartReducer,
            latestSyncedCart: state.commonReducer.latestSyncedCart
        };
    }), paymentOffersList = ref2.paymentOffersList, storeData = ref2.storeData, cartData = ref2.cartData, latestSyncedCart = ref2.latestSyncedCart;
    (0,react.useEffect)(function() {
        var ref;
        if (latestSyncedCart && (latestSyncedCart === null || latestSyncedCart === void 0 ? void 0 : (ref = latestSyncedCart.items) === null || ref === void 0 ? void 0 : ref.length) && (storeData === null || storeData === void 0 ? void 0 : storeData.store_id)) {
            debouncedGetCartPromos(cartData, dispatch, function(allPromos) {
                return setCartStorePromos(allPromos);
            });
        }
    }, [
        latestSyncedCart,
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id
    ]);
    (0,react.useEffect)(function() {
        if ((cartStorePromos === null || cartStorePromos === void 0 ? void 0 : cartStorePromos.length) || (paymentOffersList === null || paymentOffersList === void 0 ? void 0 : paymentOffersList.length)) {
            setUnOpenedTabText("".concat((cartStorePromos === null || cartStorePromos === void 0 ? void 0 : cartStorePromos.length) + (paymentOffersList === null || paymentOffersList === void 0 ? void 0 : paymentOffersList.length), " Offers Available"));
        }
    }, [
        cartStorePromos,
        paymentOffersList
    ]);
    (0,react.useEffect)(function() {
        if (storeData === null || storeData === void 0 ? void 0 : storeData.store_id) {
            dispatch((0,promo/* getPaymentOffersList */.Xu)(storeData.store_id));
        }
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id
    ]);
    var isStoreOfferTabActive = activeTabIndex === 0;
    return showView && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-gap-[18px] tw-px-[12px] tw-py-[16px] md:tw-gap-[16px] md:tw-p-[24px]",
        children: [
            isStoreOfferTabActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OffersSections_StoreOffersSection, {
                showAllPromos: showAllPromos,
                cartStorePromos: cartStorePromos,
                cartData: cartData,
                setSuccessPopupState: setSuccessPopupState
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OffersSections_BankOffersSection, {
                showAllPromos: showAllPromos,
                paymentOffersList: paymentOffersList,
                cartData: cartData,
                setSuccessPopupState: setSuccessPopupState
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandOrShrinkButton, {
                showAllPromos: showAllPromos,
                setShowAllPromos: setShowAllPromos,
                show: isStoreOfferTabActive ? (cartStorePromos === null || cartStorePromos === void 0 ? void 0 : cartStorePromos.length) > 3 : (paymentOffersList === null || paymentOffersList === void 0 ? void 0 : paymentOffersList.length) > 3
            })
        ]
    });
};
/* harmony default export */ var AllCartPagePromos_OfferNotAppliedView = (OfferNotAppliedView);

// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/CartPromoStrip/index.tsx
var CartPromoStrip = __webpack_require__(953149);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/AllCartPagePromos/OfferAppliedView/index.tsx







var OfferAppliedView = function(param) {
    var cartData = param.cartData, isBankOfferApplied = param.isBankOfferApplied, bankOfferDataFromCart = param.bankOfferDataFromCart, storeOfferDataFromCart = param.storeOfferDataFromCart;
    var getAppliedOffer = function getAppliedOffer() {
        var ref;
        return (ref = isBankOfferApplied ? bankOfferDataFromCart === null || bankOfferDataFromCart === void 0 ? void 0 : bankOfferDataFromCart.promo_code : storeOfferDataFromCart === null || storeOfferDataFromCart === void 0 ? void 0 : storeOfferDataFromCart.promo_code) === null || ref === void 0 ? void 0 : ref.toUpperCase();
    };
    var getAppliedOfferDiscount = function getAppliedOfferDiscount() {
        return isBankOfferApplied ? bankOfferDataFromCart === null || bankOfferDataFromCart === void 0 ? void 0 : bankOfferDataFromCart.promo_discount : storeOfferDataFromCart === null || storeOfferDataFromCart === void 0 ? void 0 : storeOfferDataFromCart.promo_discount;
    };
    var triggerSetCart = (0,customHooks/* default */.Z)().triggerSetCart;
    var removePaymentCoupon = function() {
        var tempPayload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartData), {
            payment_offer: {},
            store_offer: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartData.store_offer), {
                promo_code: "",
                promo_id: 0,
                promo_discount: 0
            })
        });
        triggerSetCart(tempPayload);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-flex tw-flex-col tw-gap-[18px] tw-px-[12px] tw-py-[16px] md:tw-gap-[16px] md:tw-p-[24px]",
        children: checkClientDeviceType/* IS_DESKTOP */.yn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPromoStrip/* default */.Z, {
            primaryText: getAppliedOffer(),
            secondaryText: "Offer Applied",
            onApplyOrRemoveClick: removePaymentCoupon,
            savingAmount: getAppliedOfferDiscount(),
            primaryButtonText: "Remove",
            primaryButtonClasses: "!tw-pr-0",
            isOfferApplied: true
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Common/* StripContainer */.P6, {
            customClasses: "!tw-flex-row tw-justify-between tw-items-center tw-border-none tw-px-[6px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* StripIconInfoWrapper */.To, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-gap-[8px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-m-0 tw-text-[16px]/[20px] tw-font-semibold",
                                children: "Offer Applied"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "tw-m-0 tw-flex tw-flex-col tw-gap-[8px] tw-text-[14px]/[20px] tw-font-medium tw-text-[#0D9738]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tw-w-fit tw-bg-[#E2FFEB] tw-px-[4px] tw-py-[1px]",
                                        children: getAppliedOffer()
                                    }),
                                    !!getAppliedOfferDiscount() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "tw-text-[14px]/[20px] tw-font-semibold md:tw-text-[14px]/[20px]",
                                        children: [
                                            "Save ₹",
                                            getAppliedOfferDiscount()
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* StripCTA */.iQ, {
                    ctaTextOrIcon: "Remove",
                    onClick: removePaymentCoupon
                })
            ]
        })
    });
};
/* harmony default export */ var AllCartPagePromos_OfferAppliedView = (OfferAppliedView);

;// CONCATENATED MODULE: ./src/assets/svgExports/SuccessIconWhite.js

var SuccessIconWhite = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.35498 7.98717L6.72105 10.0011L11.3784 5.87109",
                stroke: "#24AC21",
                "stroke-width": "1.3",
                "stroke-linecap": "square"
            })
        ]
    });
};
/* harmony default export */ var svgExports_SuccessIconWhite = (SuccessIconWhite);

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/AllCartPagePromos/index.tsx











var AllCartPagePromos = function() {
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return {
            paymentOffersList: state.promoReducer.paymentOffersList,
            cartData: state.cartReducer
        };
    }), paymentOffersList = ref.paymentOffersList, cartData = ref.cartData;
    var ref1 = (0,react.useState)(0), activeTabIndex = ref1[0], setActiveTabIndex = ref1[1];
    var ref2 = (0,react.useState)({
        show: false,
        appliedPromoCode: null
    }), successPopupState = ref2[0], setSuccessPopupState = ref2[1];
    var ref3 = (0,react.useState)(false), openDropdown = ref3[0], setOpenDropdown = ref3[1];
    var ref4 = (0,react.useState)(""), unopenedTabText = ref4[0], setUnopenedTabText = ref4[1];
    var couponsFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().couponsFeatureStatus;
    var isCouponsFeatureLocked = !!(couponsFeatureStatus === null || couponsFeatureStatus === void 0 ? void 0 : couponsFeatureStatus.isLocked);
    var hasPaymentOffers = !!(paymentOffersList === null || paymentOffersList === void 0 ? void 0 : paymentOffersList.length);
    var tabsData = [
        {
            text: "Store Offers"
        },
        {
            text: "Bank Offers"
        }, 
    ];
    var storeOfferDataFromCart = cartData === null || cartData === void 0 ? void 0 : cartData.store_offer;
    var bankOfferDataFromCart = cartData === null || cartData === void 0 ? void 0 : cartData.payment_offer;
    var isBankOfferApplied = !!(bankOfferDataFromCart === null || bankOfferDataFromCart === void 0 ? void 0 : bankOfferDataFromCart.promo_id);
    var isStoreOfferApplied = !!(storeOfferDataFromCart === null || storeOfferDataFromCart === void 0 ? void 0 : storeOfferDataFromCart.promo_code);
    var isOfferApplied = isBankOfferApplied || isStoreOfferApplied;
    var getSuccessMessage = function(promoCode) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-items-center tw-gap-[8px] tw-text-sm tw-text-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_SuccessIconWhite, {}),
                " Coupon",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "tw-flex tw-items-center tw-font-bold",
                    children: [
                        promoCode,
                        " "
                    ]
                }),
                "applied successfully."
            ]
        });
    };
    return !isCouponsFeatureLocked && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col md:tw-rounded-[8px] md:tw-border md:tw-border-solid md:tw-border-[#EAEAEC]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                        activeTabIndex: activeTabIndex,
                        setActiveTabIndex: setActiveTabIndex,
                        tabsData: tabsData,
                        hasPaymentOffers: hasPaymentOffers,
                        isCouponApplied: isOfferApplied,
                        UnopenedTabText: unopenedTabText,
                        openDropDown: openDropdown,
                        handleDropDown: function() {
                            return setOpenDropdown(!openDropdown);
                        }
                    }),
                    isOfferApplied ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AllCartPagePromos_OfferAppliedView, {
                        cartData: cartData,
                        isBankOfferApplied: isBankOfferApplied,
                        bankOfferDataFromCart: bankOfferDataFromCart,
                        storeOfferDataFromCart: storeOfferDataFromCart
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AllCartPagePromos_OfferNotAppliedView, {
                        activeTabIndex: activeTabIndex,
                        setSuccessPopupState: setSuccessPopupState,
                        showView: checkClientDeviceType/* IS_DESKTOP */.yn || openDropdown,
                        setUnOpenedTabText: setUnopenedTabText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessMessage, {
                show: successPopupState.show,
                onClose: function() {
                    return setSuccessPopupState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, successPopupState), {
                        show: false
                    }));
                },
                message: getSuccessMessage(successPopupState.appliedPromoCode)
            })
        ]
    });
};
/* harmony default export */ var CouponsAndVouchers_AllCartPagePromos = (AllCartPagePromos);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/Components/TabPromo/TabPromo.js





function CheckoutInfoTabPromo(props) {
    var storeId = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return {
            storeId: (ref = state.storeReducer.store) === null || ref === void 0 ? void 0 : ref.store_id
        };
    }).storeId;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        if (storeId) {
            dispatch((0,promo/* getPaymentOffersList */.Xu)(storeId));
        }
    }, [
        storeId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponsAndVouchers_AllCartPagePromos, {});
}
/* harmony default export */ var TabPromo = (CheckoutInfoTabPromo);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/CartAdditionalInfo.styles.js

function CartAdditionalInfo_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: auto;\n  flex-direction: column;\n  overflow: visible;\n  @media screen and (min-width: 767px) {\n    padding: 0 32px;\n    margin: 0 auto;\n    max-width: 55%;\n    overflow: scroll;\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n\n    /* Hide scrollbar for IE, Edge and Firefox */\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n"
    ]);
    CartAdditionalInfo_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartAdditionalInfo_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 6px;\n  padding-bottom: 40px;\n  @media screen and (max-width: 767px) {\n    margin-top: 0px;\n    padding-bottom: 0px;\n  }\n"
    ]);
    CartAdditionalInfo_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CartAdditionalInfo_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"
    ]);
    CartAdditionalInfo_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var CheckoutAdditionalInfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckoutAdditionalInfoContainer",
    componentId: "sc-731c9d0f-0"
})(CartAdditionalInfo_styles_templateObject());
var CheckoutAdditionalInfoTabContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckoutAdditionalInfoTabContainer",
    componentId: "sc-731c9d0f-1"
})(CartAdditionalInfo_styles_templateObject1());
var CheckoutAdditionalInfoHeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CheckoutAdditionalInfoHeaderContainer",
    componentId: "sc-731c9d0f-2"
})(CartAdditionalInfo_styles_templateObject2());

// EXTERNAL MODULE: ./src/utils/isStoreServiceBased.js
var isStoreServiceBased = __webpack_require__(666466);
// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
;// CONCATENATED MODULE: ./src/utils/isAddressMandatoryForService.js


function isAddressMandatoryForService() {
    return (0,getStoreType/* getStoreType */.K)() === constants/* STORE_CUSTOMIZATION.SERVICE_BASED_WITH_ADDRESS_ENABLED */.DO.SERVICE_BASED_WITH_ADDRESS_ENABLED;
}

// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(268037);
;// CONCATENATED MODULE: ./src/containers/Cart/SVGs/index.tsx

var ShieldIcon = function(param) {
    var _height = param.height, height = _height === void 0 ? 16 : _height, _width = param.width, width = _width === void 0 ? 16 : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.2678 1.79263L8.28223 0.0577139C8.11014 -0.019238 7.91051 -0.019238 7.73842 0.0577139L3.75282 1.79263C2.99562 2.12142 2.5 2.88395 2.5 3.72342V7.10231C2.5 9.01212 3.41552 10.824 4.94368 11.9363L7.60075 13.8671C7.71777 13.951 7.86233 14 8 14C8.13767 14 8.28223 13.958 8.39925 13.8671L11.0563 11.9363C12.5914 10.824 13.5 9.01911 13.5 7.10231V3.72342C13.5 2.88395 13.0113 2.12842 12.2472 1.79263H12.2678ZM10.5676 6.09494L7.81414 8.89319C7.67647 9.0331 7.50438 9.09606 7.32541 9.09606C7.14643 9.09606 6.97434 9.02611 6.83667 8.89319L5.45995 7.49407C5.19149 7.22124 5.19149 6.78051 5.45995 6.50768C5.72841 6.23485 6.16208 6.23485 6.43054 6.50768L7.31852 7.41012L9.58323 5.10856C9.85169 4.83573 10.2854 4.83573 10.5538 5.10856C10.8223 5.38139 10.8223 5.82211 10.5538 6.09494H10.5676Z",
            fill: "black"
        })
    });
};
var VerifiedIcon = function(param) {
    var _height = param.height, height = _height === void 0 ? 16 : _height, _width = param.width, width = _width === void 0 ? 16 : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#clip0_14_12063)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.4099 10.9757C10.2135 11.0576 9.98162 11.301 9.75738 11.5364C9.35432 11.9596 8.89743 12.4393 8.26148 12.4393C7.62554 12.4393 7.16865 11.9596 6.76559 11.5364C6.54138 11.301 6.30952 11.0576 6.11311 10.9757C5.89978 10.8868 5.55097 10.8924 5.21364 10.8976C5.16858 10.8984 5.123 10.8991 5.07715 10.8996V14.5606C5.07715 14.7081 5.15115 14.8457 5.2742 14.9271C5.39722 15.0085 5.5529 15.0227 5.6886 14.965L8.26151 13.8707L10.8344 14.965C10.8896 14.9885 10.9481 15 11.0063 15C11.0913 15 11.1758 14.9754 11.2488 14.9271C11.3718 14.8457 11.4458 14.7081 11.4458 14.5606V10.8996C11.4 10.899 11.3544 10.8983 11.3093 10.8976C10.9721 10.8923 10.6232 10.8868 10.4099 10.9757Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.0239 5.78019C14.0239 5.52073 13.7042 5.2152 13.3952 4.91974C13.094 4.63181 12.7825 4.33409 12.6305 3.96583C12.4722 3.58213 12.481 3.13957 12.4895 2.71154C12.4978 2.29482 12.5064 1.86395 12.3396 1.69635C12.1722 1.52815 11.7408 1.53504 11.3235 1.54151C10.8962 1.54831 10.4545 1.55522 10.0722 1.39594C9.70504 1.24292 9.40832 0.931406 9.12136 0.630117C8.82634 0.320361 8.52124 0 8.26193 0C8.00263 0 7.69753 0.320361 7.40248 0.630147C7.11552 0.931406 6.8188 1.24295 6.45165 1.39594C6.06935 1.55525 5.62768 1.54831 5.20026 1.54154C4.78313 1.53495 4.35168 1.52821 4.18428 1.69635C4.01746 1.86398 4.02604 2.29485 4.03434 2.71151C4.04286 3.13954 4.05168 3.58216 3.89333 3.96586C3.74137 4.33406 3.42994 4.63178 3.12871 4.91974C2.81963 5.2152 2.5 5.52073 2.5 5.78019C2.5 6.03961 2.8196 6.34515 3.12868 6.6406C3.42991 6.92853 3.74137 7.22628 3.89336 7.59454C4.05168 7.97824 4.04289 8.4208 4.03436 8.84883C4.02607 9.26555 4.01749 9.69641 4.18431 9.86402C4.35171 10.0322 4.7831 10.0255 5.20029 10.0188C5.28678 10.0175 5.37391 10.0161 5.46095 10.0161C5.80401 10.0161 6.14673 10.0374 6.45165 10.1644C6.8188 10.3174 7.11552 10.6289 7.40248 10.9302C7.69753 11.24 8.00263 11.5603 8.26193 11.5603C8.52124 11.5603 8.82634 11.24 9.12139 10.9302C9.40835 10.629 9.70507 10.3174 10.0722 10.1644C10.4545 10.0051 10.8964 10.0122 11.3236 10.0188C11.7407 10.0254 12.1722 10.0322 12.3396 9.86399C12.5064 9.69636 12.4978 9.26549 12.4895 8.84886C12.481 8.42083 12.4722 7.97821 12.6305 7.59451C12.7825 7.22631 13.0939 6.92856 13.3952 6.6406C13.7043 6.34515 14.0239 6.03961 14.0239 5.78019ZM8.9141 6.19565C9.56628 4.56522 6.6315 7.48837 6.6315 5.74515C6.6315 4.00192 6.52351 4.23913 8.26193 4.23913C10.0004 4.23913 5.20026 3.47417 5.20026 5.21739C5.20026 6.96061 10.6525 6.19565 8.9141 6.19565Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "8.28687",
                        cy: "5.53101",
                        r: "2.60132",
                        fill: "#F1F1F1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.26174 1.95654C6.28392 1.95654 4.6748 3.56562 4.6748 5.54348C4.6748 7.52134 6.28392 9.13046 8.26174 9.13046C10.2396 9.13046 11.8487 7.52134 11.8487 5.54348C11.8487 3.56562 10.2396 1.95654 8.26174 1.95654ZM10.3214 4.93762L8.06793 7.19111C7.97212 7.28693 7.84475 7.33966 7.70925 7.33966C7.57376 7.33966 7.44639 7.28693 7.35057 7.19111L6.20206 6.0426C6.10624 5.94678 6.05347 5.81941 6.05347 5.68391C6.05347 5.54838 6.10624 5.42101 6.20206 5.32519C6.29784 5.22938 6.42521 5.1766 6.56074 5.1766C6.69624 5.1766 6.82364 5.22938 6.91942 5.32523L7.70921 6.11498L9.60399 4.22021C9.6998 4.1244 9.82717 4.07166 9.96267 4.07166C10.0982 4.07166 10.2255 4.1244 10.3214 4.22021C10.5192 4.41806 10.5192 4.73984 10.3214 4.93762Z",
                        fill: "black"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_14_12063",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "15",
                        fill: "white",
                        transform: "translate(0.5)"
                    })
                })
            })
        ]
    });
};
var UncheckedIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
            cx: "9",
            cy: "9",
            r: "8.5",
            fill: "white",
            stroke: "black"
        })
    });
};
var CheckedIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "9",
                cy: "9",
                r: "8.5",
                fill: "white",
                stroke: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "9",
                cy: "9",
                r: "5",
                fill: color
            })
        ]
    });
};
var PickupIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "15",
        viewBox: "0 0 17 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16.8606 4.37849L15.8169 1.3195C15.5476 0.530298 14.8132 0 13.9896 0H3.01043C2.18679 0 1.45237 0.530298 1.18307 1.3195L0.139379 4.37849C-0.108522 5.10486 -0.0229276 5.84556 0.373755 6.41024C0.781339 6.99048 1.47599 7.32306 2.27965 7.32306C3.06776 7.32306 3.8583 7.00296 4.46695 6.46673C4.93692 7.0003 5.64267 7.32306 6.42655 7.32306C7.21931 7.32306 7.96402 7.00419 8.49999 6.46734C9.03597 7.00419 9.78089 7.32306 10.5734 7.32306C11.3575 7.32306 12.0633 7.0003 12.5332 6.46673C13.0345 6.90848 13.6596 7.20013 14.3049 7.29039V12.596C14.3049 13.228 13.7974 13.7425 13.1736 13.7425H11.0115V10.9279C11.0115 9.58527 9.93431 8.49316 8.60981 8.49316H8.42793C7.10363 8.49316 6.02623 9.58527 6.02623 10.9279V13.7425H3.82621C3.20262 13.7425 2.69511 13.228 2.69511 12.596V8.85501C2.69511 8.50789 2.41753 8.22627 2.07495 8.22627C1.73237 8.22627 1.45479 8.50789 1.45479 8.85501V12.596C1.45479 13.9214 2.51867 15 3.82621 15H6.64639H10.3914H13.1736C14.4813 15 15.5452 13.9214 15.5452 12.596V7.19384C15.991 7.04699 16.367 6.77921 16.6264 6.41024C17.0229 5.84535 17.1085 5.10486 16.8606 4.37849ZM7.26654 13.7425V10.9279C7.26654 10.2787 7.78758 9.75064 8.42793 9.75064H8.60981C9.25036 9.75064 9.7712 10.2787 9.7712 10.9279V13.7425H7.26654ZM15.6159 5.6808C15.4414 5.92886 15.1237 6.06558 14.7203 6.06558C14.0441 6.06558 13.3339 5.66115 12.9531 5.05901C12.8381 4.87706 12.6406 4.76961 12.4311 4.76961C12.4028 4.76961 12.3746 4.77166 12.3459 4.77555C12.1061 4.80932 11.9078 4.98124 11.8376 5.21599C11.6833 5.73217 11.1871 6.06558 10.5734 6.06558C9.92906 6.06558 9.32142 5.6896 9.061 5.13003C8.95845 4.91001 8.74002 4.76961 8.49999 4.76961C8.25997 4.76961 8.04154 4.91001 7.93919 5.13003C7.67857 5.6896 7.07073 6.06558 6.42655 6.06558C5.81305 6.06558 5.31684 5.73197 5.16241 5.21599C5.09216 4.98124 4.89372 4.80932 4.65409 4.77555C4.41386 4.74321 4.17726 4.85271 4.04665 5.05922C3.66632 5.66115 2.95613 6.06558 2.27965 6.06558C1.87651 6.06558 1.55835 5.92886 1.38393 5.6808C1.22062 5.44809 1.19478 5.13167 1.31146 4.78946L2.35515 1.73068C2.45185 1.44763 2.71509 1.25749 3.01043 1.25749H13.9896C14.2847 1.25749 14.5479 1.44763 14.6444 1.73048L15.6881 4.78967C15.8052 5.13167 15.7794 5.44809 15.6159 5.6808Z",
            fill: "black"
        })
    });
};

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/Components/OrderTypeSelector/index.tsx














var OrderTypeSelector = function() {
    var ref, ref1;
    var ref2 = (0,react.useContext)(CartContext/* CartContext */.A), _showAuthModal = ref2.showAuthModal, showAuthModal = _showAuthModal === void 0 ? null : _showAuthModal;
    var dispatch = (0,es/* useDispatch */.I0)();
    var themeColor = (0,getThemeColor/* getThemeColor */.p)() || "#000000";
    var storeInfo = (0,redux/* useSSRSelector */.kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    var ref3 = (0,es/* useSelector */.v9)(function(state) {
        return {
            cart: state.cartReducer,
            userData: state.userReducer
        };
    }), cart = ref3.cart, userData = ref3.userData;
    var ref4 = (0,react.useState)({
        show: false,
        text: ""
    }), toastState = ref4[0], setToastState = ref4[1];
    (0,react.useEffect)(function() {
        var ref;
        if (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.delivery_flag) {
            var ref1, ref2;
            if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.min_order_value) > 0 && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.services) === null || ref2 === void 0 ? void 0 : ref2.min_order_value) > cart.items_total) {
                var ref3;
                if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.services) === null || ref3 === void 0 ? void 0 : ref3.pickup_flag) === 0) {
                    var ref4;
                    onCartDeliveryInfoHandle("Shop for ₹".concat((storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.services) === null || ref4 === void 0 ? void 0 : ref4.min_order_value) - cart.items_total, " more for home delivery"));
                } else {
                    if (cart.order_type === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY) {
                        togglePickupDeliverySwitch(constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP);
                    }
                }
            }
        }
    }, []);
    var onCartDeliveryInfoHandle = function(text) {
        setToastState({
            show: true,
            text: text
        });
        setTimeout(function() {
            setToastState({
                show: false,
                text: ""
            });
        }, 3000);
    };
    /**
   * Helper function to return a
   * delivery charge
   * @param {string} orderTypeCheck
   * @return {number}
   */ var togglePickupDeliverySwitch = function(value) {
        var ref;
        if (value === cart.order_type) {
            return;
        }
        if (value === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP && (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.services.pickup_flag) === 0) {
            onCartDeliveryInfoHandle("We are not accepting pickup orders right now");
            return;
        }
        if (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.delivery_flag) {
            var ref1, ref2;
            if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.min_order_value) > 0 && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.services) === null || ref2 === void 0 ? void 0 : ref2.min_order_value) > cart.pay_amount && value === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY) {
                var ref3;
                onCartDeliveryInfoHandle("Shop for ₹".concat((storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.services) === null || ref3 === void 0 ? void 0 : ref3.min_order_value) - cart.pay_amount, " more for home delivery"));
            } else {
                dispatch((0,actions_cart/* setCart */.RV)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cart), {
                    order_type: value,
                    store_id: storeInfo.store_id,
                    user_phone: cart.phone,
                    cart_id: cart.cart_id
                })));
            }
        } else {
            onCartDeliveryInfoHandle("Store is currently not delivering to your area");
        }
    };
    var switchesData = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingTruck, {}),
            heading: "Deliver this to an address",
            desc: "Get estimated delivery time after you add the address",
            value: constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY,
            isActive: cart.order_type === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PickupIcon, {}),
            heading: "Pickup from store",
            desc: "Check with store if pickup is available today",
            value: constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP,
            isActive: cart.order_type === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP
        }, 
    ];
    return !!(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.pickup_flag) && !!(storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.delivery_flag) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-relative tw-border-t tw-border-solid tw-border-[#E2E2E2] md:tw-border-none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-mx-[16px] tw-mb-[8px] tw-mt-[16px] tw-flex tw-flex-col tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid md:tw-mx-0 md:tw-mb-0 md:tw-flex-row",
                style: {
                    borderColor: themeColor
                },
                children: switchesData.map(function(data, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-1 tw-cursor-pointer tw-flex-row-reverse tw-justify-between tw-gap-[16px] tw-border-b tw-border-solid tw-border-[#E2E2E2] tw-px-[20px] tw-py-[20px] md:tw-flex-row md:tw-justify-start md:tw-border-r md:tw-py-[24px] ".concat(data.isActive ? "tw-bg-[#F7F7F7]" : ""),
                        onClick: function() {
                            !(userData === null || userData === void 0 ? void 0 : userData.isLogin) ? showAuthModal === null || showAuthModal === void 0 ? void 0 : showAuthModal() : togglePickupDeliverySwitch(data.value);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    color: themeColor
                                },
                                children: data.isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckedIcon, {
                                    color: themeColor
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UncheckedIcon, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex tw-h-fit tw-items-center tw-gap-[12px]",
                                children: [
                                    !checkClientDeviceType/* IS_DESKTOP */.yn && data.icon,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-flex tw-flex-col tw-gap-[4px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "tw-m-0 tw-text-sm ".concat(data.isActive ? "tw-font-semibold" : "tw-font-medium"),
                                                children: data.heading
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "tw-m-0 tw-hidden tw-text-xs tw-text-[#666666] md:tw-block",
                                                children: data.desc
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            }),
            toastState.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartDeliveryTooltip, {
                children: toastState.text
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: toastState.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartDeliveryTooltip, {
            children: toastState.text
        })
    });
};
/* harmony default export */ var Components_OrderTypeSelector = (OrderTypeSelector);

// EXTERNAL MODULE: ./node_modules/lodash/capitalize.js
var capitalize = __webpack_require__(548403);
var capitalize_default = /*#__PURE__*/__webpack_require__.n(capitalize);
// EXTERNAL MODULE: ./src/utils/getContactDetails.js
var getContactDetails = __webpack_require__(160492);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/Components/TabPickup/index.tsx







var TabPickup = function(props) {
    var getPickupAvailableText = function getPickupAvailableText() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "tw-m-0 tw-flex tw-pt-[12px] tw-text-xs tw-italic md:tw-p-0",
            children: "Check with store if pickup is available today"
        });
    };
    var ref;
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    });
    var ref1 = (0,getContactDetails/* default */.ZP)(storeData, true), storeAddress = ref1.storeAddress, storePhone = ref1.storePhone;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-mb-[16px] tw-rounded-lg md:tw-border ".concat(props.showTopBorderMobile ? "tw-border-t tw-border-solid" : "tw-bodrer-none", " tw-border-[#EAEAEC] md:tw-mb-0 md:tw-mt-[16px]   md:tw-border-solid"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-items-center tw-justify-between tw-px-[16px] tw-py-[20px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "tw-flex tw-items-center tw-gap-[12px] tw-text-[16px] tw-font-semibold md:tw-text-sm md:tw-font-medium",
                        children: [
                            checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsx)(PickupIcon, {}),
                            "Store Location"
                        ]
                    }),
                    checkClientDeviceType/* IS_DESKTOP */.yn && getPickupAvailableText()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-px-[16px] md:tw-border-t md:tw-border-solid md:tw-border-[#EAEAEC] md:tw-px-[32px] md:tw-pb-[24px] md:tw-pt-[24px] ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-gap-[12px] tw-rounded-lg tw-border tw-border-solid tw-border-[#E2E2E2] tw-pt-[12px] md:tw-border-none md:tw-p-0 ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-gap-[4px] tw-px-[16px] md:tw-p-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-m-0 tw-text-sm",
                                    children: capitalize_default()((ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.name)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-m-0 tw-text-sm tw-text-[#7D7D7D]",
                                    children: storePhone
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-m-0 tw-text-sm tw-text-[#7D7D7D]",
                                    children: storeAddress
                                }),
                                !checkClientDeviceType/* IS_DESKTOP */.yn && getPickupAvailableText()
                            ]
                        }),
                        !checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-flex tw-divide-x tw-border-t tw-border-solid tw-border-[#E2E2E2] md:tw-flex-row-reverse md:tw-gap-[16px] md:tw-border-none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "tw-flex tw-flex-1 tw-cursor-pointer tw-justify-center tw-border-r tw-border-solid tw-border-[#E2E2E2] tw-px-[16px] tw-py-[12px] tw-text-sm tw-font-semibold tw-no-underline last:tw-border-none md:tw-flex-none md:tw-border-none md:tw-p-0",
                                style: {
                                    color: (0,getThemeColor/* getThemeColor */.p)()
                                },
                                href: "tel:".concat(storePhone),
                                children: "Call Store"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Components_TabPickup = (TabPickup);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartAdditionalInfo/CartAdditionalInfo.js














function CheckoutAdditionalInfo(props) {
    var getOrderTypeText = function getOrderTypeText() {
        switch(cartData === null || cartData === void 0 ? void 0 : cartData.order_type){
            case constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP:
                return "Pickup Order";
            case constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY:
                return "Delivery Order";
            default:
                return null;
        }
    };
    var ref, ref1, ref2;
    var cartData = (0,es/* useSelector */.v9)(function(state) {
        return state.cartReducer;
    });
    var storeInfo = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    });
    var shouldShowAddressField = (cartData === null || cartData === void 0 ? void 0 : cartData.order_type) === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY || (0,isStoreServiceBased/* isStoreServiceBased */.A)() && isAddressMandatoryForService();
    var shouldShowPickuptab = (cartData === null || cartData === void 0 ? void 0 : cartData.order_type) === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP;
    var showTopBorderMobile = !(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.pickup_flag) || !(storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.delivery_flag);
    var _renderAddressField = function() {
        return shouldShowAddressField ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TabAddress, {
            showTopBorderMobile: showTopBorderMobile
        }) : null;
    };
    var _renderPickupTab = function() {
        return shouldShowPickuptab ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_TabPickup, {
            showTopBorderMobile: shouldShowAddressField
        }) : null;
    };
    var selectedOrderTypeText = getOrderTypeText();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutAdditionalInfoContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutAdditionalInfoHeaderContainer, {
                    children: !!((ref2 = props.allItems) === null || ref2 === void 0 ? void 0 : ref2.length) && checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartOption, {
                        className: "tw-flex tw-items-center tw-justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                children: "Cart"
                            }),
                            selectedOrderTypeText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                className: "!tw-text-sm !tw-font-medium",
                                children: selectedOrderTypeText
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckoutAdditionalInfoTabContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPromo, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-gap-[]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_OrderTypeSelector, {}),
                                _renderPickupTab(),
                                _renderAddressField()
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabOrderInstruction, {})
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var CartAdditionalInfo = (CheckoutAdditionalInfo);

// EXTERNAL MODULE: ./src/utils/useIsComponentMounted.js
var useIsComponentMounted = __webpack_require__(471778);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/components/ProductCustomizationPopUp/index.js + 7 modules
var ProductCustomizationPopUp = __webpack_require__(924648);
// EXTERNAL MODULE: ./src/assets/svgExports/ZeroCart.js
var ZeroCart = __webpack_require__(786350);
// EXTERNAL MODULE: ./src/utils/canDisablePlaceOrder.ts
var canDisablePlaceOrder = __webpack_require__(596930);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/EmptyCartView/index.tsx












var EmptyCartView = function() {
    var ref, ref1;
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var ref2 = (0,redux/* useSSRSelector */.kF)(function(state) {
        var ref, ref1, ref2, ref3;
        return {
            storeInfo: state.storeReducer.store,
            isWishlistItemPresentOnStore: (ref = state.wishlistReducer) === null || ref === void 0 ? void 0 : ref.wishlistItemCount,
            wishlistFeatureActive: (ref1 = state.storeReducer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.store) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.services) === null || ref3 === void 0 ? void 0 : ref3.wishlist_flag
        };
    }), storeInfo = ref2.storeInfo, isWishlistItemPresentOnStore = ref2.isWishlistItemPresentOnStore, wishlistFeatureActive = ref2.wishlistFeatureActive;
    var shopButtonClick = function() {
        var ref;
        if ((0,canDisablePlaceOrder/* canDisablePlaceOrder */.w)()) {
            return;
        }
        router_default().push((0,routes.getRoute)(routes.PATH.PRODUCT, storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    var addFromWishlistCtaClick = function() {
        var ref;
        router_default().push((0,routes.getRoute)(routes.PATH.WISHLIST, storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoItemInCart, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoItemInCartSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ZeroCart/* ZeroCart */.N, {
                        height: deviceWidth/* deviceWidth */.o >= 767 ? 184.32 : 123,
                        width: deviceWidth/* deviceWidth */.o >= 767 ? 226.77 : 151
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NoItemInCartText, {
                        children: "Your cart is empty, Go ahead and add something to the cart"
                    })
                ]
            }),
            isWishlistItemPresentOnStore && wishlistFeatureActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                py: "18px",
                mb: "13px",
                width: checkClientDeviceType/* IS_DESKTOP */.yn ? "252px" : "180px",
                fontColor: themeColor,
                roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : ref.roundness,
                backgroundColor: "#ffffff",
                borderColor: themeColor,
                label: "Add from Wishlist",
                variant: "solid",
                fontSize: checkClientDeviceType/* IS_DESKTOP */.yn ? "16px" : "15px",
                onClick: addFromWishlistCtaClick
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                width: checkClientDeviceType/* IS_DESKTOP */.yn ? "252px" : "180px",
                py: "18px",
                fontColor: "#ffffff",
                roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : ref1.roundness,
                backgroundColor: themeColor,
                label: (0,getCustomCtaText/* default */.Z)("cart_cta"),
                variant: "solid",
                fontSize: checkClientDeviceType/* IS_DESKTOP */.yn ? "16px" : "15px",
                onClick: shopButtonClick
            })
        ]
    });
};
/* harmony default export */ var Components_EmptyCartView = (EmptyCartView);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartItemsAndCheckout/CartItemsAndCheckoutSectionHeading.tsx





var CartItemsAndCheckoutSectionHeading = function(param) {
    var showSummary = param.showSummary, hanldeSummary = param.hanldeSummary, _summeryClasses = param.summeryClasses, summeryClasses = _summeryClasses === void 0 ? "" : _summeryClasses, _showDropdown = param.showDropdown, showDropdown = _showDropdown === void 0 ? false : _showDropdown;
    return !checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemHeading, {
        onClick: function() {
            return showDropdown && hanldeSummary();
        },
        showSummery: showSummary,
        showDropdown: showDropdown,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSummary, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSummaryText, {
                    className: "".concat(showDropdown ? "tw-text-[18px]/[22px]" : "tw-text-[16px]/[20px]", " tw-font-semibold md:tw-font-medium ").concat(summeryClasses),
                    children: (0,getCustomCtaText/* default */.Z)("order_summary_heading")
                })
            }),
            !checkClientDeviceType/* IS_DESKTOP */.yn && showDropdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalDropDownArrowContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrowSummary, {
                    showOrderSummary: showSummary,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDown, {})
                })
            })
        ]
    });
};
/* harmony default export */ var CartItemsAndCheckout_CartItemsAndCheckoutSectionHeading = (CartItemsAndCheckoutSectionHeading);

// EXTERNAL MODULE: ./src/assets/svgExports/DropDownArrow.js
var DropDownArrow = __webpack_require__(972193);
;// CONCATENATED MODULE: ./src/hooks/useOnScrollDownCta.js

/**
 * This Custom Hook Calculates if an Overflow div
 * is Scrolled To the end by User. USed in Cart.
 * @param {*} props
 * @returns -> False : When User reaches end of the Div. else False.
 */ function useOnScrollDownCta(props) {
    var removeScrollEventListener = function removeScrollEventListener() {
        var ref;
        referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref = referenceToCheckScrollHeight.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("scroll", checkIfScrolledDown);
    };
    var removeClickEvent = function removeClickEvent() {
        var ref;
        referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref = referenceToCheckScrollHeight.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", checkScrollHeight);
    };
    var checkScrollHeight = function checkScrollHeight() {
        var ref;
        if ((referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref = referenceToCheckScrollHeight.current) === null || ref === void 0 ? void 0 : ref.scrollHeight) < 700) {
            setShowScrollDownHelper(false);
            removeScrollEventListener();
            removeClickEvent();
        }
    };
    var checkIfScrolledDown = function checkIfScrolledDown() {
        var ref, ref1, ref2;
        if ((referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref = referenceToCheckScrollHeight.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) + (referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref1 = referenceToCheckScrollHeight.current) === null || ref1 === void 0 ? void 0 : ref1.scrollTop) + 20 >= (referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref2 = referenceToCheckScrollHeight.current) === null || ref2 === void 0 ? void 0 : ref2.scrollHeight)) {
            setShowScrollDownHelper(false);
            removeScrollEventListener();
            removeClickEvent();
        }
    };
    var ref = (0,react.useState)(true), showScrollDownHelper = ref[0], setShowScrollDownHelper = ref[1];
    var referenceToCheckScrollHeight = props.referenceToCheckScrollHeight;
    (0,react.useEffect)(function() {
        var ref, ref1;
        referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref = referenceToCheckScrollHeight.current) === null || ref === void 0 ? void 0 : ref.addEventListener("scroll", checkIfScrolledDown);
        checkIfScrolledDown();
        referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref1 = referenceToCheckScrollHeight.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", checkScrollHeight);
        return function() {
            removeScrollEventListener();
            removeClickEvent();
        };
    }, []);
    return showScrollDownHelper;
}

;// CONCATENATED MODULE: ./src/components/Scroll/Scroll.styles.js

function Scroll_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  position: sticky;\n  bottom: 2%;\n  left: 40%;\n"
    ]);
    Scroll_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Scroll_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #383838;\n  opacity: 0.76;\n  display: flex;\n  justify-content: center;\n  max-width: 10vw;\n  border-radius: 18px;\n"
    ]);
    Scroll_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Scroll_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: 12px;\n  padding: 10px 16px 10px 16px;\n  color: white;\n"
    ]);
    Scroll_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Scroll_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-left: 9px;\n  margin-top: 4px;\n"
    ]);
    Scroll_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var ScrollContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScrollContainer",
    componentId: "sc-1ab23cfb-0"
})(Scroll_styles_templateObject());
var ScrollButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScrollButton",
    componentId: "sc-1ab23cfb-1"
})(Scroll_styles_templateObject1());
var ScrollTextIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScrollTextIconContainer",
    componentId: "sc-1ab23cfb-2"
})(Scroll_styles_templateObject2());
var ScrollIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScrollIcon",
    componentId: "sc-1ab23cfb-3"
})(Scroll_styles_templateObject3());

;// CONCATENATED MODULE: ./src/components/Scroll/Scroll.js






/**
 * Scroll Tab Provides User With Information That
 * current List of Items is Scrollable
 * removes after list is scrolled to the end.
 * @param {*} referenceToCheckScrollHeight
 * @returns
 */ function Scroll(referenceToCheckScrollHeight) {
    var showScrollDownHelper = useOnScrollDownCta(referenceToCheckScrollHeight);
    if (deviceWidth/* deviceWidth */.o < 767) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showScrollDownHelper && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollButton, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollTextIconContainer, {
                    children: [
                        "Scroll",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollIcon, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrow/* DropDownArrow */.s, {
                                fillColor: "#ffffff",
                                width: 9,
                                height: 5
                            })
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var Scroll_Scroll = (Scroll);

// EXTERNAL MODULE: ./src/utils/getDiscountPercentage.js
var getDiscountPercentage = __webpack_require__(153716);
// EXTERNAL MODULE: ./src/utils/mutateItemObjectWithCartData.js
var mutateItemObjectWithCartData = __webpack_require__(822787);
// EXTERNAL MODULE: ./src/utils/mutateVariantItemWithCartData.js
var mutateVariantItemWithCartData = __webpack_require__(759186);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/redux/actions/logs.js
var logs = __webpack_require__(467936);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/CartButton/index.js + 2 modules
var CartButton = __webpack_require__(891815);
// EXTERNAL MODULE: ./src/config/index.js
var config = __webpack_require__(477733);
;// CONCATENATED MODULE: ./src/components/DesignSystem/CartItem/styles.js

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  box-sizing: border-box;\n  :last-child {\n    border-bottom: none;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-wrap: nowrap;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-fit: cover;\n  margin-right: 10px;\n  border: 0.5px solid #d9d9d9;\n  padding: 2px;\n  border-radius: 8px;\n\n  & > img {\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n  }\n\n  @media screen and (min-width: 767px) {\n    width: 64px;\n    height: 64px;\n  }\n\n  @media screen and (max-width: 766px) {\n    width: 67px;\n    height: 67px;\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 10px;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  height: fit-content;\n  min-width: 12vw;\n  @media screen and (max-width: 767px) {\n    min-width: 38vw;\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  min-height: 15px;\n  height: fit-content;\n  margin-bottom: 7px;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #000000;\n\n  @media screen and (min-width: 767px) {\n    font-size: 14px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 13px;\n  }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  font-weight: 300;\n  padding-bottom: 6px;\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  @media screen and (min-width: 767px) {\n    flex-direction: row;\n  }\n\n  @media screen and (max-width: 766px) {\n    flex-direction: column;\n  }\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0;\n  margin-bottom: 4.5px;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row wrap;\n  flex: 0;\n  width: fit-content;\n  font-size: 12px;\n  font-weight: 400;\n  margin: 0;\n  margin-right: 10px;\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n\n  & > p {\n    font-size: 12px;\n    margin: 0 0 2px 0;\n    word-break: break-all;\n\n    &.heading {\n      color: #808080;\n    }\n\n    &:not(.heading) {\n      cursor: pointer;\n    }\n  }\n\n  @media screen and (min-width: 767px) {\n    max-width: 380px;\n\n    & > p {\n      margin: 0 0 4px 0;\n    }\n  }\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #000000;\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: rgba(112, 112, 112, 0.43);\n  text-decoration: line-through;\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  text-transform: uppercase;\n  color: #0dbf44;\n  margin: 0;\n  @media screen and (min-width: 767px) {\n    width: 5vw;\n  }\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  text-align: right;\n  height: fit-content;\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  height: fit-content;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  color: #7e7e7e;\n  font-size: 12px;\n  margin-top: 4px;\n"
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 24px;\n"
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}

var Item = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "Item",
    componentId: "sc-b16f4d97-0"
})(styles_templateObject());
var ItemInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemInfo",
    componentId: "sc-b16f4d97-1"
})(styles_templateObject1());
var ItemImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemImage",
    componentId: "sc-b16f4d97-2"
})(styles_templateObject2());
var ItemDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemDetails",
    componentId: "sc-b16f4d97-3"
})(styles_templateObject3());
var ItemName = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "ItemName",
    componentId: "sc-b16f4d97-4"
})(styles_templateObject4());
var ItemVariantName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemVariantName",
    componentId: "sc-b16f4d97-5"
})(styles_templateObject5());
var ItemSub = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemSub",
    componentId: "sc-b16f4d97-6"
})(styles_templateObject6());
var ItemPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemPrice",
    componentId: "sc-b16f4d97-7"
})(styles_templateObject7());
var AmountText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "AmountText",
    componentId: "sc-b16f4d97-8"
})(styles_templateObject8());
var ItemRemarksWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemRemarksWrapper",
    componentId: "sc-b16f4d97-9"
})(styles_templateObject9());
var DiscountedPrice = (0,styled_components_browser_esm/* default */.ZP)(AmountText).withConfig({
    displayName: "DiscountedPrice",
    componentId: "sc-b16f4d97-10"
})(styles_templateObject10());
var ActualPrice = (0,styled_components_browser_esm/* default */.ZP)(AmountText).withConfig({
    displayName: "ActualPrice",
    componentId: "sc-b16f4d97-11"
})(styles_templateObject11());
var ItemDiscount = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "ItemDiscount",
    componentId: "sc-b16f4d97-12"
})(styles_templateObject12());
var ItemTotalValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemTotalValue",
    componentId: "sc-b16f4d97-13"
})(styles_templateObject13());
var CartButtonItemValueContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CartButtonItemValueContainer",
    componentId: "sc-b16f4d97-14"
})(styles_templateObject14());
var DeliveryCharges = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DeliveryCharges",
    componentId: "sc-b16f4d97-15"
})(styles_templateObject15());
var styles_ItemContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ItemContainer",
    componentId: "sc-b16f4d97-16"
})(styles_templateObject16());

// EXTERNAL MODULE: ./src/redux/store/index.js + 44 modules
var store = __webpack_require__(167261);
;// CONCATENATED MODULE: ./src/utils/removeItemFromCart.js




/**
 * removes a itemId from cart.
 */ function removeItemFromCart(productItem) {
    var ref;
    var cartData = store/* default.getState */.Z.getState().cartReducer;
    var items = cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
        return (productItem === null || productItem === void 0 ? void 0 : productItem.item_id) !== (item === null || item === void 0 ? void 0 : item.item_id);
    });
    var newCart = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartData), {
        items: items
    });
    store/* default.dispatch */.Z.dispatch((0,actions_cart/* setCart */.RV)(newCart));
}

;// CONCATENATED MODULE: ./src/assets/svgExports/SimpleCloseIcon.js

var SimpleCloseIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "8",
        height: "8",
        viewBox: "0 0 8 8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "Icon_material-close",
            "data-name": "Icon material-close",
            d: "M15.5,8.306,14.694,7.5,11.5,10.694,8.306,7.5,7.5,8.306,10.694,11.5,7.5,14.694l.806.806L11.5,12.306,14.694,15.5l.806-.806L12.306,11.5Z",
            transform: "translate(-7.5 -7.5)",
            fill: "#fc3d3d"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/CartRemoveCta/CartRemoveCta.styles.js

function CartRemoveCta_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  cursor: pointer;\n  margin-left: ",
        "px;\n  margin-right: ",
        "px;\n  margin-top: ",
        "px;\n  margin-bottom: ",
        "px;\n"
    ]);
    CartRemoveCta_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartRemoveCta_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-left: ",
        "px;\n  margin-right: ",
        "px;\n  margin-top: ",
        "px;\n  margin-bottom: ",
        "px;\n"
    ]);
    CartRemoveCta_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CartRemoveCta_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: ",
        "px;\n  color: #fc3d3d;\n"
    ]);
    CartRemoveCta_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var CartRemoveCtaContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CartRemoveCtaContainer",
    componentId: "sc-a4e39d4-0"
})(CartRemoveCta_styles_templateObject(), function(props) {
    return props.customStyles.ml;
}, function(props) {
    return props.customStyles.mr;
}, function(props) {
    return props.customStyles.mt;
}, function(props) {
    return props.customStyles.mb;
});
var CartRemoveIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CartRemoveIcon",
    componentId: "sc-a4e39d4-1"
})(CartRemoveCta_styles_templateObject1(), function(props) {
    return props.mli || 0;
}, function(props) {
    return props.mri || 0;
}, function(props) {
    return props.mti || 0;
}, function(props) {
    return props.mbi || 0;
});
var CartRemoveText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CartRemoveText",
    componentId: "sc-a4e39d4-2"
})(CartRemoveCta_styles_templateObject2(), function(props) {
    return props.fontSize || 12;
});

;// CONCATENATED MODULE: ./src/components/CartRemoveCta/CartRemoveCta.js





function CartRemoveCta(props) {
    var handleRemoveCta = function handleRemoveCta() {
        removeItemFromCart(props === null || props === void 0 ? void 0 : props.item);
        (0,triggerGetServiceableAddressId/* triggerGetServiceableAddressId */.o)();
    };
    var cartRemoveCtaContainerStyles = {
        ml: props.ml ? props.ml : 0,
        mt: props.mt ? props.mt : 0,
        mb: props.mb ? props.mb : 0,
        mr: props.mr ? props.mr : 0
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartRemoveCtaContainer, {
        customStyles: cartRemoveCtaContainerStyles,
        onClick: handleRemoveCta,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartRemoveIcon, {
                mti: 2,
                mri: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleCloseIcon, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartRemoveText, {
                fontSize: props.fontSize,
                children: "Remove"
            })
        ]
    });
}
/* harmony default export */ var CartRemoveCta_CartRemoveCta = (CartRemoveCta);

// EXTERNAL MODULE: ./src/hooks/useCartHandler.js
var useCartHandler = __webpack_require__(491240);
// EXTERNAL MODULE: ./src/hooks/useSetWishlistState.tsx
var useSetWishlistState = __webpack_require__(106531);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(506337);
// EXTERNAL MODULE: ./src/components/ProductCustomizationPopUp/components/ReadMoreReadLess.js
var ReadMoreReadLess = __webpack_require__(719976);
;// CONCATENATED MODULE: ./src/components/DesignSystem/CartItem/ItemPersonalizationDetails.js


var ItemPersonalizationDetails = function(param) {
    var storeData = param.storeData, personalizationsData = param.personalizationsData, handleEditClick = param.handleEditClick;
    var ref;
    if (!(personalizationsData === null || personalizationsData === void 0 ? void 0 : personalizationsData.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-mt-[16px] tw-flex tw-flex-col tw-gap-3 xs:tw-w-[90vw] md:tw-min-w-[100%] md:tw-max-w-[20vw]",
        children: personalizationsData === null || personalizationsData === void 0 ? void 0 : (ref = personalizationsData.map) === null || ref === void 0 ? void 0 : ref.call(personalizationsData, function(data, idx) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "tw-flex tw-gap-[0.5rem]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "tw-text-[12px] tw-font-normal tw-text-[#242121] md:tw-text-[0.875rem]",
                                        children: [
                                            " ",
                                            "Personalisation details",
                                            " "
                                        ]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "tw-text-[12px] tw-font-normal tw-text-[#868686] md:tw-text-[0.875rem]",
                                        children: [
                                            "(Qty: ",
                                            data === null || data === void 0 ? void 0 : data.quantity,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-ml-auto tw-cursor-pointer tw-text-[12px] tw-font-semibold tw-leading-5 tw-text-[#1F1F1F] md:tw-text-[0.875rem]",
                                style: {
                                    color: (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) || "#1F1F1F"
                                },
                                onClick: function() {
                                    return handleEditClick(data, idx);
                                },
                                children: "Edit"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-[0.75rem] tw-flex tw-flex-col tw-gap-[0.5rem]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-gap-[16px]",
                            children: [
                                !!(data === null || data === void 0 ? void 0 : (ref2 = data.images) === null || ref2 === void 0 ? void 0 : ref2.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex tw-flex-col tw-gap-[6px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-text-[0.75rem] tw-font-normal tw-text-[#4E4E4E]",
                                            children: "Image"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-flex tw-flex-wrap tw-gap-[0.625rem]",
                                            children: data === null || data === void 0 ? void 0 : (ref3 = data.images) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.map) === null || ref4 === void 0 ? void 0 : ref4.call(ref3, function(imgUrl, idx) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: imgUrl,
                                                    alt: "".concat(imgUrl, "-image"),
                                                    className: "tw-rounded",
                                                    width: "40px",
                                                    height: "40px",
                                                    style: {
                                                        border: "1px solid #eaeaec"
                                                    }
                                                }, idx);
                                            })
                                        })
                                    ]
                                }),
                                !!(data === null || data === void 0 ? void 0 : (ref5 = data.texts) === null || ref5 === void 0 ? void 0 : ref5.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex tw-flex-col tw-gap-[2px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-text-[0.75rem] tw-font-normal tw-text-[#4E4E4E]",
                                            children: "Text"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMoreReadLess/* default */.Z, {
                                            text: (data === null || data === void 0 ? void 0 : (ref6 = data.texts) === null || ref6 === void 0 ? void 0 : ref6[0]) || "",
                                            color: "#999",
                                            maxChar: 80
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }, idx);
        })
    });
};
/* harmony default export */ var CartItem_ItemPersonalizationDetails = (ItemPersonalizationDetails);

// EXTERNAL MODULE: ./src/components/ItemSchedulingInfo/index.tsx + 2 modules
var ItemSchedulingInfo = __webpack_require__(995350);
// EXTERNAL MODULE: ./src/constants/wishlist.js
var wishlist = __webpack_require__(298627);
;// CONCATENATED MODULE: ./src/components/DesignSystem/CartItem/index.js























var CartItem = function(props) {
    var pincodeBasedDeliveryServicableCheck = function pincodeBasedDeliveryServicableCheck() {
        if ((0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)() && (userData === null || userData === void 0 ? void 0 : userData.user_id)) {
            if (cartData === null || cartData === void 0 ? void 0 : cartData.is_store_unserviceable) return false;
            return productItem === null || productItem === void 0 ? void 0 : productItem.is_unserviceable;
        }
        return false;
    };
    var showDeliveryCharges = function showDeliveryCharges(item) {
        if ((0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)() && (item === null || item === void 0 ? void 0 : item.delivery_charges) > 0) return true;
        return false;
    };
    var ref, ref1;
    var _data = props.data, _name = _data.name, name = _name === void 0 ? props.data.name || props.data.item_name : _name, _price = _data.price, price = _price === void 0 ? props.data.price || props.data.actual_price : _price, discounted_price = _data.discounted_price, quantity = _data.quantity;
    var ref2 = (0,react.useState)(props.data), productItem = ref2[0], setProductItem = ref2[1];
    var ref3 = (0,react.useState)(false), viewCompleteRemarks = ref3[0], setViewCompleteRemarks = ref3[1];
    var ref4 = (0,react.useState)(0), discountPercent = ref4[0], setDiscountPercent = ref4[1];
    var ref5 = (0,react.useState)(null), personalizationsData = ref5[0], setPersonalizationsData = ref5[1];
    var ref6 = (0,react.useState)(false), isItemUpdating = ref6[0], setIsItemUpdating = ref6[1];
    var ref7 = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store,
            cartData: state.cartReducer,
            userData: state.userReducer.data,
            setCartLoader: state.commonReducer.setCartLoader
        };
    }), cartData = ref7.cartData, storeData = ref7.storeData, userData = ref7.userData, setCartLoader = ref7.setCartLoader;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref8 = (0,useCartHandler/* useCartHandlers */.u)(), handleSetProductCustomizationCount = ref8.handleSetProductCustomizationCount, handleIncreamentClick = ref8.handleIncreamentClick, handleDecreamentClick = ref8.handleDecreamentClick, handleSetProductData = ref8.handleSetProductData;
    var setWishlistState = (0,useSetWishlistState/* useSetWishlistState */.X)().setWishlistState;
    (0,react.useEffect)(function() {
        if (!setCartLoader && isItemUpdating) {
            setIsItemUpdating(false);
        }
    }, [
        setCartLoader
    ]);
    (0,react.useEffect)(function() {
        var percent = 0;
        var _tempItem = (0,_object_spread/* default */.Z)({}, props.data);
        var personalizations = [];
        /** If this is a variant product */ if (props.variant) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            _tempItem.discounted_price = props === null || props === void 0 ? void 0 : (ref = props.variant) === null || ref === void 0 ? void 0 : ref.discounted_price;
            _tempItem.price = props === null || props === void 0 ? void 0 : (ref1 = props.variant) === null || ref1 === void 0 ? void 0 : ref1.price;
            _tempItem.quantity = (props === null || props === void 0 ? void 0 : (ref2 = props.variant) === null || ref2 === void 0 ? void 0 : ref2.quantity) || 0;
            _tempItem.available_quantity = (props === null || props === void 0 ? void 0 : (ref3 = props.variant) === null || ref3 === void 0 ? void 0 : ref3.available_quantity) || 0;
            _tempItem.thumbnail_url = (ref4 = props.variant) === null || ref4 === void 0 ? void 0 : ref4.thumbnail_url;
            var ref7;
            personalizations = (ref7 = props === null || props === void 0 ? void 0 : (ref5 = props.variant) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.personalization_info) === null || ref6 === void 0 ? void 0 : ref6.personalizations) !== null && ref7 !== void 0 ? ref7 : [];
            /** If variant has image */ if (props.variant.images) {
                var ref8, ref9, ref10;
                _tempItem.image_url = (ref8 = props.variant) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.images) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : ref10.image_url;
            }
            percent = (0,getDiscountPercentage/* getDiscountPercentage */.$)(props.variant.price, props.variant.discounted_price);
        } else {
            var ref11, ref12, ref13, ref14;
            var ref15;
            personalizations = (ref15 = (ref11 = props.data) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.personalization_info) === null || ref12 === void 0 ? void 0 : ref12.personalizations) !== null && ref15 !== void 0 ? ref15 : [];
            _tempItem.quantity = (props === null || props === void 0 ? void 0 : (ref13 = props.data) === null || ref13 === void 0 ? void 0 : ref13.quantity) || 0;
            _tempItem.available_quantity = (props === null || props === void 0 ? void 0 : (ref14 = props.data) === null || ref14 === void 0 ? void 0 : ref14.available_quantity) || 0;
            percent = (0,getDiscountPercentage/* getDiscountPercentage */.$)(price, discounted_price);
        }
        if (personalizations && (personalizations === null || personalizations === void 0 ? void 0 : personalizations.length)) {
            var ref16;
            dispatch((0,catalog/* fetchCatalogItemById */.eP)({
                store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                item_id: (ref16 = props.data) === null || ref16 === void 0 ? void 0 : ref16.item_id,
                src: "cart_item"
            }, true, function(data) {
                _tempItem["available"] = data.available;
                _tempItem["variants"] = data.variants;
                _tempItem["product_personalization"] = data.product_personalization;
                _tempItem["variants_count"] = data.variants_count;
                dispatch((0,common/* setVariantModalVisibility */.VZ)(false));
            }));
        }
        /** set the discount percentage & product item */ setDiscountPercent(percent ? percent : 0);
        setProductItem(_tempItem);
        setPersonalizationsData(personalizations);
    }, [
        cartData.items
    ]);
    (0,react.useEffect)(function() {
        if (productItem === null || productItem === void 0 ? void 0 : productItem.product_personalization) {
            handleSetProductData(productItem);
        }
    }, [
        productItem
    ]);
    var handleMoveItemToWishlist = function() {
        var ref;
        var payload = {
            item_id: (ref = props.data) === null || ref === void 0 ? void 0 : ref.item_id,
            status: wishlist/* ITEM_WISHLIST_STATE.ITEM_WISHLISTED */.U.ITEM_WISHLISTED
        };
        setWishlistState(payload);
    };
    var handleAddRemoveItem = function(type) {
        var count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var ref;
        dispatch((0,logs/* pushEventsLog */.U)({
            event_name: "Cx_ATC",
            data: {
                store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                domain: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                page: window.location.href,
                device: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? "Mobile" : "Desktop",
                cx_number: userData === null || userData === void 0 ? void 0 : userData.phone
            }
        }));
        if (props.variant) {
            var newCart = (0,mutateVariantItemWithCartData/* mutateVariantItemWithCartData */.I)(type, props.data, props.variant, cartData, null, null, null, count);
            dispatch((0,actions_cart/* saveCart */.FP)(newCart));
            return;
        }
        var newState = (0,mutateItemObjectWithCartData/* mutateItemObjectWithCartData */.L)(type, props.data, cartData, null, null, null, count);
        dispatch((0,actions_cart/* saveCart */.FP)(newState));
    };
    var toggleCompleteRemarks = function() {
        return setViewCompleteRemarks(function(val) {
            return !val;
        });
    };
    var getTruncatedText = function(remark) {
        var TRUNCATED_CHAR_LIMIT = 40;
        if ((remark === null || remark === void 0 ? void 0 : remark.length) < TRUNCATED_CHAR_LIMIT) return remark;
        else return !viewCompleteRemarks ? "".concat(remark === null || remark === void 0 ? void 0 : remark.substr(0, TRUNCATED_CHAR_LIMIT), "...") : remark;
    };
    var getAdditionalRemarkText = function() {
        var ref;
        return ((ref = props.variant) === null || ref === void 0 ? void 0 : ref.additional_remark) || (productItem === null || productItem === void 0 ? void 0 : productItem.additional_remark);
    };
    var isItemAdditionDisabled = function() {
        if (productItem === null || productItem === void 0 ? void 0 : productItem.managed_inventory) return !((productItem === null || productItem === void 0 ? void 0 : productItem.quantity) < (productItem === null || productItem === void 0 ? void 0 : productItem.available_quantity));
        else return false;
    };
    var handleEditClick = function(data, idx) {
        var ref;
        handleSetProductCustomizationCount(productItem);
        handleSetProductData(productItem);
        checkRenderEnv/* IS_CLIENT */.kc && localStorage.setItem("activeVariantId", props === null || props === void 0 ? void 0 : (ref = props.variant) === null || ref === void 0 ? void 0 : ref.variant_id);
        var itemData = (props === null || props === void 0 ? void 0 : props.variant) || (props === null || props === void 0 ? void 0 : props.data) || {};
        dispatch((0,catalog/* editCartProductPersonalization */.lF)({
            personalizedProductData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, itemData), {
                index: idx
            }),
            editableData: {
                images: data === null || data === void 0 ? void 0 : data.images,
                texts: data === null || data === void 0 ? void 0 : data.texts
            }
        }));
    };
    var updateCartItemForPersonalisedProduct = function(type) {
        handleSetProductCustomizationCount(productItem);
        handleSetProductData(productItem);
        if (productItem === null || productItem === void 0 ? void 0 : productItem.variants_count) {
            var ref;
            checkRenderEnv/* IS_CLIENT */.kc && localStorage.setItem("activeVariantId", props === null || props === void 0 ? void 0 : (ref = props.variant) === null || ref === void 0 ? void 0 : ref.variant_id);
        }
        switch(type){
            case "inc":
                handleIncreamentClick(type, productItem);
                break;
            case "dec":
                handleDecreamentClick(type, productItem);
                break;
            // this case would occur on personalised item deletion
            case "custom":
                handleAddRemoveItem(type, 0);
            default:
                break;
        }
    };
    var handleCartItemUpdate = function(type) {
        var count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        if (!(productItem === null || productItem === void 0 ? void 0 : productItem.product_personalization)) {
            handleAddRemoveItem(type, count);
            return;
        }
        updateCartItemForPersonalisedProduct(type, count);
    };
    var handleItemChange = function(type) {
        var count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, reset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        if (count && (productItem === null || productItem === void 0 ? void 0 : productItem.managed_inventory) && (productItem === null || productItem === void 0 ? void 0 : productItem.available_quantity) < count) {
            dispatch((0,common/* setUnavailableQuantityAlertState */.K6)({
                show: true,
                availableQuantity: productItem === null || productItem === void 0 ? void 0 : productItem.available_quantity,
                onConfirm: function() {
                    setIsItemUpdating(true);
                    handleCartItemUpdate(type, productItem === null || productItem === void 0 ? void 0 : productItem.available_quantity);
                },
                onCancel: reset
            }));
        } else {
            setIsItemUpdating(true);
            handleCartItemUpdate(type, count);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_ItemContainer, {
        className: "tw-relative !tw-border-none",
        children: [
            pincodeBasedDeliveryServicableCheck() && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartError_CartError, {
                text: "This item can’t be delivered to the selected address",
                iconWidth: 14,
                iconHeight: 14,
                mri: 8,
                width: deviceWidth/* deviceWidth */.o < 767 ? "100vw" : "24.48vw",
                fontSize: 12,
                mt: 12,
                mb: 12
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                imageUrl: productItem === null || productItem === void 0 ? void 0 : productItem.image_url,
                children: [
                    (productItem === null || productItem === void 0 ? void 0 : productItem.thumbnail_url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemImage, {
                        className: "tw-flex-shrink-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: productItem === null || productItem === void 0 ? void 0 : productItem.thumbnail_url
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-1 tw-flex-col tw-gap-[16px] md:tw-flex-row md:tw-gap-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemInfo, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemDetails, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemName, {
                                            children: name
                                        }),
                                        (props === null || props === void 0 ? void 0 : props.variant) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemVariantName, {
                                            children: props.variant.variant_name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemSub, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemPrice, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountedPrice, {
                                                            children: "".concat(config/* CURRENCY_SYMBOL */.o).concat(productItem === null || productItem === void 0 ? void 0 : productItem.discounted_price)
                                                        }),
                                                        discountPercent !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActualPrice, {
                                                            children: "".concat(config/* CURRENCY_SYMBOL */.o).concat((productItem === null || productItem === void 0 ? void 0 : productItem.price) || (productItem === null || productItem === void 0 ? void 0 : productItem.actual_price))
                                                        })
                                                    ]
                                                }),
                                                discountPercent !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemDiscount, {
                                                    children: [
                                                        "".concat(discountPercent),
                                                        "% OFF"
                                                    ]
                                                })
                                            ]
                                        }),
                                        showDeliveryCharges(productItem) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliveryCharges, {
                                            children: [
                                                "Delivery: ",
                                                "".concat(config/* CURRENCY_SYMBOL */.o).concat(productItem === null || productItem === void 0 ? void 0 : productItem.delivery_charges)
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartButtonItemValueContainer, {
                                className: "tw-flex-1 !tw-justify-between md:!tw-justify-end",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButton/* default */.Z, {
                                        isUpdating: isItemUpdating,
                                        customClasses: "tw-h-fit !tw-relative !tw-w-[132px] md:!tw-w-fit",
                                        allowItemDeletion: true,
                                        allowCustomInput: !(productItem === null || productItem === void 0 ? void 0 : productItem.product_personalization),
                                        disableAddition: isItemAdditionDisabled(),
                                        quantity: props.variant ? props.variant.quantity : quantity,
                                        onChange: handleItemChange,
                                        fontSize: 14,
                                        handleMoveItemToWishlist: handleMoveItemToWishlist
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemTotalValue, {
                                        className: "tw-w-[80px]",
                                        children: [
                                            config/* CURRENCY_SYMBOL */.o,
                                            props.variant ? props === null || props === void 0 ? void 0 : (ref = props.variant) === null || ref === void 0 ? void 0 : ref.amount : productItem === null || productItem === void 0 ? void 0 : productItem.amount
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, props === null || props === void 0 ? void 0 : props.key),
            !!getAdditionalRemarkText() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemRemarksWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "heading",
                        children: "Additional Remarks: "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "cp",
                        onClick: toggleCompleteRemarks,
                        children: [
                            '"',
                            getTruncatedText(getAdditionalRemarkText()),
                            '"'
                        ]
                    })
                ]
            }),
            pincodeBasedDeliveryServicableCheck() && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartRemoveCta_CartRemoveCta, {
                item: productItem,
                mt: 8
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSchedulingInfo/* default */.Z, {
                schedulingInfo: props === null || props === void 0 ? void 0 : (ref1 = props.data) === null || ref1 === void 0 ? void 0 : ref1.schedule_info
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItem_ItemPersonalizationDetails, {
                storeData: storeData,
                personalizationsData: personalizationsData,
                handleEditClick: handleEditClick
            })
        ]
    });
};
/* harmony default export */ var DesignSystem_CartItem = (CartItem);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartItemsAndCheckout/AllCartItems.tsx






var AllCartItems = function(param) {
    var referenceToCheckScrollHeight = param.referenceToCheckScrollHeight, allItems = param.allItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemContainer, {
        className: "!tw-max-w-[100vw]",
        children: [
            checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemPrecursor, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemPrecursorText, {
                        children: (0,getCustomCtaText/* default */.Z)("item_details_heading")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemPrecursorText, {
                        style: {
                            marginRight: "6px"
                        },
                        children: "Quantity"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemList, {
                children: [
                    (allItems === null || allItems === void 0 ? void 0 : allItems.length) > 0 && allItems.filter(function(item) {
                        return item.item_type === "catalog";
                    }).map(function(item, i) {
                        var ref;
                        if ((item === null || item === void 0 ? void 0 : (ref = item.variants_selected) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                            var ref1;
                            return item === null || item === void 0 ? void 0 : (ref1 = item.variants_selected) === null || ref1 === void 0 ? void 0 : ref1.map(function(_var, varIdx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignSystem_CartItem, {
                                    data: item,
                                    variant: _var
                                }, _var.variant_id);
                            });
                        } else return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignSystem_CartItem, {
                            data: item
                        }, "".concat(i, "-cart-item"));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Scroll_Scroll, {
                        referenceToCheckScrollHeight: referenceToCheckScrollHeight
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CartItemsAndCheckout_AllCartItems = (AllCartItems);

;// CONCATENATED MODULE: ./src/components/DeliveryChargeList/DeliveryChargeList.styles.js

function DeliveryChargeList_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-top: 6px;\n  flex-direction: column;\n"
    ]);
    DeliveryChargeList_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DeliveryChargeList_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  color: #7e7e7e;\n  width: 100%;\n  margin-top: 6px;\n"
    ]);
    DeliveryChargeList_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DeliveryChargeList_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: 14px;\n  color: #7e7e7e;\n"
    ]);
    DeliveryChargeList_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var DeliveryChargeListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DeliveryChargeListContainer",
    componentId: "sc-ff02a544-0"
})(DeliveryChargeList_styles_templateObject());
var DeliveryChargeRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DeliveryChargeRow",
    componentId: "sc-ff02a544-1"
})(DeliveryChargeList_styles_templateObject1());
var DeliveryPriceContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DeliveryPriceContainer",
    componentId: "sc-ff02a544-2"
})(DeliveryChargeList_styles_templateObject2());

;// CONCATENATED MODULE: ./src/components/DeliveryChargeList/DeliveryChargeList.js





function DeliveryChargeList() {
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return {
            items: state.cartReducer.items,
            otherDeliveryCharges: state.cartReducer.other_delivery_charges,
            cartData: state.cartReducer
        };
    }), items = ref.items, otherDeliveryCharges = ref.otherDeliveryCharges, cartData = ref.cartData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliveryChargeListContainer, {
        children: [
            (items === null || items === void 0 ? void 0 : items.length) > 0 ? items === null || items === void 0 ? void 0 : items.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: item.delivery_charges > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliveryChargeRow, {
                        children: [
                            item.item_name,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliveryPriceContainer, {
                                children: [
                                    config/* CURRENCY_SYMBOL */.o,
                                    item.delivery_charges
                                ]
                            })
                        ]
                    }) : null
                }, item.item_id);
            }) : null,
            otherDeliveryCharges > 0 && otherDeliveryCharges !== (cartData === null || cartData === void 0 ? void 0 : cartData.delivery_charge) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliveryChargeRow, {
                children: [
                    "Other Delivery Charges",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliveryPriceContainer, {
                        children: [
                            config/* CURRENCY_SYMBOL */.o,
                            otherDeliveryCharges
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var DeliveryChargeList_DeliveryChargeList = (DeliveryChargeList);

// EXTERNAL MODULE: ./src/utils/storeGSTStatus.js
var storeGSTStatus = __webpack_require__(541359);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartItemsAndCheckout/GrandTotal.tsx




var GrandTotal_GrandTotal = function(param) {
    var cart = param.cart;
    var _renderGstInclusivePrice = function _renderGstInclusivePrice() {
        return (0,storeGSTStatus/* isStoreGstIncluded */.u)() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GstIncludesContainer, {
            children: "(Incl. ₹ ".concat(cart === null || cart === void 0 ? void 0 : cart.total_gst_paid, " GST)")
        }) : null;
    };
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AmountRow, {
        className: "tw-mb-[16px] tw-w-full md:tw-mb-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TotalText, {
                fontWeight: 600,
                className: "!tw-text-[16px]/[20px]",
                children: [
                    "Grand Total",
                    _renderGstInclusivePrice()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalText, {
                fontWeight: 600,
                className: "!tw-text-[18px]/[22px] md:!tw-text-[16px]/[20px]",
                children: (cart === null || cart === void 0 ? void 0 : cart.buyer_pay_value) && "".concat(config/* CURRENCY_SYMBOL */.o, " ").concat(cart === null || cart === void 0 ? void 0 : (ref = cart.buyer_pay_value) === null || ref === void 0 ? void 0 : ref.toFixed(2))
            })
        ]
    });
};
/* harmony default export */ var CartItemsAndCheckout_GrandTotal = (GrandTotal_GrandTotal);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartItemsAndCheckout/OrderAmountInfo.tsx













var OrderAmountInfo = function(param) {
    var _showGrandTotal = param.showGrandTotal, showGrandTotal = _showGrandTotal === void 0 ? false : _showGrandTotal;
    var handleDeliveryChargeList = function handleDeliveryChargeList() {
        setShowDeliveryChargeList(!showDeliveryChargeList);
    };
    var _renderGstExclusivePrice = function _renderGstExclusivePrice() {
        return (0,storeGSTStatus/* isStoreGstExcluded */.n)() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(GstExcludesContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "GST"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "₹ ",
                        cart === null || cart === void 0 ? void 0 : cart.total_gst_paid
                    ]
                })
            ]
        }) : null;
    };
    var _renderDeliveryRelatedInfo = function _renderDeliveryRelatedInfo() {
        var ref, ref1, ref2;
        var isOrderBasedStoreType = (0,getStoreType/* getStoreType */.K)(storeInfo) === constants/* STORE_CUSTOMIZATION.ORDER_BASED */.DO.ORDER_BASED;
        var isDeliveryOrder = cart.order_type === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY;
        var minDeliveryCharge = storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.delivery_charge_min;
        var maxDeliveryCharge = storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.delivery_charge_max;
        var approxDeliveryTime = storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.services) === null || ref2 === void 0 ? void 0 : ref2.delivery_time_approx;
        var isDeliveryChargeInfoAvailable = !!minDeliveryCharge && !!maxDeliveryCharge;
        var isDeliveryTimeInfoAvailable = !!approxDeliveryTime;
        var isDeliveryInfoAvaiable = isDeliveryChargeInfoAvailable || isDeliveryTimeInfoAvailable;
        var showDeliveryInfo = isOrderBasedStoreType && isDeliveryOrder && isDeliveryInfoAvaiable;
        return showDeliveryInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: "flex justify-center items-start pt4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex w2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/7UkwS1DR.webp",
                        alt: "info ocon",
                        className: "img h1"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-auto f7 black-50 ph2 lh-title",
                    children: [
                        isDeliveryChargeInfoAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                marginBottom: 10
                            },
                            children: "Delivery charges may apply, approx delivery charge ₹ ".concat(minDeliveryCharge, " to ₹ ").concat(maxDeliveryCharge, ". Exact amount will be reflected in your final bill")
                        }),
                        isDeliveryTimeInfoAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Typically arrives in ".concat(approxDeliveryTime, ". Final ETA will be shared once we get your order ready.")
                        })
                    ]
                })
            ]
        });
    };
    var ref;
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeInfo: state.storeReducer.store,
            cart: state.cartReducer
        };
    }), cart = ref1.cart, storeInfo = ref1.storeInfo;
    var ref2 = (0,react.useState)(false), showDeliveryChargeList = ref2[0], setShowDeliveryChargeList = ref2[1];
    var checkDeliveryChargeTypeComparison = function() {
        var ref, ref1, ref2, ref3;
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.delivery_charge_type) === constants/* DELIVERY_CHARGE_TYPE.FREE */.zy.FREE || (storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.delivery_charge_type) === constants/* DELIVERY_CHARGE_TYPE.FIXED */.zy.FIXED) return true;
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.services) === null || ref2 === void 0 ? void 0 : ref2.delivery_charge_type) === constants/* DELIVERY_CHARGE_TYPE.NOT_VALID */.zy.NOT_VALID || (storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.services) === null || ref3 === void 0 ? void 0 : ref3.delivery_charge_type) === constants/* DELIVERY_CHARGE_TYPE.CUSTOM */.zy.CUSTOM) {
            var ref4, ref5;
            return (storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.services) === null || ref4 === void 0 ? void 0 : ref4.free_delivery_above) ? cart.items_total > (storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.services) === null || ref5 === void 0 ? void 0 : ref5.free_delivery_above) : false;
        }
        return true;
    };
    var _renderPromoDiscountBox = function() {
        var ref, ref1, ref2, ref3;
        return (cart === null || cart === void 0 ? void 0 : (ref = cart.store_offer) === null || ref === void 0 ? void 0 : ref.promo_code) && (cart === null || cart === void 0 ? void 0 : (ref1 = cart.store_offer) === null || ref1 === void 0 ? void 0 : ref1.promo_discount) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: "flex justify-between items-center f6 lime-green-color",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Promo Discount"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "(-) ₹",
                        cart === null || cart === void 0 ? void 0 : (ref2 = cart.store_offer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.promo_discount) === null || ref3 === void 0 ? void 0 : ref3.toFixed(2)
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    var _renderPaymentPromoDiscountBox = function() {
        var ref;
        return cart.payment_offer && cart.payment_offer.promo_discount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: "flex justify-between items-center f6 lime-green-color",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Bank Discount"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        "(-) ₹",
                        (ref = cart.payment_offer.promo_discount) === null || ref === void 0 ? void 0 : ref.toFixed(2)
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AmountContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AmountRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalText, {
                        fontWeight: 400,
                        children: (0,getCustomCtaText/* default */.Z)("item_total_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalText, {
                        fontWeight: 400,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: cart.items_total && "".concat(config/* CURRENCY_SYMBOL */.o).concat(cart === null || cart === void 0 ? void 0 : (ref = cart.items_total) === null || ref === void 0 ? void 0 : ref.toFixed(2))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AmountRow, {
                style: {
                    flexDirection: "column",
                    alignItems: "space-between",
                    justifyContent: "center"
                },
                children: cart.order_type === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY && checkDeliveryChargeTypeComparison() && /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                    style: {
                        width: "100%"
                    },
                    className: "cart-totalAmt__deliveryCharge flex justify-between items-start premium-deliver--charge mt2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-column w-100",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliveryChargeDropDownContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TotalText, {
                                        fontWeight: 400,
                                        children: [
                                            "Delivery fees",
                                            (0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)() && cart.delivery_charge > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrowContainer, {
                                                onClick: handleDeliveryChargeList,
                                                showDeliveryChargeList: showDeliveryChargeList,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrow/* DropDownArrow */.s, {
                                                    width: 12,
                                                    height: 6
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TotalText, {
                                        fontWeight: 400,
                                        children: cart.delivery_charge === 0 ? "Free" : "".concat(config/* CURRENCY_SYMBOL */.o, " ").concat(cart.delivery_charge)
                                    })
                                ]
                            }),
                            showDeliveryChargeList && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryChargeList_DeliveryChargeList, {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-100 mv2",
                children: _renderPromoDiscountBox()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-100 mv2",
                children: _renderPaymentPromoDiscountBox()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-100 mv2",
                children: _renderGstExclusivePrice()
            }),
            showGrandTotal && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-100 mv2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemsAndCheckout_GrandTotal, {
                    cart: cart
                })
            }),
            _renderDeliveryRelatedInfo()
        ]
    });
};
/* harmony default export */ var CartItemsAndCheckout_OrderAmountInfo = (OrderAmountInfo);

;// CONCATENATED MODULE: ./src/hooks/useOnScrollRemoveShadow.js

/**
 * this useEffect returns a variable that toggles
 * when we scroll to the bottom and top
 * @param {*} referenceToCheckScrollHeight
 * @returns
 */ function useOnScrollRemoveShadow(referenceToCheckScrollHeight) {
    var removeScrollEventListener = function removeScrollEventListener() {
        var ref;
        referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref = referenceToCheckScrollHeight.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("scroll", checkIfScrolledDownTop);
    };
    var checkIfScrolledDownTop = function checkIfScrolledDownTop() {
        var ref, ref1, ref2;
        if ((referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref = referenceToCheckScrollHeight.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) + (referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref1 = referenceToCheckScrollHeight.current) === null || ref1 === void 0 ? void 0 : ref1.scrollTop) >= (referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref2 = referenceToCheckScrollHeight.current) === null || ref2 === void 0 ? void 0 : ref2.scrollHeight)) {
            setShowScrollDownShadow(false);
        } else setShowScrollDownShadow(true);
    };
    var ref = (0,react.useState)(true), showScrollDownShadow = ref[0], setShowScrollDownShadow = ref[1];
    (0,react.useEffect)(function() {
        var ref;
        referenceToCheckScrollHeight === null || referenceToCheckScrollHeight === void 0 ? void 0 : (ref = referenceToCheckScrollHeight.current) === null || ref === void 0 ? void 0 : ref.addEventListener("scroll", checkIfScrolledDownTop);
        checkIfScrolledDownTop();
        return function() {
            removeScrollEventListener();
        };
    }, []);
    return showScrollDownShadow;
}

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CustomerAssurityBadges/index.tsx



var KYC_DONE_FLAG = 3;
var CustomerAssurityBadges = function() {
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var isKycDone = (storeData === null || storeData === void 0 ? void 0 : storeData.kyc_status) === KYC_DONE_FLAG;
    var assurityData = [
        {
            show: true,
            Icon: ShieldIcon,
            boldText: "Secured",
            normalText: "Payment"
        },
        {
            show: isKycDone,
            Icon: VerifiedIcon,
            boldText: "Verified",
            normalText: "Merchant"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-flex tw-items-center tw-justify-center tw-gap-[20px] tw-text-[14px] tw-opacity-60 md:tw-pt-[4px]",
        children: assurityData.map(function(param, index) {
            var show = param.show, Icon = param.Icon, boldText = param.boldText, normalText = param.normalText;
            return show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "tw-flex tw-gap-[2px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        height: 16,
                        width: 16
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-font-bold",
                        children: boldText
                    }),
                    " ",
                    normalText
                ]
            }, index);
        })
    });
};
/* harmony default export */ var Components_CustomerAssurityBadges = (CustomerAssurityBadges);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartItemsAndCheckout/CartCheckoutCTA.tsx
















var PLACE_ORDER_BUTTON_OPACITY = "20";
var CartCheckoutCTA = function(param) {
    var allItems = param.allItems, referenceToCheckScrollHeight = param.referenceToCheckScrollHeight;
    var getCtalabel = function getCtalabel() {
        var ref;
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.payment_method) === constants/* PREPAID_POSTPAID_METHODS.PREPAID */.R9.PREPAID) return "Pay Now";
        return (0,getCustomCtaText/* default */.Z)("cart_cta");
    };
    var getIsCtaDisabled = function getIsCtaDisabled() {
        var ref;
        switch(true){
            case (0,canDisablePlaceOrder/* canDisablePlaceOrder */.w)():
            case cart === null || cart === void 0 ? void 0 : cart.is_order_blocked:
            case prepaidLimitDisablePayNow:
            case (0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)() && (cart === null || cart === void 0 ? void 0 : cart.is_cart_unserviceable):
            case (userData === null || userData === void 0 ? void 0 : userData.isLogin) && (cart === null || cart === void 0 ? void 0 : cart.order_type) === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY && !((ref = cart.delivery_info) === null || ref === void 0 ? void 0 : ref.address1):
            case (cart === null || cart === void 0 ? void 0 : cart.order_type) === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY && toggleAddDeliveryForm:
                return true;
            default:
                return false;
        }
    };
    var getPlaceOrderCtaColor = function getPlaceOrderCtaColor() {
        if (getIsCtaDisabled()) {
            return themeColor + PLACE_ORDER_BUTTON_OPACITY;
        } else {
            return themeColor;
        }
    };
    var renderTextBelowPlaceOrderCta = function renderTextBelowPlaceOrderCta() {
        var ref, ref1, ref2;
        var invalidAddressText = (userData === null || userData === void 0 ? void 0 : userData.isLogin) && (cart === null || cart === void 0 ? void 0 : cart.order_type) === constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY && !((ref = cart.delivery_info) === null || ref === void 0 ? void 0 : ref.address1) ? "Add valid address and phone number to proceed" : "";
        if (getIsCtaDisabled() && !!invalidAddressText) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "f12px mt12px tw-text-red-600",
                children: invalidAddressText
            });
        }
        var paymentInfoText = (storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.services) === null || ref1 === void 0 ? void 0 : ref1.partial_payment_flag) ? "You can choose partial payment in the next step" : (0,isStoreServiceBased/* isStoreServiceBased */.A)() ? "You can make payment once you avail the service" : null;
        return (storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.services) === null || ref2 === void 0 ? void 0 : ref2.payment_method) !== constants/* PREPAID_POSTPAID_METHODS.PREPAID */.R9.PREPAID && !!paymentInfoText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-text-[12px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tc",
                children: paymentInfoText
            })
        });
    };
    var ref;
    var showScrollDownShadow = useOnScrollRemoveShadow(referenceToCheckScrollHeight);
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return {
            cart: state.cartReducer,
            storeInfo: state.storeReducer.store,
            prepaidLimitDisablePayNow: state.commonReducer.prepaidLimitDisablePayNow,
            userData: state.userReducer,
            toggleAddDeliveryForm: state.commonReducer.toggleAddDeliveryForm
        };
    }), cart = ref1.cart, storeInfo = ref1.storeInfo, prepaidLimitDisablePayNow = ref1.prepaidLimitDisablePayNow, userData = ref1.userData, toggleAddDeliveryForm = ref1.toggleAddDeliveryForm;
    var onCartPlaceOrderBtnHandle = (0,react.useContext)(CartContext/* CartContext */.A).onCartPlaceOrderBtnHandle;
    return (allItems === null || allItems === void 0 ? void 0 : allItems.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomContainer, {
        storeUnserviceable: cart.is_store_unserviceable,
        showScrollDownShadow: showScrollDownShadow,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemsAndCheckout_GrandTotal, {
                cart: cart
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-w-full tw-flex-col tw-gap-[12px]",
                children: !cart.is_store_unserviceable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAbutton, {
                            fluid: true,
                            roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : ref.roundness,
                            backgroundColor: getPlaceOrderCtaColor(),
                            fontColor: "#ffffff",
                            fontSize: checkClientDeviceType/* IS_DESKTOP */.yn ? 14 : 16,
                            fontWeight: 700,
                            textTransform: "capitalize",
                            label: getCtalabel(),
                            variant: "solid",
                            disabled: getIsCtaDisabled(),
                            borderWidth: "0px",
                            onClick: function() {
                                if ((0,canDisablePlaceOrder/* canDisablePlaceOrder */.w)()) {
                                    return;
                                }
                                onCartPlaceOrderBtnHandle === null || onCartPlaceOrderBtnHandle === void 0 ? void 0 : onCartPlaceOrderBtnHandle();
                            },
                            className: "tw-py-[18px] md:tw-py-[16px]"
                        }),
                        renderTextBelowPlaceOrderCta()
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CartError_CartError, {
                    text: "Sorry, we are currently unserviceable at this pincode",
                    iconWidth: 14,
                    iconHeight: 14,
                    fontSize: !checkClientDeviceType/* IS_DESKTOP */.yn ? 12 : 14,
                    customClasses: "tw-justify-center"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_CustomerAssurityBadges, {})
        ]
    });
};
/* harmony default export */ var CartItemsAndCheckout_CartCheckoutCTA = (CartCheckoutCTA);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/CartItemsAndCheckout/index.tsx








var CartSummery = function(param) {
    var showOrderSummary = param.showOrderSummary, handleOrderSummary = param.handleOrderSummary, _referenceToCheckScrollHeight = param.referenceToCheckScrollHeight, referenceToCheckScrollHeight = _referenceToCheckScrollHeight === void 0 ? null : _referenceToCheckScrollHeight, _summeryClasses = param.summeryClasses, summeryClasses = _summeryClasses === void 0 ? "" : _summeryClasses, _showDropdown = param.showDropdown, showDropdown = _showDropdown === void 0 ? false : _showDropdown, allItems = param.allItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemsAndCheckout_CartItemsAndCheckoutSectionHeading, {
                showSummary: showOrderSummary,
                hanldeSummary: handleOrderSummary,
                summeryClasses: summeryClasses,
                showDropdown: showDropdown
            }),
            showOrderSummary && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemAmountContainer, {
                ref: referenceToCheckScrollHeight,
                showOrderSummary: showOrderSummary,
                showDropdown: showDropdown,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemsAndCheckout_AllCartItems, {
                        allItems: allItems,
                        referenceToCheckScrollHeight: referenceToCheckScrollHeight
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemsAndCheckout_OrderAmountInfo, {
                        showGrandTotal: showDropdown
                    })
                ]
            })
        ]
    });
};
var CartItemsAndCheckout = function(param) {
    var allItems = param.allItems;
    var handleOrderSummary = function handleOrderSummary() {
        if (!checkClientDeviceType/* IS_DESKTOP */.yn) setShowOrderSummary(!showOrderSummary);
    };
    var ref = (0,react.useState)(true), showOrderSummary = ref[0], setShowOrderSummary = ref[1];
    var referenceToCheckScrollHeight = (0,react.useRef)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartBodyRightSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartSummery, {
                showOrderSummary: showOrderSummary,
                handleOrderSummary: handleOrderSummary,
                referenceToCheckScrollHeight: referenceToCheckScrollHeight,
                allItems: allItems
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemsAndCheckout_CartCheckoutCTA, {
                allItems: allItems,
                referenceToCheckScrollHeight: referenceToCheckScrollHeight
            })
        ]
    });
};
/* harmony default export */ var Components_CartItemsAndCheckout = (CartItemsAndCheckout);

// EXTERNAL MODULE: ./src/utils/specificThemeRender.ts
var specificThemeRender = __webpack_require__(698616);
// EXTERNAL MODULE: ./src/utils/themeImports.js + 1 modules
var themeImports = __webpack_require__(353978);
// EXTERNAL MODULE: ./src/assets/svgExports/BackArrow.js
var BackArrow = __webpack_require__(285946);
;// CONCATENATED MODULE: ./src/containers/Cart/Components/PageHeader/index.tsx








var PageHeader = function(param) {
    var isEmptyCart = param.isEmptyCart;
    var ref, ref1, ref2;
    var storeInfo = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    var router = (0,next_router.useRouter)();
    return !checkClientDeviceType/* IS_DESKTOP */.yn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartHeader, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartHeaderBack, {
                onClick: function() {
                    return router.back();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackArrow/* BackArrow */.D, {
                    width: 16,
                    height: 16
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartHeaderData, {
                children: !isEmptyCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeaderInner, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartHeaderText, {
                        children: "Cart"
                    })
                }) : null
            })
        ]
    }) : (ref = (0,specificThemeRender/* specificThemeRender */.t)(storeInfo)) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : ref2.map(function(layout) {
        return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
    });
};
/* harmony default export */ var Components_PageHeader = (PageHeader);

// EXTERNAL MODULE: ./src/utils/getPaymentMethodUsedByCustomer.js
var getPaymentMethodUsedByCustomer = __webpack_require__(510203);
;// CONCATENATED MODULE: ./src/containers/Cart/Hooks/useCartPageLandingEvent.tsx






var useCartPageLandingEvent = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeInfo = (0,redux/* useSSRSelector */.kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    var userData = (0,es/* useSelector */.v9)(function(state) {
        return {
            userData: state.userReducer
        };
    }).userData;
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        dispatch((0,common/* setPrepaidLimitDisablePayNow */.cv)(false));
        dispatch((0,logs/* pushEventsLog */.U)({
            event_name: "Cx_Cart_Page",
            data: {
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                domain: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                device: checkClientDeviceType/* IS_DESKTOP */.yn ? "Desktop" : "Mobile",
                cx_number: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone,
                payment_method: (0,getPaymentMethodUsedByCustomer/* getPaymentMethodUsedByCustomer */.R)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.services) === null || ref2 === void 0 ? void 0 : ref2.payment_method)
            }
        }));
    }, []);
};
/* harmony default export */ var Hooks_useCartPageLandingEvent = (useCartPageLandingEvent);

;// CONCATENATED MODULE: ./src/containers/Cart/Components/ModifiedCartNotificationBar/index.tsx

var ModifiedCartNotificationBar = function(param) {
    var cartValidationData = param.cartValidationData, showValidationError = param.showValidationError;
    return (cartValidationData === null || cartValidationData === void 0 ? void 0 : cartValidationData.is_cart_modified) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: "cart-update-notifier flex justify-center items-center bg-black w-100 white f7 fw3 pv2 ph3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "https://cdn.dotpe.in/longtail/themes/8073865/XzydmtDk.webp",
                className: "img h1 pr2"
            }),
            "There are updates in your cart",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "f7 fw3 bb b--dotted mh2",
                onClick: showValidationError,
                children: "View Details"
            })
        ]
    });
};
/* harmony default export */ var Components_ModifiedCartNotificationBar = (ModifiedCartNotificationBar);

;// CONCATENATED MODULE: ./src/containers/Cart/Hooks/useTriggerPixelEvent.tsx


var useTriggerCartPixelEvent = function(param) {
    var orderButtonClickCount = param.orderButtonClickCount;
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return {
            cart: state.cartReducer,
            userData: state.userReducer
        };
    }), cart = ref.cart, userData = ref.userData;
    (0,react.useEffect)(function() {
        if (typeof window.fbq === "function" && orderButtonClickCount == 1) {
            var ref, ref1, ref2, ref3;
            var pixelObject = {
                contents: cart === null || cart === void 0 ? void 0 : (ref = cart.items) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                    return {
                        id: (item === null || item === void 0 ? void 0 : item.id) || (item === null || item === void 0 ? void 0 : item.item_id),
                        name: (item === null || item === void 0 ? void 0 : item.name) || (item === null || item === void 0 ? void 0 : item.item_name),
                        price: (item === null || item === void 0 ? void 0 : item.price) || (item === null || item === void 0 ? void 0 : item.actual_price),
                        quantity: item === null || item === void 0 ? void 0 : item.quantity
                    };
                }),
                currency: "INR",
                num_items: cart === null || cart === void 0 ? void 0 : (ref1 = cart.items) === null || ref1 === void 0 ? void 0 : ref1.length,
                value: cart === null || cart === void 0 ? void 0 : cart.pay_amount,
                user_id: userData === null || userData === void 0 ? void 0 : (ref2 = userData.data) === null || ref2 === void 0 ? void 0 : ref2.user_id,
                phone: userData === null || userData === void 0 ? void 0 : (ref3 = userData.data) === null || ref3 === void 0 ? void 0 : ref3.phone
            };
            window.fbq("track", "Purchase", pixelObject);
        }
    }, [
        orderButtonClickCount
    ]);
    return null;
};
/* harmony default export */ var useTriggerPixelEvent = (useTriggerCartPixelEvent);

;// CONCATENATED MODULE: ./src/components/CartItemDeletionAlert/index.tsx








var CartItemDeletionAlert = function() {
    var onClose = function onClose() {
        setDeletionAlertState === null || setDeletionAlertState === void 0 ? void 0 : setDeletionAlertState({
            show: false,
            callback: null
        });
    };
    var onConfirm = function onConfirm() {
        var ref;
        deletionAlertState === null || deletionAlertState === void 0 ? void 0 : (ref = deletionAlertState.callback) === null || ref === void 0 ? void 0 : ref.call(deletionAlertState, false);
        onClose();
    };
    var ref = (0,react.useContext)(CartContext/* CartContext */.A), deletionAlertState = ref.deletionAlertState, setDeletionAlertState = ref.setDeletionAlertState;
    var wishlistFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().wishlistFeatureStatus;
    var themeColor = (0,getThemeColor/* getThemeColor */.p)() || "#000000";
    var isWishlistLocked = wishlistFeatureStatus === null || wishlistFeatureStatus === void 0 ? void 0 : wishlistFeatureStatus.isLocked;
    var wishlistFeatureActive = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2;
        return {
            wishlistFeatureActive: (ref = state.storeReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.services) === null || ref2 === void 0 ? void 0 : ref2.wishlist_flag
        };
    }).wishlistFeatureActive;
    (0,react.useEffect)(function() {
        return function() {
            return onClose();
        };
    }, []);
    var addItemToWishlist = function() {
        var ref;
        deletionAlertState === null || deletionAlertState === void 0 ? void 0 : (ref = deletionAlertState.callback) === null || ref === void 0 ? void 0 : ref.call(deletionAlertState, true);
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicModal/* default */.Z, {
        show: true,
        onClose: onClose,
        heading: "Remove Item",
        headingClasses: "!tw-border-none !tw-pt-[32px] !tw-px-[16px] md:!tw-px-[24px]",
        customClasses: "!tw-max-w-[440px] !tw-min-w-[300px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-gap-[24px] tw-px-[16px] tw-pb-[22px] md:tw-px-[24px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "tw-m-0 tw-text-sm tw-text-[#606060]",
                    children: isWishlistLocked || wishlistFeatureActive !== wishlist/* WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE */.g.WISHLIST_ACTIVE ? "Are you sure you want to remove this item from the cart? This will also remove any associated coupon applied on this item." : "Are you sure you want to remove this item from the cart? This will also remove any associated coupon applied on this item You can also move this item to your Wishlist."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-justify-end tw-gap-[16px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: onConfirm,
                            className: "tw-cursor-pointer tw-rounded-lg tw-border tw-border-solid tw-border-[#FF0000] tw-bg-transparent tw-p-[12px] tw-text-[#FF0000]",
                            children: "Remove Item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: isWishlistLocked || wishlistFeatureActive !== wishlist/* WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE */.g.WISHLIST_ACTIVE ? onClose : addItemToWishlist,
                            className: "tw-cursor-pointer tw-rounded-lg tw-border tw-border-solid !tw-border-[#E3E3E3] tw-bg-transparent tw-p-[12px]",
                            style: {
                                color: themeColor
                            },
                            children: isWishlistLocked || wishlistFeatureActive !== wishlist/* WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE */.g.WISHLIST_ACTIVE ? "Cancel" : "Move to Wishlist"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_CartItemDeletionAlert = (CartItemDeletionAlert);

// EXTERNAL MODULE: ./src/components/QuntityUnavailableAlert/index.tsx
var QuntityUnavailableAlert = __webpack_require__(527913);
// EXTERNAL MODULE: ./src/utils/getWindowDimension.js
var getWindowDimension = __webpack_require__(37110);
// EXTERNAL MODULE: ./src/hooks/useCreateOrder.tsx
var useCreateOrder = __webpack_require__(443742);
;// CONCATENATED MODULE: ./src/containers/Cart/index.js










































var STORE_CLOSE_FLAG = 0;
var DELIVERY_UNAVILABLE_FLAG = 0;
var PICKUP_UNAVILABLE_FLAG = 0;
var CART_ORDER_TYPE_TEXT = {
    SERVICE: "service",
    DELIVERY: "deliver",
    PICKUP: "pickup"
};
function getOrderTypeTextForCart(orderType) {
    switch(orderType){
        case constants/* ORDER_TYPE.SERVICE */.Jm.SERVICE:
            return CART_ORDER_TYPE_TEXT.SERVICE;
        case constants/* ORDER_TYPE.DELIVERY */.Jm.DELIVERY:
            return CART_ORDER_TYPE_TEXT.DELIVERY;
        default:
            CART_ORDER_TYPE_TEXT.PICKUP;
    }
}
// export const CartContext = createContext({});
var PreCartPage = function() {
    var handleCloseButton = function handleCloseButton() {
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            showAuthModel: false
        }));
    };
    var ref;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var triggerSetCart = (0,customHooks/* default */.Z)().triggerSetCart;
    var ref1 = (0,react.useState)({
        showAuthModel: false,
        showOrderInstructionModal: false,
        orderInstructionText: "",
        showPaymentModal: true,
        isPhoneNumber: false
    }), state = ref1[0], setState = ref1[1];
    var ref2 = (0,react.useState)(false), orderConfirmLoaderToggle = ref2[0], setOrderConfirmLoaderToggle = ref2[1];
    var ref3 = (0,react.useState)(0), orderButtonClickCount = ref3[0], setOrderButtonClickCount = ref3[1];
    var ref4 = (0,react.useState)(false), showAddressError = ref4[0], setShowAddressError = ref4[1];
    var ref5 = (0,react.useState)({
        show: false,
        callback: null
    }), deletionAlertState = ref5[0], setDeletionAlertState = ref5[1];
    var ref6 = (0,react.useState)(false), showSummeryMobile = ref6[0], setShowSummeryMobile = ref6[1];
    var ref7 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref;
        return {
            storeInfo: state.storeReducer.store,
            personalizedProduct: (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : ref.personalizedProduct
        };
    }), storeInfo = ref7.storeInfo, personalizedProduct = ref7.personalizedProduct;
    var ref8 = (0,es/* useSelector */.v9)(function(state) {
        return {
            cart: state.cartReducer,
            list: state.commonReducer.createList,
            userData: state.userReducer,
            setCartLoader: state.commonReducer.setCartLoader,
            cartValidationData: state.errorReducer.cart.cartValidationData
        };
    }), cart = ref8.cart, list = ref8.list, userData = ref8.userData, setCartLoader = ref8.setCartLoader, cartValidationData = ref8.cartValidationData;
    var isComponentMounted = (0,useIsComponentMounted/* default */.Z)();
    var height = (0,getWindowDimension/* default */.Z)({
        useDocumentDimensions: true
    }).height;
    Hooks_useCartPageLandingEvent();
    useTriggerPixelEvent(orderButtonClickCount);
    var addAddressDetailsAndPlaceOrder = (0,useCreateOrder/* useCreateOrder */.Q)().addAddressDetailsAndPlaceOrder;
    (0,react.useEffect)(function() {
        if (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("auth_token")) {
            var authData = {
                auth_token: localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("auth_token"),
                service: ""
            };
            dispatch((0,auth/* authenticateUser */.So)(authData));
            setCartAction();
        } else {
            dispatch((0,user/* setLogout */.wt)());
        }
    }, [
        userData === null || userData === void 0 ? void 0 : userData.isLogin,
        userData === null || userData === void 0 ? void 0 : userData.savedAddress
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.store_flag) === STORE_CLOSE_FLAG) {
            var ref1;
            router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain));
        }
    }, [
        storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.store_flag
    ]);
    (0,react.useEffect)(function() {
        if (!setCartLoader) setCartAction();
    }, [
        cart.pay_amount,
        cart.amount
    ]);
    var allItems = (0,_to_consumable_array/* default */.Z)(cart.items).concat((0,_to_consumable_array/* default */.Z)(list));
    var setCartAction = function() {
        var ref, ref1, ref2;
        var cartWithDeliveryInfo = !((0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)() && !(userData === null || userData === void 0 ? void 0 : (ref = userData.savedAddress) === null || ref === void 0 ? void 0 : ref.pincode)) ? (0,addDeliveryInfoInCart/* addDeliveryInfoInCart */.$)(cart, (0,getStringifyAddress/* getStringifyAddress */.H)()) : {};
        triggerSetCart((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cart, cartWithDeliveryInfo), {
            user_phone: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone,
            phone: userData === null || userData === void 0 ? void 0 : (ref2 = userData.data) === null || ref2 === void 0 ? void 0 : ref2.phone
        }));
    };
    var toggleAuthModal = function() {
        var phone = (0,localStorageFunctions/* getLeadData */.X5)();
        var phoneReg = /(6|7|8|9)\d{9}/;
        if ((allItems === null || allItems === void 0 ? void 0 : allItems.length) && phone && phone.length === 10 && phone.match(phoneReg)) {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    showAuthModel: !state.showAuthModel,
                    isPhoneNumber: true
                });
            });
        } else {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    showAuthModel: !state.showAuthModel
                });
            });
        }
    };
    var onDeliverHereBtnHandle = function() {
        var ref;
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.payment_method) === 0 && (0,getAuthToken/* getAuthToken */.b)() && !orderConfirmLoaderToggle) {
            setOrderConfirmLoaderToggle(!orderConfirmLoaderToggle);
        } else {
            addAddressDetailsAndPlaceOrder();
        }
    };
    var submitCart = function() {
        var type = getOrderTypeTextForCart(cart.order_type);
        var isFormValid = true;
        var atleastOneProductPresent = false;
        var errorMessage = "Please create your product list";
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("deliveryType", type);
        allItems === null || allItems === void 0 ? void 0 : allItems.map(function(el) {
            if (el.item_name && el.quantity === "") {
                isFormValid = false;
                errorMessage = "Please enter the product quantity.";
            } else if (el.quantity === 0) {
                isFormValid = false;
                errorMessage = "Please enter the product quantity greater than 0.";
            }
            if (el.item_name) {
                atleastOneProductPresent = true;
            }
            return;
        });
        if (isFormValid && atleastOneProductPresent) {
            var ref;
            if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.delivery_flag) === DELIVERY_UNAVILABLE_FLAG && type === CART_ORDER_TYPE_TEXT.DELIVERY) {
                (0,Toast/* toastNotifyError */.Lu)("Sorry! Delivery not available currently.");
                return;
            }
            if (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("auth_token")) {
                if (type === CART_ORDER_TYPE_TEXT.PICKUP || type === CART_ORDER_TYPE_TEXT.SERVICE) {
                    dispatch((0,order/* placeOrder */.s1)(cart, router));
                } else {
                    dispatch((0,actions_cart/* saveCart */.FP)((0,_object_spread/* default */.Z)({}, cart)));
                    onDeliverHereBtnHandle();
                }
            } else {
                dispatch((0,actions_cart/* saveCart */.FP)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cart), {
                    items: allItems,
                    instructions: state.orderInstructionText
                })));
                toggleAuthModal();
            }
        } else {
            (0,Toast/* toastNotifyError */.Lu)(errorMessage);
        }
    };
    var onCartPlaceOrderBtnHandle = function() {
        setOrderButtonClickCount(function(count) {
            return count + 1;
        });
        if ((0,canDisablePlaceOrder/* canDisablePlaceOrder */.w)()) {
            return;
        }
        if (!(cart === null || cart === void 0 ? void 0 : cart.store_id)) {
            cart.store_id = storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id;
        }
        (userData === null || userData === void 0 ? void 0 : userData.isLogin) ? dispatch((0,actions_cart/* validateCart */.ir)(cart, onCartValidationSuccess)) : toggleAuthModal();
    };
    var onCartValidationSuccess = function(validateCartData) {
        var ref;
        if (!(validateCartData === null || validateCartData === void 0 ? void 0 : (ref = validateCartData.message_list) === null || ref === void 0 ? void 0 : ref.length)) {
            var ref1, ref2, ref3, ref4, ref5, ref6;
            var type = getOrderTypeTextForCart(cart.order_type);
            if (type === CART_ORDER_TYPE_TEXT.DELIVERY && (userData === null || userData === void 0 ? void 0 : userData.isLogin) && !((ref1 = cart.delivery_info) === null || ref1 === void 0 ? void 0 : ref1.address1)) {
                setShowAddressError(true);
                return;
            }
            if (type === CART_ORDER_TYPE_TEXT.PICKUP && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.services) === null || ref2 === void 0 ? void 0 : ref2.pickup_flag) === PICKUP_UNAVILABLE_FLAG) {
                (0,Toast/* toastNotifyError */.Lu)("We do not accept Pickup orders currently");
                return;
            }
            if (type === CART_ORDER_TYPE_TEXT.DELIVERY && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.services) === null || ref3 === void 0 ? void 0 : ref3.delivery_flag) === 1 && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.services) === null || ref4 === void 0 ? void 0 : ref4.min_order_value) > 0 && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.services) === null || ref5 === void 0 ? void 0 : ref5.min_order_value) > cart.items_total) {
                var ref7;
                (0,Toast/* toastNotifyError */.Lu)("Shop for ₹".concat((storeInfo === null || storeInfo === void 0 ? void 0 : (ref7 = storeInfo.services) === null || ref7 === void 0 ? void 0 : ref7.min_order_value) - cart.items_total, " more for home delivery"));
                return;
            }
            if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref6 = storeInfo.services) === null || ref6 === void 0 ? void 0 : ref6.payment_method) === 0 && (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("auth_token")) && cart.order_type === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP) {
                setOrderConfirmLoaderToggle(!orderConfirmLoaderToggle);
            } else submitCart();
        }
    };
    var showValidationError = function() {
        (userData === null || userData === void 0 ? void 0 : userData.isLogin) ? dispatch((0,error/* setCartValidationErrorMsgModalVisibility */.sn)(true)) : toggleAuthModal();
    };
    var contextValue = {
        allItems: allItems,
        userData: userData,
        storeInfo: storeInfo,
        showAuthModal: toggleAuthModal,
        isLogin: !!(userData === null || userData === void 0 ? void 0 : userData.isLogin),
        showAddressError: showAddressError,
        setShowAddressError: setShowAddressError,
        deletionAlertState: deletionAlertState,
        setDeletionAlertState: setDeletionAlertState,
        onCartPlaceOrderBtnHandle: onCartPlaceOrderBtnHandle
    };
    var isEmptyCart = !(allItems === null || allItems === void 0 ? void 0 : allItems.length) && isComponentMounted;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartContext/* CartContext.Provider */.A.Provider, {
            value: contextValue,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartPage, {
                height: height,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_PageHeader, {
                        isEmptyCart: isEmptyCart
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_ModifiedCartNotificationBar, {
                        cartValidationData: cartValidationData,
                        showValidationError: showValidationError
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartBody, {
                        children: isEmptyCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_EmptyCartView, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                checkClientDeviceType/* IS_MOBILE */.q$ && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartSummery, {
                                    summeryClasses: "tw-text-[16px] tw-font-semibold",
                                    showDropdown: true,
                                    showOrderSummary: showSummeryMobile,
                                    handleOrderSummary: function() {
                                        return setShowSummeryMobile(!showSummeryMobile);
                                    },
                                    referenceToCheckScrollHeight: null,
                                    allItems: allItems
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartAdditionalInfo, {
                                    allItems: allItems
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_CartItemsAndCheckout, {
                                    allItems: allItems
                                })
                            ]
                        })
                    }),
                    state.showAuthModel && /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthPopUp["default"], {
                        toggleModal: toggleAuthModal,
                        submitCart: submitCart,
                        isVisible: state.showAuthModel,
                        redirection: false,
                        isPhoneNumber: state.isPhoneNumber,
                        handleOnCloseButton: handleCloseButton,
                        isFromCart: true
                    }),
                    orderConfirmLoaderToggle && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderConfirmLoader/* default */.Z, {
                        orderType: cart.order_type,
                        isVisible: orderConfirmLoaderToggle,
                        toggleModal: function() {
                            if (cart.order_type) setOrderConfirmLoaderToggle(!orderConfirmLoaderToggle);
                        },
                        closeModal: function() {
                            return setOrderConfirmLoaderToggle(!orderConfirmLoaderToggle);
                        },
                        submitAction: submitCart,
                        deliveryType: cart.order_type
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_CartValidationErrorMsgModal, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NotAcceptingOrderPopUp, {}),
                    deviceWidth/* deviceWidth */.o > 990 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopPaymentModal/* default */.ZP, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentModal/* default */.Z, {}),
                    (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.personalizationPopUp) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCustomizationPopUp/* ProductCustomizationPopUp */.X, {}),
                    deletionAlertState.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CartItemDeletionAlert, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuntityUnavailableAlert/* default */.Z, {})
                ]
            }, "cartPagePremium")
        })
    });
};
/* harmony default export */ var Cart = (PreCartPage);


/***/ }),

/***/ 630876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_DeliveryList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/auth.js
var auth = __webpack_require__(368060);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var cart = __webpack_require__(666162);
// EXTERNAL MODULE: ./src/utils/addDeliveryInfoInCart.js
var addDeliveryInfoInCart = __webpack_require__(668068);
// EXTERNAL MODULE: ./src/utils/isDeliveryPincodeBased.js
var isDeliveryPincodeBased = __webpack_require__(984110);
// EXTERNAL MODULE: ./src/utils/getStringifyAddress.js
var getStringifyAddress = __webpack_require__(97978);
;// CONCATENATED MODULE: ./src/utils/setUserSavedAddress.js



/**
 * utility function to check for saved address of logged in user
 * @param {*} userAddress
 * @return {*} Object
 */ var setUserSavedAddress = function(userAddress) {
    if (userAddress && Object.keys(userAddress).length) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
        var ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, userAddress), {
            user_name: (ref12 = (ref11 = userAddress === null || userAddress === void 0 ? void 0 : (ref = userAddress.user_name) === null || ref === void 0 ? void 0 : ref.text) !== null && ref11 !== void 0 ? ref11 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.user_name) !== null && ref12 !== void 0 ? ref12 : "",
            landmark: (ref14 = (ref13 = userAddress === null || userAddress === void 0 ? void 0 : (ref1 = userAddress.landmark) === null || ref1 === void 0 ? void 0 : ref1.text) !== null && ref13 !== void 0 ? ref13 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.landmark) !== null && ref14 !== void 0 ? ref14 : "",
            pincode: (ref16 = (ref15 = userAddress === null || userAddress === void 0 ? void 0 : (ref2 = userAddress.pincode) === null || ref2 === void 0 ? void 0 : ref2.text) !== null && ref15 !== void 0 ? ref15 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.pincode) !== null && ref16 !== void 0 ? ref16 : "",
            city: (ref18 = (ref17 = userAddress === null || userAddress === void 0 ? void 0 : (ref3 = userAddress.city) === null || ref3 === void 0 ? void 0 : ref3.text) !== null && ref17 !== void 0 ? ref17 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.city) !== null && ref18 !== void 0 ? ref18 : "",
            state: (ref20 = (ref19 = userAddress === null || userAddress === void 0 ? void 0 : (ref4 = userAddress.state) === null || ref4 === void 0 ? void 0 : ref4.text) !== null && ref19 !== void 0 ? ref19 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.state) !== null && ref20 !== void 0 ? ref20 : "",
            country: (ref22 = (ref21 = userAddress === null || userAddress === void 0 ? void 0 : (ref5 = userAddress.country) === null || ref5 === void 0 ? void 0 : ref5.text) !== null && ref21 !== void 0 ? ref21 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.country) !== null && ref22 !== void 0 ? ref22 : "",
            address1: (ref24 = (ref23 = userAddress === null || userAddress === void 0 ? void 0 : (ref6 = userAddress.address1) === null || ref6 === void 0 ? void 0 : ref6.text) !== null && ref23 !== void 0 ? ref23 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.address1) !== null && ref24 !== void 0 ? ref24 : "",
            address2: (ref26 = (ref25 = userAddress === null || userAddress === void 0 ? void 0 : (ref7 = userAddress.address2) === null || ref7 === void 0 ? void 0 : ref7.text) !== null && ref25 !== void 0 ? ref25 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.address2) !== null && ref26 !== void 0 ? ref26 : "",
            address_id: userAddress === null || userAddress === void 0 ? void 0 : userAddress.address_id,
            latitude: (ref27 = userAddress === null || userAddress === void 0 ? void 0 : userAddress.latitude) !== null && ref27 !== void 0 ? ref27 : 0,
            longitude: (ref28 = userAddress === null || userAddress === void 0 ? void 0 : userAddress.longitude) !== null && ref28 !== void 0 ? ref28 : 0,
            alternate_phone: (ref30 = (ref29 = userAddress === null || userAddress === void 0 ? void 0 : (ref8 = userAddress.alternate_phone) === null || ref8 === void 0 ? void 0 : ref8.text) !== null && ref29 !== void 0 ? ref29 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.alternate_phone) !== null && ref30 !== void 0 ? ref30 : "",
            gst_number: (ref32 = (ref31 = userAddress === null || userAddress === void 0 ? void 0 : (ref9 = userAddress.gst_number) === null || ref9 === void 0 ? void 0 : ref9.text) !== null && ref31 !== void 0 ? ref31 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.gst_number) !== null && ref32 !== void 0 ? ref32 : "",
            email_id: (ref34 = (ref33 = userAddress === null || userAddress === void 0 ? void 0 : (ref10 = userAddress.email_id) === null || ref10 === void 0 ? void 0 : ref10.text) !== null && ref33 !== void 0 ? ref33 : userAddress === null || userAddress === void 0 ? void 0 : userAddress.email_id) !== null && ref34 !== void 0 ? ref34 : "",
            custom_field_data_list: (0,getStringifyAddress/* getCustomFieldPayload */.C)(userAddress === null || userAddress === void 0 ? void 0 : userAddress.custom_field_data_list),
            missing_fields: (ref35 = userAddress === null || userAddress === void 0 ? void 0 : userAddress.missing_fields) !== null && ref35 !== void 0 ? ref35 : []
        });
    }
    return {};
};

// EXTERNAL MODULE: ./src/redux/store/index.js + 44 modules
var store = __webpack_require__(167261);
;// CONCATENATED MODULE: ./src/utils/getAddressByServiceabilityUnserviceabilty.js

/**
 * object containing unservicble , servicable and pincode required addresses
 * @returns {object} Properties -> Servicable, unservicable , pincode , Address Id's
 */ function getAddressByServiceabilityUnserviceabilty() {
    var ref;
    var pincode_required = [];
    var serviceable_address_ids = [];
    var unserviceable_address_ids = [];
    var addressData = store/* default.getState */.Z.getState().deliveryReducer.addressData;
    var userData = store/* default.getState */.Z.getState().userReducer;
    for(var i = 0; i < (userData === null || userData === void 0 ? void 0 : (ref = userData.addressList) === null || ref === void 0 ? void 0 : ref.length); i++){
        var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        if (addressData === null || addressData === void 0 ? void 0 : (ref1 = addressData.pincode_required) === null || ref1 === void 0 ? void 0 : ref1.includes(userData === null || userData === void 0 ? void 0 : (ref2 = userData.addressList) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[i]) === null || ref3 === void 0 ? void 0 : ref3.address_id)) {
            var ref10;
            pincode_required.push(userData === null || userData === void 0 ? void 0 : (ref10 = userData.addressList) === null || ref10 === void 0 ? void 0 : ref10[i]);
        } else if (addressData === null || addressData === void 0 ? void 0 : (ref4 = addressData.serviceable_address_ids) === null || ref4 === void 0 ? void 0 : ref4.includes(userData === null || userData === void 0 ? void 0 : (ref5 = userData.addressList) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[i]) === null || ref6 === void 0 ? void 0 : ref6.address_id)) {
            var ref11;
            serviceable_address_ids.push(userData === null || userData === void 0 ? void 0 : (ref11 = userData.addressList) === null || ref11 === void 0 ? void 0 : ref11[i]);
        } else if (addressData === null || addressData === void 0 ? void 0 : (ref7 = addressData.unserviceable_address_ids) === null || ref7 === void 0 ? void 0 : ref7.includes(userData === null || userData === void 0 ? void 0 : (ref8 = userData.addressList) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[i]) === null || ref9 === void 0 ? void 0 : ref9.address_id)) {
            var ref12;
            unserviceable_address_ids.push(userData === null || userData === void 0 ? void 0 : (ref12 = userData.addressList) === null || ref12 === void 0 ? void 0 : ref12[i]);
        }
    }
    return {
        pincode_required: pincode_required,
        serviceable_address_ids: serviceable_address_ids,
        unserviceable_address_ids: unserviceable_address_ids
    };
}

// EXTERNAL MODULE: ./src/utils/triggerGetItemDeliveryChages.js + 1 modules
var triggerGetItemDeliveryChages = __webpack_require__(508527);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/containers/DeliveryList/DeliveryList.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  color: #6c6c6c;\n  letter-spacing: 0.9px;\n  @media screen and (max-width: 767px) {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ListHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ListHeading",
    componentId: "sc-82c72e6e-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/components/UserAddressCard/index.tsx + 3 modules
var UserAddressCard = __webpack_require__(925269);
// EXTERNAL MODULE: ./src/components/BasicModal/index.tsx
var BasicModal = __webpack_require__(475868);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/index.js + 2 modules
var AtomicComponents = __webpack_require__(438855);
;// CONCATENATED MODULE: ./src/containers/DeliveryList/index.js
/**
 * Delivery Address List page
 */ 
















var ADDRESS_TYPE = {
    SERVICABLE: "SERVICABLE ADDRESSES",
    UNSERVICABLE: "NON-SERVICABLE ADDRESSES",
    PINCODE_REQUIRED: "PINCODE REQUIRED",
    SAVED_ADDRESS: "SAVED ADDRESSES"
};
var DeliveryList = function(props) {
    var renderAddressDetails = function renderAddressDetails(addressDetails, addressType) {
        var isUnserviceable = addressType === ADDRESS_TYPE.UNSERVICABLE;
        var isIncomplete = addressType === ADDRESS_TYPE.PINCODE_REQUIRED;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (isUnserviceable ? "o-40" : "") + " tw-mb-[4px] tw-flex tw-flex-col tw-gap-[16px]",
            children: (userData === null || userData === void 0 ? void 0 : userData.savedAddress) && (addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.map(function(item, index) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAddressCard/* default */.Z, {
                    onEditClick: !isUnserviceable ? function() {
                        return onEditClick((item === null || item === void 0 ? void 0 : item.address_id) || 0);
                    } : null,
                    onDeliverClick: !isUnserviceable && !isIncomplete ? function() {
                        return setAddressValue(item, addressType);
                    } : null,
                    isIncomplete: isIncomplete,
                    isUnserviceable: isUnserviceable,
                    userName: item === null || item === void 0 ? void 0 : (ref = item.user_name) === null || ref === void 0 ? void 0 : ref.text,
                    addressType: item === null || item === void 0 ? void 0 : item.address_type,
                    addressName: item === null || item === void 0 ? void 0 : item.address_name,
                    alternatePhone: item === null || item === void 0 ? void 0 : (ref1 = item.alternate_phone) === null || ref1 === void 0 ? void 0 : ref1.text,
                    address1: item === null || item === void 0 ? void 0 : (ref2 = item.address1) === null || ref2 === void 0 ? void 0 : ref2.text,
                    address2: item === null || item === void 0 ? void 0 : (ref3 = item.address2) === null || ref3 === void 0 ? void 0 : ref3.text,
                    city: item === null || item === void 0 ? void 0 : (ref4 = item.city) === null || ref4 === void 0 ? void 0 : ref4.text,
                    state: item === null || item === void 0 ? void 0 : (ref5 = item.state) === null || ref5 === void 0 ? void 0 : ref5.text,
                    pincode: item === null || item === void 0 ? void 0 : (ref6 = item.pincode) === null || ref6 === void 0 ? void 0 : ref6.text,
                    customClasses: "md:!tw-border-solid md:!tw-px-[24px] md:!tw-py-[14px] md:!tw-rounded"
                }, index);
            }))
        });
    };
    var renderListHeading = function renderListHeading(headingText) {
        var ref, ref1, ref2;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-mb-[12px] tw-flex tw-flex-col-reverse tw-justify-between tw-gap-[20px] md:tw-flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListHeading, {
                    children: headingText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                    textTransform: "capitalize",
                    roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : ref.roundness,
                    className: "!tw-w-full tw-py-[15px] !tw-text-sm !tw-font-semibold md:!tw-w-fit md:!tw-border-none md:tw-p-0",
                    label: "Add New Address",
                    fontColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color,
                    variant: "outline",
                    onClick: onAddNewAddressBtnHandle
                })
            ]
        });
    };
    var pincodeBasedDeliveryList = function pincodeBasedDeliveryList() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (serviceable_address_ids === null || serviceable_address_ids === void 0 ? void 0 : serviceable_address_ids.length) > 0 && renderListHeading(ADDRESS_TYPE.SERVICABLE),
                renderAddressDetails(serviceable_address_ids, ADDRESS_TYPE.SERVICABLE),
                renderAddressDetails(pincode_required, ADDRESS_TYPE.PINCODE_REQUIRED),
                renderAddressDetails(unserviceable_address_ids, ADDRESS_TYPE.UNSERVICABLE)
            ]
        });
    };
    var userAddressList = function userAddressList() {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col",
            children: [
                (userData === null || userData === void 0 ? void 0 : (ref = userData.addressList) === null || ref === void 0 ? void 0 : ref.length) > 0 && renderListHeading(ADDRESS_TYPE.SAVED_ADDRESS),
                renderAddressDetails(userData === null || userData === void 0 ? void 0 : userData.addressList, ADDRESS_TYPE.SAVED_ADDRESS)
            ]
        });
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeInfo = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var userData = (0,es/* useSelector */.v9)(function(state) {
        return state.userReducer;
    });
    var cartData = (0,es/* useSelector */.v9)(function(state) {
        return state.cartReducer;
    });
    var ref = getAddressByServiceabilityUnserviceabilty(), serviceable_address_ids = ref.serviceable_address_ids, pincode_required = ref.pincode_required, unserviceable_address_ids = ref.unserviceable_address_ids;
    (0,react.useEffect)(function() {
        if (props.isVisible) {
            dispatch((0,auth/* saveSelectedAddress */.z)({}));
        }
    }, []);
    var setAddressValue = function(selectedAddFromUsersAddList, addressType) {
        var ref;
        if (addressType === ADDRESS_TYPE.UNSERVICABLE) {
            return;
        }
        if ((selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : selectedAddFromUsersAddList.missing_fields[0]) && ((ref = selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : selectedAddFromUsersAddList.missing_fields[0]) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            dispatch((0,auth/* saveSelectedAddress */.z)(setUserSavedAddress(selectedAddFromUsersAddList)));
            props.setEditId(selectedAddFromUsersAddList.address_id);
            props.toggleAddDeliveryForm(true);
            props.toggleModal();
        } else {
            var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
            dispatch((0,auth/* saveSelectedAddress */.z)(setUserSavedAddress(selectedAddFromUsersAddList)));
            var cartPayload = (0,addDeliveryInfoInCart/* addDeliveryInfoInCart */.$)(cartData, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedAddFromUsersAddList), {
                user_name: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref1 = selectedAddFromUsersAddList.user_name) === null || ref1 === void 0 ? void 0 : ref1.text) || "",
                landmark: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref2 = selectedAddFromUsersAddList.landmark) === null || ref2 === void 0 ? void 0 : ref2.text) || "",
                pincode: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref3 = selectedAddFromUsersAddList.pincode) === null || ref3 === void 0 ? void 0 : ref3.text) || "",
                city: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref4 = selectedAddFromUsersAddList.city) === null || ref4 === void 0 ? void 0 : ref4.text) || "",
                state: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref5 = selectedAddFromUsersAddList.state) === null || ref5 === void 0 ? void 0 : ref5.text) || "",
                country: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref6 = selectedAddFromUsersAddList.country) === null || ref6 === void 0 ? void 0 : ref6.text) || "",
                address1: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref7 = selectedAddFromUsersAddList.address1) === null || ref7 === void 0 ? void 0 : ref7.text) || "",
                address2: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref8 = selectedAddFromUsersAddList.address2) === null || ref8 === void 0 ? void 0 : ref8.text) || "",
                address_id: selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : selectedAddFromUsersAddList.address_id,
                latitude: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : selectedAddFromUsersAddList.latitude) || 0,
                longitude: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : selectedAddFromUsersAddList.longitude) || 0,
                alternate_phone: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref9 = selectedAddFromUsersAddList.alternate_phone) === null || ref9 === void 0 ? void 0 : ref9.text) || "",
                email_id: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref10 = selectedAddFromUsersAddList.email_id) === null || ref10 === void 0 ? void 0 : ref10.text) || "",
                age: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref11 = selectedAddFromUsersAddList.age) === null || ref11 === void 0 ? void 0 : ref11.text) || "",
                gender: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref12 = selectedAddFromUsersAddList.gender) === null || ref12 === void 0 ? void 0 : ref12.text) || "",
                gst_number: (selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : (ref13 = selectedAddFromUsersAddList.gst_number) === null || ref13 === void 0 ? void 0 : ref13.text) || "",
                custom_field_data_list: (0,getStringifyAddress/* getCustomFieldPayload */.C)(selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : selectedAddFromUsersAddList.custom_field_data_list) || []
            }));
            dispatch((0,cart/* setCart */.RV)(cartPayload));
            if ((0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)()) (0,triggerGetItemDeliveryChages/* triggerGetItemDeliveryCharges */.l)();
            props.toggleModal();
            props.toggleAddDeliveryForm(false);
        }
    };
    var openAddressAdditionForm = function() {
        props.toggleAddDeliveryForm(true);
        props.toggleModal();
    };
    var onAddNewAddressBtnHandle = function() {
        openAddressAdditionForm();
        props.setEditId(0);
    };
    var onEditClick = function(id) {
        openAddressAdditionForm();
        props.setEditId(id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicModal/* default */.Z, {
        show: props.isVisible,
        onClose: props.toggleModal,
        heading: "Select Delivery Address",
        showCloseIcon: true,
        customClasses: "!tw-max-h-[80%] md:!tw-max-h-[60%] !tw-font-inter",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex justify-center tw-flex-col tw-gap-[16px] tw-px-[16px] tw-py-[20px] md:tw-px-[24px] md:tw-py-[16px]",
            children: (0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)() ? pincodeBasedDeliveryList() : userAddressList()
        })
    });
};
/* harmony default export */ var containers_DeliveryList = (DeliveryList);


/***/ }),

/***/ 443742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useCreateOrder; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(225617);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(666162);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(804160);
/* harmony import */ var src_utils_addDeliveryInfoInCart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(668068);
/* harmony import */ var src_utils_getStringifyAddress__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97978);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);






function useCreateOrder() {
    var addAddressDetailsAndPlaceOrder = function addAddressDetailsAndPlaceOrder() {
        var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        var orderData = (0,src_utils_addDeliveryInfoInCart__WEBPACK_IMPORTED_MODULE_1__/* .addDeliveryInfoInCart */ .$)(cart, (0,src_utils_getStringifyAddress__WEBPACK_IMPORTED_MODULE_2__/* .getStringifyAddress */ .H)());
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .setCart */ .RV)(orderData, function() {
            dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_5__/* .placeOrder */ .s1)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, orderData), (next_router__WEBPACK_IMPORTED_MODULE_3___default()), callback));
        }));
    };
    var cart = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return {
            cart: state.cartReducer
        };
    }).cart;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    return {
        addAddressDetailsAndPlaceOrder: addAddressDetailsAndPlaceOrder
    };
}


/***/ }),

/***/ 930077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSetCart; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(225617);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(666162);
/* harmony import */ var _utils_getCurrentOrderType__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(648071);
/* harmony import */ var _utils_getStringifyAddress__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97978);







function useSetCart() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var storeId = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return state.storeReducer.store.store_id;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), cart = ref[0], triggerSetCart = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timerId = setTimeout(setCustomerCart, 300);
        return function() {
            return clearTimeout(timerId);
        };
    }, [
        cart
    ]);
    var setCustomerCart = function() {
        if (Object.keys(cart).length) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .setCart */ .RV)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, cart), {
                order_type: (0,_utils_getCurrentOrderType__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentOrderType */ .h)(cart.order_type),
                store_id: storeId,
                user_phone: cart.phone,
                cart_id: cart.cart_id,
                delivery_info: (0,_utils_getStringifyAddress__WEBPACK_IMPORTED_MODULE_3__/* .getStringifyAddress */ .H)()
            })));
        }
    };
    return {
        triggerSetCart: triggerSetCart
    };
}


/***/ }),

/***/ 510203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getPaymentMethodUsedByCustomer; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(913886);

var getPaymentMethodUsedByCustomer = function(paymentFlag) {
    if (paymentFlag === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_PAYMENT_TYPE.POSTPAID */ .EY.POSTPAID) return "cod";
    if (paymentFlag === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_PAYMENT_TYPE.PREPAID */ .EY.PREPAID) return "prepaid";
    return "both";
};


/***/ })

}]);